/**
 * Auto-generated by IconRegistryGenerator
 * DO NOT EDIT THIS FILE MANUALLY.
 */
import type { ComponentType, SVGProps } from 'react';
import iconLazy from '../lazy';
import { IconCategoryId } from '../types';

const AddTable = iconLazy(
  () =>
    import(
      /* webpackChunkName: "ua-icons-AddTable" */ '../../components/outline/AddTable'
    ),
);
const AgenticAiAgents = iconLazy(
  () =>
    import(
      /* webpackChunkName: "ua-icons-AgenticAiAgents" */ '../../components/outline/AgenticAiAgents'
    ),
);
const AgenticAiApps = iconLazy(
  () =>
    import(
      /* webpackChunkName: "ua-icons-AgenticAiApps" */ '../../components/outline/AgenticAiApps'
    ),
);
const AgenticAiChat = iconLazy(
  () =>
    import(
      /* webpackChunkName: "ua-icons-AgenticAiChat" */ '../../components/outline/AgenticAiChat'
    ),
);
const AgenticAiChatSolid = iconLazy(
  () =>
    import(
      /* webpackChunkName: "ua-icons-AgenticAiChatSolid" */ '../../components/solid/AgenticAiChatSolid'
    ),
);
const AgenticAiPeople = iconLazy(
  () =>
    import(
      /* webpackChunkName: "ua-icons-AgenticAiPeople" */ '../../components/outline/AgenticAiPeople'
    ),
);
const AgenticAiSearch = iconLazy(
  () =>
    import(
      /* webpackChunkName: "ua-icons-AgenticAiSearch" */ '../../components/outline/AgenticAiSearch'
    ),
);
const AgenticAiSearchSolid = iconLazy(
  () =>
    import(
      /* webpackChunkName: "ua-icons-AgenticAiSearchSolid" */ '../../components/solid/AgenticAiSearchSolid'
    ),
);
const AiAgentSolid = iconLazy(
  () =>
    import(
      /* webpackChunkName: "ua-icons-AiAgentSolid" */ '../../components/solid/AiAgentSolid'
    ),
);
const AiDataPipelines = iconLazy(
  () =>
    import(
      /* webpackChunkName: "ua-icons-AiDataPipelines" */ '../../components/outline/AiDataPipelines'
    ),
);
const AiEditor = iconLazy(
  () =>
    import(
      /* webpackChunkName: "ua-icons-AiEditor" */ '../../components/outline/AiEditor'
    ),
);
const AiEditorSolid = iconLazy(
  () =>
    import(
      /* webpackChunkName: "ua-icons-AiEditorSolid" */ '../../components/solid/AiEditorSolid'
    ),
);
const AiEnrichment = iconLazy(
  () =>
    import(
      /* webpackChunkName: "ua-icons-AiEnrichment" */ '../../components/outline/AiEnrichment'
    ),
);
const AiGenerateDoc = iconLazy(
  () =>
    import(
      /* webpackChunkName: "ua-icons-AiGenerateDoc" */ '../../components/outline/AiGenerateDoc'
    ),
);
const AiGenerateDocOff = iconLazy(
  () =>
    import(
      /* webpackChunkName: "ua-icons-AiGenerateDocOff" */ '../../components/outline/AiGenerateDocOff'
    ),
);
const AiGenerateText = iconLazy(
  () =>
    import(
      /* webpackChunkName: "ua-icons-AiGenerateText" */ '../../components/outline/AiGenerateText'
    ),
);
const AiStar = iconLazy(
  () =>
    import(
      /* webpackChunkName: "ua-icons-AiStar" */ '../../components/solid/AiStar'
    ),
);
const AISummary = iconLazy(
  () =>
    import(
      /* webpackChunkName: "ua-icons-AISummary" */ '../../components/outline/AiSummary'
    ),
);
const AiZapFast = iconLazy(
  () =>
    import(
      /* webpackChunkName: "ua-icons-AiZapFast" */ '../../components/outline/AiZapFast'
    ),
);
const AlertCircle = iconLazy(
  () =>
    import(
      /* webpackChunkName: "ua-icons-AlertCircle" */ '../../components/outline/AlertCircle'
    ),
);
const AlertTriangle = iconLazy(
  () =>
    import(
      /* webpackChunkName: "ua-icons-AlertTriangle" */ '../../components/outline/AlertTriangle'
    ),
);
const AlertTrianlgeSolid = iconLazy(
  () =>
    import(
      /* webpackChunkName: "ua-icons-AlertTrianlgeSolid" */ '../../components/solid/AlertTriangle'
    ),
);
const AlignLeft = iconLazy(
  () =>
    import(
      /* webpackChunkName: "ua-icons-AlignLeft" */ '../../components/outline/AlignLeft'
    ),
);
const Announcement03 = iconLazy(
  () =>
    import(
      /* webpackChunkName: "ua-icons-Announcement03" */ '../../components/outline/Announcement03'
    ),
);
const Archive = iconLazy(
  () =>
    import(
      /* webpackChunkName: "ua-icons-Archive" */ '../../components/outline/Archive'
    ),
);
const ArrowCircleBrokenDownRight = iconLazy(
  () =>
    import(
      /* webpackChunkName: "ua-icons-ArrowCircleBrokenDownRight" */ '../../components/outline/ArrowCircleBrokenDownRight'
    ),
);
const ArrowCircleBrokenRight = iconLazy(
  () =>
    import(
      /* webpackChunkName: "ua-icons-ArrowCircleBrokenRight" */ '../../components/outline/ArrowCircleBrokenRight'
    ),
);
const ArrowCircleBrokenUpRight = iconLazy(
  () =>
    import(
      /* webpackChunkName: "ua-icons-ArrowCircleBrokenUpRight" */ '../../components/outline/ArrowCircleBrokenUpRight'
    ),
);
const ArrowCircleRight = iconLazy(
  () =>
    import(
      /* webpackChunkName: "ua-icons-ArrowCircleRight" */ '../../components/outline/ArrowCircleRight'
    ),
);
const ArrowCircleUpLeft = iconLazy(
  () =>
    import(
      /* webpackChunkName: "ua-icons-ArrowCircleUpLeft" */ '../../components/outline/ArrowCircleUpLeft'
    ),
);
const ArrowDown = iconLazy(
  () =>
    import(
      /* webpackChunkName: "ua-icons-ArrowDown" */ '../../components/outline/ArrowDown'
    ),
);
const ArrowDownToLine = iconLazy(
  () =>
    import(
      /* webpackChunkName: "ua-icons-ArrowDownToLine" */ '../../components/outline/ArrowDownToLine'
    ),
);
const ArrowLeft = iconLazy(
  () =>
    import(
      /* webpackChunkName: "ua-icons-ArrowLeft" */ '../../components/outline/ArrowNarrowLeft'
    ),
);
const ArrowLeftToLine = iconLazy(
  () =>
    import(
      /* webpackChunkName: "ua-icons-ArrowLeftToLine" */ '../../components/outline/ArrowLeftToLine'
    ),
);
const ArrowNarrowDown = iconLazy(
  () =>
    import(
      /* webpackChunkName: "ua-icons-ArrowNarrowDown" */ '../../components/outline/ArrowNarrowDown'
    ),
);
const ArrowNarrowLeft = iconLazy(
  () =>
    import(
      /* webpackChunkName: "ua-icons-ArrowNarrowLeft" */ '../../components/outline/ArrowLeft'
    ),
);
const ArrowNarrowRight = iconLazy(
  () =>
    import(
      /* webpackChunkName: "ua-icons-ArrowNarrowRight" */ '../../components/outline/ArrowNarrowRight'
    ),
);
const ArrowRight = iconLazy(
  () =>
    import(
      /* webpackChunkName: "ua-icons-ArrowRight" */ '../../components/outline/ArrowNarrowRight'
    ),
);
const ArrowRightToLine = iconLazy(
  () =>
    import(
      /* webpackChunkName: "ua-icons-ArrowRightToLine" */ '../../components/outline/ArrowRightToLine'
    ),
);
const ArrowsDown = iconLazy(
  () =>
    import(
      /* webpackChunkName: "ua-icons-ArrowsDown" */ '../../components/outline/ArrowsDown'
    ),
);
const ArrowsLeft = iconLazy(
  () =>
    import(
      /* webpackChunkName: "ua-icons-ArrowsLeft" */ '../../components/outline/ArrowsLeft'
    ),
);
const ArrowSquareUpRight = iconLazy(
  () =>
    import(
      /* webpackChunkName: "ua-icons-ArrowSquareUpRight" */ '../../components/outline/ArrowSquareUpRight'
    ),
);
const ArrowsRight = iconLazy(
  () =>
    import(
      /* webpackChunkName: "ua-icons-ArrowsRight" */ '../../components/outline/ArrowsRight'
    ),
);
const ArrowsUp = iconLazy(
  () =>
    import(
      /* webpackChunkName: "ua-icons-ArrowsUp" */ '../../components/outline/ArrowsUp'
    ),
);
const ArrowUp = iconLazy(
  () =>
    import(
      /* webpackChunkName: "ua-icons-ArrowUp" */ '../../components/outline/ArrowUp'
    ),
);
const ArrowUpToLine = iconLazy(
  () =>
    import(
      /* webpackChunkName: "ua-icons-ArrowUpToLine" */ '../../components/outline/ArrowUpToLine'
    ),
);
const Atom02 = iconLazy(
  () =>
    import(
      /* webpackChunkName: "ua-icons-Atom02" */ '../../components/outline/Atom02'
    ),
);
const AtSign = iconLazy(
  () =>
    import(
      /* webpackChunkName: "ua-icons-AtSign" */ '../../components/outline/AtSign'
    ),
);
const AxisStatusBacklog = iconLazy(
  () =>
    import(
      /* webpackChunkName: "ua-icons-AxisStatusBacklog" */ '../../components/colored/AxisStatusBacklog'
    ),
);
const AxisStatusCanceled = iconLazy(
  () =>
    import(
      /* webpackChunkName: "ua-icons-AxisStatusCanceled" */ '../../components/colored/AxisStatusCanceled'
    ),
);
const AxisStatusCompleted = iconLazy(
  () =>
    import(
      /* webpackChunkName: "ua-icons-AxisStatusCompleted" */ '../../components/colored/AxisStatusCompleted'
    ),
);
const AxisStatusInProgress = iconLazy(
  () =>
    import(
      /* webpackChunkName: "ua-icons-AxisStatusInProgress" */ '../../components/colored/AxisStatusInProgress'
    ),
);
const AxisStatusInReview = iconLazy(
  () =>
    import(
      /* webpackChunkName: "ua-icons-AxisStatusInReview" */ '../../components/colored/AxisStatusInReview'
    ),
);
const AxisStatusPlanned = iconLazy(
  () =>
    import(
      /* webpackChunkName: "ua-icons-AxisStatusPlanned" */ '../../components/colored/AxisStatusPlanned'
    ),
);
const AxisStatusStarted = iconLazy(
  () =>
    import(
      /* webpackChunkName: "ua-icons-AxisStatusStarted" */ '../../components/colored/AxisStatusStarted'
    ),
);
const AxisStatusStarted100 = iconLazy(
  () =>
    import(
      /* webpackChunkName: "ua-icons-AxisStatusStarted100" */ '../../components/colored/AxisStatusStarted100'
    ),
);
const AxisStatusStarted25 = iconLazy(
  () =>
    import(
      /* webpackChunkName: "ua-icons-AxisStatusStarted25" */ '../../components/colored/AxisStatusStarted25'
    ),
);
const AxisStatusUnstarted = iconLazy(
  () =>
    import(
      /* webpackChunkName: "ua-icons-AxisStatusUnstarted" */ '../../components/colored/AxisStatusUnstarted'
    ),
);
const BarChart10 = iconLazy(
  () =>
    import(
      /* webpackChunkName: "ua-icons-BarChart10" */ '../../components/outline/BarChart10'
    ),
);
const BarChartSquare01 = iconLazy(
  () =>
    import(
      /* webpackChunkName: "ua-icons-BarChartSquare01" */ '../../components/outline/BarChartSquare01'
    ),
);
const BellNotification = iconLazy(
  () =>
    import(
      /* webpackChunkName: "ua-icons-BellNotification" */ '../../components/outline/BellNotification'
    ),
);
const Bloomberg = iconLazy(
  () =>
    import(
      /* webpackChunkName: "ua-icons-Bloomberg" */ '../../components/colored/Bloomberg'
    ),
);
const BracketsCheck = iconLazy(
  () =>
    import(
      /* webpackChunkName: "ua-icons-BracketsCheck" */ '../../components/outline/BracketsCheck'
    ),
);
const BracketsEllipses = iconLazy(
  () =>
    import(
      /* webpackChunkName: "ua-icons-BracketsEllipses" */ '../../components/outline/BracketsEllipses'
    ),
);
const BracketsSquare = iconLazy(
  () =>
    import(
      /* webpackChunkName: "ua-icons-BracketsSquare" */ '../../components/outline/BracketsSquare'
    ),
);
const BriefCase02 = iconLazy(
  () =>
    import(
      /* webpackChunkName: "ua-icons-BriefCase02" */ '../../components/outline/Briefcase02'
    ),
);
const BubbleChart = iconLazy(
  () =>
    import(
      /* webpackChunkName: "ua-icons-BubbleChart" */ '../../components/outline/BubbleChart'
    ),
);
const Bug = iconLazy(
  () =>
    import(
      /* webpackChunkName: "ua-icons-Bug" */ '../../components/outline/Bug'
    ),
);
const Calendar = iconLazy(
  () =>
    import(
      /* webpackChunkName: "ua-icons-Calendar" */ '../../components/outline/Calendar'
    ),
);
const CalendarDate02 = iconLazy(
  () =>
    import(
      /* webpackChunkName: "ua-icons-CalendarDate02" */ '../../components/outline/CalendarDate02'
    ),
);
const CalendarMonthView = iconLazy(
  () =>
    import(
      /* webpackChunkName: "ua-icons-CalendarMonthView" */ '../../components/outline/CalendarMonthView'
    ),
);
const CalendarSingleDayView = iconLazy(
  () =>
    import(
      /* webpackChunkName: "ua-icons-CalendarSingleDayView" */ '../../components/outline/CalendarSingleDayView'
    ),
);
const CalendarSolid = iconLazy(
  () =>
    import(
      /* webpackChunkName: "ua-icons-CalendarSolid" */ '../../components/solid/CalendarSolid'
    ),
);
const CalendarTwoDayView = iconLazy(
  () =>
    import(
      /* webpackChunkName: "ua-icons-CalendarTwoDayView" */ '../../components/outline/CalendarTwoDayView'
    ),
);
const Chat = iconLazy(
  () =>
    import(
      /* webpackChunkName: "ua-icons-Chat" */ '../../components/outline/Chat'
    ),
);
const ChatRoundLine = iconLazy(
  () =>
    import(
      /* webpackChunkName: "ua-icons-ChatRoundLine" */ '../../components/outline/ChatRoundLine'
    ),
);
const CheckCircleBroken = iconLazy(
  () =>
    import(
      /* webpackChunkName: "ua-icons-CheckCircleBroken" */ '../../components/outline/CheckCircleBroken'
    ),
);
const CheckHeart = iconLazy(
  () =>
    import(
      /* webpackChunkName: "ua-icons-CheckHeart" */ '../../components/outline/CheckHeart'
    ),
);
const CheckSquare = iconLazy(
  () =>
    import(
      /* webpackChunkName: "ua-icons-CheckSquare" */ '../../components/outline/CheckSquare'
    ),
);
const ChevronDown = iconLazy(
  () =>
    import(
      /* webpackChunkName: "ua-icons-ChevronDown" */ '../../components/outline/ChevronDown'
    ),
);
const ChevronDownDouble = iconLazy(
  () =>
    import(
      /* webpackChunkName: "ua-icons-ChevronDownDouble" */ '../../components/outline/ChevronDownDouble'
    ),
);
const ChevronDownSm = iconLazy(
  () =>
    import(
      /* webpackChunkName: "ua-icons-ChevronDownSm" */ '../../components/outline/ChevronDownSm'
    ),
);
const ChevronLeft = iconLazy(
  () =>
    import(
      /* webpackChunkName: "ua-icons-ChevronLeft" */ '../../components/outline/ChevronLeft'
    ),
);
const ChevronLeftDouble = iconLazy(
  () =>
    import(
      /* webpackChunkName: "ua-icons-ChevronLeftDouble" */ '../../components/outline/ChevronLeftDouble'
    ),
);
const ChevronRight = iconLazy(
  () =>
    import(
      /* webpackChunkName: "ua-icons-ChevronRight" */ '../../components/outline/ChevronRight'
    ),
);
const ChevronRightDouble = iconLazy(
  () =>
    import(
      /* webpackChunkName: "ua-icons-ChevronRightDouble" */ '../../components/outline/ChevronRightDouble'
    ),
);
const ChevronSelectorVertical = iconLazy(
  () =>
    import(
      /* webpackChunkName: "ua-icons-ChevronSelectorVertical" */ '../../components/outline/ChevronSelectorVertical'
    ),
);
const ChevronUp = iconLazy(
  () =>
    import(
      /* webpackChunkName: "ua-icons-ChevronUp" */ '../../components/outline/ChevronUp'
    ),
);
const ChevronUpDouble = iconLazy(
  () =>
    import(
      /* webpackChunkName: "ua-icons-ChevronUpDouble" */ '../../components/outline/ChevronUpDouble'
    ),
);
const Clock = iconLazy(
  () =>
    import(
      /* webpackChunkName: "ua-icons-Clock" */ '../../components/outline/Clock'
    ),
);
const ClockFastForward = iconLazy(
  () =>
    import(
      /* webpackChunkName: "ua-icons-ClockFastForward" */ '../../components/outline/ClockFastForward'
    ),
);
const ClockRefresh = iconLazy(
  () =>
    import(
      /* webpackChunkName: "ua-icons-ClockRefresh" */ '../../components/outline/ClockRefresh'
    ),
);
const ClockStopwatch = iconLazy(
  () =>
    import(
      /* webpackChunkName: "ua-icons-ClockStopwatch" */ '../../components/outline/ClockStopwatch'
    ),
);
const Code01 = iconLazy(
  () =>
    import(
      /* webpackChunkName: "ua-icons-Code01" */ '../../components/outline/Code01'
    ),
);
const Code02 = iconLazy(
  () =>
    import(
      /* webpackChunkName: "ua-icons-Code02" */ '../../components/outline/Code02'
    ),
);
const Codepen = iconLazy(
  () =>
    import(
      /* webpackChunkName: "ua-icons-Codepen" */ '../../components/outline/Codepen'
    ),
);
const CodeSnippet02 = iconLazy(
  () =>
    import(
      /* webpackChunkName: "ua-icons-CodeSnippet02" */ '../../components/outline/CodeSnippet02'
    ),
);
const Coins03 = iconLazy(
  () =>
    import(
      /* webpackChunkName: "ua-icons-Coins03" */ '../../components/outline/Coins03'
    ),
);
const CoinsStacked04 = iconLazy(
  () =>
    import(
      /* webpackChunkName: "ua-icons-CoinsStacked04" */ '../../components/outline/CoinsStacked04'
    ),
);
const CollapseAll = iconLazy(
  () =>
    import(
      /* webpackChunkName: "ua-icons-CollapseAll" */ '../../components/outline/CollapseAll'
    ),
);
const ColoredMoon = iconLazy(
  () =>
    import(
      /* webpackChunkName: "ua-icons-ColoredMoon" */ '../../components/colored/Moon'
    ),
);
const ColoredSun = iconLazy(
  () =>
    import(
      /* webpackChunkName: "ua-icons-ColoredSun" */ '../../components/colored/Sun'
    ),
);
const Command = iconLazy(
  () =>
    import(
      /* webpackChunkName: "ua-icons-Command" */ '../../components/outline/Command'
    ),
);
const Container = iconLazy(
  () =>
    import(
      /* webpackChunkName: "ua-icons-Container" */ '../../components/outline/Container'
    ),
);
const ControlWalkthrough = iconLazy(
  () =>
    import(
      /* webpackChunkName: "ua-icons-ControlWalkthrough" */ '../../components/outline/ControlWalkthrough'
    ),
);
const Copy01 = iconLazy(
  () =>
    import(
      /* webpackChunkName: "ua-icons-Copy01" */ '../../components/outline/Copy01'
    ),
);
const Cross = iconLazy(
  () =>
    import(
      /* webpackChunkName: "ua-icons-Cross" */ '../../components/outline/X'
    ),
);
const Csv = iconLazy(
  () =>
    import(
      /* webpackChunkName: "ua-icons-Csv" */ '../../components/colored/Csv'
    ),
);
const Cube02 = iconLazy(
  () =>
    import(
      /* webpackChunkName: "ua-icons-Cube02" */ '../../components/outline/Cube02'
    ),
);
const CursorBox = iconLazy(
  () =>
    import(
      /* webpackChunkName: "ua-icons-CursorBox" */ '../../components/outline/CursorBox'
    ),
);
const CursorInteractive = iconLazy(
  () =>
    import(
      /* webpackChunkName: "ua-icons-CursorInteractive" */ '../../components/outline/CursorInteractive'
    ),
);
const CustomConnector01 = iconLazy(
  () =>
    import(
      /* webpackChunkName: "ua-icons-CustomConnector01" */ '../../components/outline/CustomConnector01'
    ),
);
const Dash2 = iconLazy(
  () =>
    import(
      /* webpackChunkName: "ua-icons-Dash2" */ '../../components/outline/Dash2'
    ),
);
const Database01 = iconLazy(
  () =>
    import(
      /* webpackChunkName: "ua-icons-Database01" */ '../../components/outline/Database01'
    ),
);
const Database01Filled = iconLazy(
  () =>
    import(
      /* webpackChunkName: "ua-icons-Database01Filled" */ '../../components/outline/Database01Filled'
    ),
);
const Dataflow02 = iconLazy(
  () =>
    import(
      /* webpackChunkName: "ua-icons-Dataflow02" */ '../../components/outline/Dataflow02'
    ),
);
const Dataflow04 = iconLazy(
  () =>
    import(
      /* webpackChunkName: "ua-icons-Dataflow04" */ '../../components/outline/Dataflow04'
    ),
);
const DataTypeArray = iconLazy(
  () =>
    import(
      /* webpackChunkName: "ua-icons-DataTypeArray" */ '../../components/outline/data-types/DataTypeArray'
    ),
);
const DataTypeArrayZero = iconLazy(
  () =>
    import(
      /* webpackChunkName: "ua-icons-DataTypeArrayZero" */ '../../components/outline/data-types/DataTypeArrayZero'
    ),
);
const DataTypeBinary = iconLazy(
  () =>
    import(
      /* webpackChunkName: "ua-icons-DataTypeBinary" */ '../../components/outline/data-types/DataTypeBinary'
    ),
);
const DataTypeBoolean = iconLazy(
  () =>
    import(
      /* webpackChunkName: "ua-icons-DataTypeBoolean" */ '../../components/outline/data-types/DataTypeBoolean'
    ),
);
const DataTypeDate = iconLazy(
  () =>
    import(
      /* webpackChunkName: "ua-icons-DataTypeDate" */ '../../components/outline/data-types/DataTypeDate'
    ),
);
const DataTypeDatetime = iconLazy(
  () =>
    import(
      /* webpackChunkName: "ua-icons-DataTypeDatetime" */ '../../components/outline/data-types/DataTypeDatetime'
    ),
);
const DataTypeDecimal = iconLazy(
  () =>
    import(
      /* webpackChunkName: "ua-icons-DataTypeDecimal" */ '../../components/outline/data-types/DataTypeDecimal'
    ),
);
const DataTypeDouble = iconLazy(
  () =>
    import(
      /* webpackChunkName: "ua-icons-DataTypeDouble" */ '../../components/outline/data-types/DataTypeDouble'
    ),
);
const DataTypeInteger = iconLazy(
  () =>
    import(
      /* webpackChunkName: "ua-icons-DataTypeInteger" */ '../../components/outline/data-types/DataTypeInteger'
    ),
);
const DataTypeObject = iconLazy(
  () =>
    import(
      /* webpackChunkName: "ua-icons-DataTypeObject" */ '../../components/outline/data-types/DataTypeObject'
    ),
);
const DataTypeText = iconLazy(
  () =>
    import(
      /* webpackChunkName: "ua-icons-DataTypeText" */ '../../components/outline/data-types/DataTypeText'
    ),
);
const DataTypeTime = iconLazy(
  () =>
    import(
      /* webpackChunkName: "ua-icons-DataTypeTime" */ '../../components/outline/data-types/DataTypeTime'
    ),
);
const DataTypeTimestamp = iconLazy(
  () =>
    import(
      /* webpackChunkName: "ua-icons-DataTypeTimestamp" */ '../../components/outline/data-types/DataTypeTimestamp'
    ),
);
const Debugger = iconLazy(
  () =>
    import(
      /* webpackChunkName: "ua-icons-Debugger" */ '../../components/outline/Debugger'
    ),
);
const Decimal = iconLazy(
  () =>
    import(
      /* webpackChunkName: "ua-icons-Decimal" */ '../../components/outline/Decimal'
    ),
);
const Doc = iconLazy(
  () =>
    import(
      /* webpackChunkName: "ua-icons-Doc" */ '../../components/colored/Doc'
    ),
);
const Docx = iconLazy(
  () =>
    import(
      /* webpackChunkName: "ua-icons-Docx" */ '../../components/colored/Docx'
    ),
);
const DotsGrid = iconLazy(
  () =>
    import(
      /* webpackChunkName: "ua-icons-DotsGrid" */ '../../components/outline/DotsGrid'
    ),
);
const DotsHorizontal = iconLazy(
  () =>
    import(
      /* webpackChunkName: "ua-icons-DotsHorizontal" */ '../../components/outline/DotsHorizontal'
    ),
);
const DotsVertical = iconLazy(
  () =>
    import(
      /* webpackChunkName: "ua-icons-DotsVertical" */ '../../components/outline/DotsVertical'
    ),
);
const Double = iconLazy(
  () =>
    import(
      /* webpackChunkName: "ua-icons-Double" */ '../../components/outline/data-types/DataTypeDouble'
    ),
);
const DualAxesLineChartUp01 = iconLazy(
  () =>
    import(
      /* webpackChunkName: "ua-icons-DualAxesLineChartUp01" */ '../../components/outline/DualAxesLineChartUp01'
    ),
);
const Edit01 = iconLazy(
  () =>
    import(
      /* webpackChunkName: "ua-icons-Edit01" */ '../../components/outline/Edit01'
    ),
);
const Edit05 = iconLazy(
  () =>
    import(
      /* webpackChunkName: "ua-icons-Edit05" */ '../../components/outline/Edit05'
    ),
);
const Epubs = iconLazy(
  () =>
    import(
      /* webpackChunkName: "ua-icons-Epubs" */ '../../components/colored/Epubs'
    ),
);
const ErrorOutline = iconLazy(
  () =>
    import(
      /* webpackChunkName: "ua-icons-ErrorOutline" */ '../../components/outline/ErrorOutline'
    ),
);
const EventPayload = iconLazy(
  () =>
    import(
      /* webpackChunkName: "ua-icons-EventPayload" */ '../../components/outline/EventPayload'
    ),
);
const Expand06 = iconLazy(
  () =>
    import(
      /* webpackChunkName: "ua-icons-Expand06" */ '../../components/outline/Expand06'
    ),
);
const ExpandAll = iconLazy(
  () =>
    import(
      /* webpackChunkName: "ua-icons-ExpandAll" */ '../../components/outline/ExpandAll'
    ),
);
const ExtractData02 = iconLazy(
  () =>
    import(
      /* webpackChunkName: "ua-icons-ExtractData02" */ '../../components/outline/ExtractData02'
    ),
);
const Facebook = iconLazy(
  () =>
    import(
      /* webpackChunkName: "ua-icons-Facebook" */ '../../components/colored/Facebook'
    ),
);
const FaceSmile = iconLazy(
  () =>
    import(
      /* webpackChunkName: "ua-icons-FaceSmile" */ '../../components/outline/FaceSmile'
    ),
);
const File02 = iconLazy(
  () =>
    import(
      /* webpackChunkName: "ua-icons-File02" */ '../../components/outline/File02'
    ),
);
const File05 = iconLazy(
  () =>
    import(
      /* webpackChunkName: "ua-icons-File05" */ '../../components/outline/File05'
    ),
);
const File05Filled = iconLazy(
  () =>
    import(
      /* webpackChunkName: "ua-icons-File05Filled" */ '../../components/solid/File05Filled'
    ),
);
const FileCheck02 = iconLazy(
  () =>
    import(
      /* webpackChunkName: "ua-icons-FileCheck02" */ '../../components/outline/FileCheck02'
    ),
);
const FileCode01 = iconLazy(
  () =>
    import(
      /* webpackChunkName: "ua-icons-FileCode01" */ '../../components/outline/FileCode01'
    ),
);
const FileDownload03 = iconLazy(
  () =>
    import(
      /* webpackChunkName: "ua-icons-FileDownload03" */ '../../components/outline/FileDownload03'
    ),
);
const FilePlus02 = iconLazy(
  () =>
    import(
      /* webpackChunkName: "ua-icons-FilePlus02" */ '../../components/outline/FilePlus02'
    ),
);
const FileQuestion02 = iconLazy(
  () =>
    import(
      /* webpackChunkName: "ua-icons-FileQuestion02" */ '../../components/outline/FileQuestion02'
    ),
);
const FileSearch02 = iconLazy(
  () =>
    import(
      /* webpackChunkName: "ua-icons-FileSearch02" */ '../../components/outline/FileSearch02'
    ),
);
const FileShield02 = iconLazy(
  () =>
    import(
      /* webpackChunkName: "ua-icons-FileShield02" */ '../../components/outline/FileShield02'
    ),
);
const FileX02 = iconLazy(
  () =>
    import(
      /* webpackChunkName: "ua-icons-FileX02" */ '../../components/outline/FileX02'
    ),
);
const FileX03 = iconLazy(
  () =>
    import(
      /* webpackChunkName: "ua-icons-FileX03" */ '../../components/outline/FileX03'
    ),
);
const FilterLines = iconLazy(
  () =>
    import(
      /* webpackChunkName: "ua-icons-FilterLines" */ '../../components/outline/FilterLines'
    ),
);
const FilterLines02 = iconLazy(
  () =>
    import(
      /* webpackChunkName: "ua-icons-FilterLines02" */ '../../components/outline/FilterLines02'
    ),
);
const Fold = iconLazy(
  () =>
    import(
      /* webpackChunkName: "ua-icons-Fold" */ '../../components/outline/Fold'
    ),
);
const FolderColored = iconLazy(
  () =>
    import(
      /* webpackChunkName: "ua-icons-FolderColored" */ '../../components/colored/Folder'
    ),
);
const Gauge = iconLazy(
  () =>
    import(
      /* webpackChunkName: "ua-icons-Gauge" */ '../../components/outline/Gauge'
    ),
);
const GenAiApps = iconLazy(
  () =>
    import(
      /* webpackChunkName: "ua-icons-GenAiApps" */ '../../components/outline/GenAiApps'
    ),
);
const GitBranch01 = iconLazy(
  () =>
    import(
      /* webpackChunkName: "ua-icons-GitBranch01" */ '../../components/outline/GitBranch01'
    ),
);
const Github = iconLazy(
  () =>
    import(
      /* webpackChunkName: "ua-icons-Github" */ '../../components/outline/Github'
    ),
);
const Gitlab = iconLazy(
  () =>
    import(
      /* webpackChunkName: "ua-icons-Gitlab" */ '../../components/outline/Gitlab'
    ),
);
const Globe01 = iconLazy(
  () =>
    import(
      /* webpackChunkName: "ua-icons-Globe01" */ '../../components/outline/Globe01'
    ),
);
const GoogleMaps = iconLazy(
  () =>
    import(
      /* webpackChunkName: "ua-icons-GoogleMaps" */ '../../components/colored/GoogleMaps'
    ),
);
const Governance = iconLazy(
  () =>
    import(
      /* webpackChunkName: "ua-icons-Governance" */ '../../components/outline/Governance'
    ),
);
const GridDotsBottom = iconLazy(
  () =>
    import(
      /* webpackChunkName: "ua-icons-GridDotsBottom" */ '../../components/outline/GridDotsBottom'
    ),
);
const GridDotsLeft = iconLazy(
  () =>
    import(
      /* webpackChunkName: "ua-icons-GridDotsLeft" */ '../../components/outline/GridDotsLeft'
    ),
);
const GridDotsOuter = iconLazy(
  () =>
    import(
      /* webpackChunkName: "ua-icons-GridDotsOuter" */ '../../components/outline/GridDotsOuter'
    ),
);
const GridDotsRight = iconLazy(
  () =>
    import(
      /* webpackChunkName: "ua-icons-GridDotsRight" */ '../../components/outline/GridDotsRight'
    ),
);
const GridDotsTop = iconLazy(
  () =>
    import(
      /* webpackChunkName: "ua-icons-GridDotsTop" */ '../../components/outline/GridDotsTop'
    ),
);
const Hash01 = iconLazy(
  () =>
    import(
      /* webpackChunkName: "ua-icons-Hash01" */ '../../components/outline/Hash01'
    ),
);
const Headphones01 = iconLazy(
  () =>
    import(
      /* webpackChunkName: "ua-icons-Headphones01" */ '../../components/outline/Headphones01'
    ),
);
const HealthMeter = iconLazy(
  () =>
    import(
      /* webpackChunkName: "ua-icons-HealthMeter" */ '../../components/outline/HealthMeter'
    ),
);
const Heart = iconLazy(
  () =>
    import(
      /* webpackChunkName: "ua-icons-Heart" */ '../../components/outline/Heart'
    ),
);
const HeartFilled = iconLazy(
  () =>
    import(
      /* webpackChunkName: "ua-icons-HeartFilled" */ '../../components/solid/HeartFilled'
    ),
);
const HelpCircle = iconLazy(
  () =>
    import(
      /* webpackChunkName: "ua-icons-HelpCircle" */ '../../components/outline/HelpCircle'
    ),
);
const Home01 = iconLazy(
  () =>
    import(
      /* webpackChunkName: "ua-icons-Home01" */ '../../components/outline/Home01'
    ),
);
const Home02 = iconLazy(
  () =>
    import(
      /* webpackChunkName: "ua-icons-Home02" */ '../../components/outline/Home02'
    ),
);
const Home03 = iconLazy(
  () =>
    import(
      /* webpackChunkName: "ua-icons-Home03" */ '../../components/outline/Home03'
    ),
);
const Home04 = iconLazy(
  () =>
    import(
      /* webpackChunkName: "ua-icons-Home04" */ '../../components/outline/Home04'
    ),
);
const Home05 = iconLazy(
  () =>
    import(
      /* webpackChunkName: "ua-icons-Home05" */ '../../components/outline/Home05'
    ),
);
const HomeLine = iconLazy(
  () =>
    import(
      /* webpackChunkName: "ua-icons-HomeLine" */ '../../components/outline/HomeLine'
    ),
);
const HomeSmile = iconLazy(
  () =>
    import(
      /* webpackChunkName: "ua-icons-HomeSmile" */ '../../components/outline/HomeSmile'
    ),
);
const HomeWhite = iconLazy(
  () =>
    import(
      /* webpackChunkName: "ua-icons-HomeWhite" */ '../../components/outline/HomeWhite'
    ),
);
const HorizontalBarChart02 = iconLazy(
  () =>
    import(
      /* webpackChunkName: "ua-icons-HorizontalBarChart02" */ '../../components/outline/HorizontalBarChart02'
    ),
);
const Hourglass01 = iconLazy(
  () =>
    import(
      /* webpackChunkName: "ua-icons-Hourglass01" */ '../../components/outline/Hourglass01'
    ),
);
const Image01 = iconLazy(
  () =>
    import(
      /* webpackChunkName: "ua-icons-Image01" */ '../../components/outline/Image01'
    ),
);
const InfoCircle = iconLazy(
  () =>
    import(
      /* webpackChunkName: "ua-icons-InfoCircle" */ '../../components/outline/InfoCircle'
    ),
);
const Integer = iconLazy(
  () =>
    import(
      /* webpackChunkName: "ua-icons-Integer" */ '../../components/outline/Integer'
    ),
);
const IntersectCircle = iconLazy(
  () =>
    import(
      /* webpackChunkName: "ua-icons-IntersectCircle" */ '../../components/outline/IntersectCircle'
    ),
);
const Json = iconLazy(
  () =>
    import(
      /* webpackChunkName: "ua-icons-Json" */ '../../components/outline/JsonLanguage'
    ),
);
const Laptop02 = iconLazy(
  () =>
    import(
      /* webpackChunkName: "ua-icons-Laptop02" */ '../../components/outline/Laptop02'
    ),
);
const LayersThree01 = iconLazy(
  () =>
    import(
      /* webpackChunkName: "ua-icons-LayersThree01" */ '../../components/outline/LayersThree01'
    ),
);
const LayersThree02 = iconLazy(
  () =>
    import(
      /* webpackChunkName: "ua-icons-LayersThree02" */ '../../components/outline/LayersThree02'
    ),
);
const LayersTwo01 = iconLazy(
  () =>
    import(
      /* webpackChunkName: "ua-icons-LayersTwo01" */ '../../components/outline/LayersTwo01'
    ),
);
const LayoutAlt01 = iconLazy(
  () =>
    import(
      /* webpackChunkName: "ua-icons-LayoutAlt01" */ '../../components/outline/LayoutAlt01'
    ),
);
const LayoutAlt04 = iconLazy(
  () =>
    import(
      /* webpackChunkName: "ua-icons-LayoutAlt04" */ '../../components/outline/LayoutAlt04'
    ),
);
const LayoutBottom = iconLazy(
  () =>
    import(
      /* webpackChunkName: "ua-icons-LayoutBottom" */ '../../components/outline/LayoutBottom'
    ),
);
const LayoutLeft = iconLazy(
  () =>
    import(
      /* webpackChunkName: "ua-icons-LayoutLeft" */ '../../components/outline/LayoutLeft'
    ),
);
const LayoutRight = iconLazy(
  () =>
    import(
      /* webpackChunkName: "ua-icons-LayoutRight" */ '../../components/outline/LayoutRight'
    ),
);
const LayoutTop = iconLazy(
  () =>
    import(
      /* webpackChunkName: "ua-icons-LayoutTop" */ '../../components/outline/LayoutTop'
    ),
);
const LcBarChart = iconLazy(
  () =>
    import(
      /* webpackChunkName: "ua-icons-LcBarChart" */ '../../components/outline/LcBarChart'
    ),
);
const LcFileUpload = iconLazy(
  () =>
    import(
      /* webpackChunkName: "ua-icons-LcFileUpload" */ '../../components/outline/LcFileUpload'
    ),
);
const LcForm = iconLazy(
  () =>
    import(
      /* webpackChunkName: "ua-icons-LcForm" */ '../../components/outline/LcForm'
    ),
);
const LcSectionColumn = iconLazy(
  () =>
    import(
      /* webpackChunkName: "ua-icons-LcSectionColumn" */ '../../components/outline/LcSectionColumn'
    ),
);
const LcStatus = iconLazy(
  () =>
    import(
      /* webpackChunkName: "ua-icons-LcStatus" */ '../../components/outline/LcStatus'
    ),
);
const Lightbulb02 = iconLazy(
  () =>
    import(
      /* webpackChunkName: "ua-icons-Lightbulb02" */ '../../components/outline/Lightbulb02'
    ),
);
const LineChartUp01 = iconLazy(
  () =>
    import(
      /* webpackChunkName: "ua-icons-LineChartUp01" */ '../../components/outline/LineChartUp01'
    ),
);
const LineLineChart = iconLazy(
  () =>
    import(
      /* webpackChunkName: "ua-icons-LineLineChart" */ '../../components/outline/LineLineChart'
    ),
);
const Link01 = iconLazy(
  () =>
    import(
      /* webpackChunkName: "ua-icons-Link01" */ '../../components/outline/Link01'
    ),
);
const LinkBroken01 = iconLazy(
  () =>
    import(
      /* webpackChunkName: "ua-icons-LinkBroken01" */ '../../components/outline/LinkBroken01'
    ),
);
const Linkedin = iconLazy(
  () =>
    import(
      /* webpackChunkName: "ua-icons-Linkedin" */ '../../components/colored/Linkedin'
    ),
);
const LinkExternal01 = iconLazy(
  () =>
    import(
      /* webpackChunkName: "ua-icons-LinkExternal01" */ '../../components/outline/LinkExternal01'
    ),
);
const List = iconLazy(
  () =>
    import(
      /* webpackChunkName: "ua-icons-List" */ '../../components/outline/List'
    ),
);
const ListSolid = iconLazy(
  () =>
    import(
      /* webpackChunkName: "ua-icons-ListSolid" */ '../../components/solid/ListSolid'
    ),
);
const Lock03 = iconLazy(
  () =>
    import(
      /* webpackChunkName: "ua-icons-Lock03" */ '../../components/outline/Lock03'
    ),
);
const Lock04Filled = iconLazy(
  () =>
    import(
      /* webpackChunkName: "ua-icons-Lock04Filled" */ '../../components/solid/Lock04Filled'
    ),
);
const Logout01 = iconLazy(
  () =>
    import(
      /* webpackChunkName: "ua-icons-Logout01" */ '../../components/outline/LogOut01'
    ),
);
const Loop = iconLazy(
  () =>
    import(
      /* webpackChunkName: "ua-icons-Loop" */ '../../components/outline/Loop'
    ),
);
const Mail01 = iconLazy(
  () =>
    import(
      /* webpackChunkName: "ua-icons-Mail01" */ '../../components/outline/Mail01'
    ),
);
const Mark = iconLazy(
  () =>
    import(
      /* webpackChunkName: "ua-icons-Mark" */ '../../components/outline/Mark'
    ),
);
const Menu01 = iconLazy(
  () =>
    import(
      /* webpackChunkName: "ua-icons-Menu01" */ '../../components/outline/Menu01'
    ),
);
const Menu03 = iconLazy(
  () =>
    import(
      /* webpackChunkName: "ua-icons-Menu03" */ '../../components/outline/Menu03'
    ),
);
const MessageAlertSquare = iconLazy(
  () =>
    import(
      /* webpackChunkName: "ua-icons-MessageAlertSquare" */ '../../components/outline/MessageAlertSquare'
    ),
);
const MessagePlusSquare = iconLazy(
  () =>
    import(
      /* webpackChunkName: "ua-icons-MessagePlusSquare" */ '../../components/outline/MessagePlusSquare'
    ),
);
const MessageQuestionSquare = iconLazy(
  () =>
    import(
      /* webpackChunkName: "ua-icons-MessageQuestionSquare" */ '../../components/outline/MessageQuestionSquare'
    ),
);
const MessageSmileSquare = iconLazy(
  () =>
    import(
      /* webpackChunkName: "ua-icons-MessageSmileSquare" */ '../../components/outline/MessageSmileSquare'
    ),
);
const MessageSmileSquareSolid = iconLazy(
  () =>
    import(
      /* webpackChunkName: "ua-icons-MessageSmileSquareSolid" */ '../../components/solid/MessageSmileSquareSolid'
    ),
);
const MessageTextSquare02 = iconLazy(
  () =>
    import(
      /* webpackChunkName: "ua-icons-MessageTextSquare02" */ '../../components/outline/MessageTextSquare02'
    ),
);
const Microphone01 = iconLazy(
  () =>
    import(
      /* webpackChunkName: "ua-icons-Microphone01" */ '../../components/outline/Microphone01'
    ),
);
const MicrophoneOff01 = iconLazy(
  () =>
    import(
      /* webpackChunkName: "ua-icons-MicrophoneOff01" */ '../../components/outline/MicrophoneOff01'
    ),
);
const Minimize02 = iconLazy(
  () =>
    import(
      /* webpackChunkName: "ua-icons-Minimize02" */ '../../components/outline/Minimize02'
    ),
);
const Minus = iconLazy(
  () =>
    import(
      /* webpackChunkName: "ua-icons-Minus" */ '../../components/outline/Minus'
    ),
);
const Mode = iconLazy(
  () =>
    import(
      /* webpackChunkName: "ua-icons-Mode" */ '../../components/outline/Mode'
    ),
);
const Monitor01 = iconLazy(
  () =>
    import(
      /* webpackChunkName: "ua-icons-Monitor01" */ '../../components/outline/Monitor01'
    ),
);
const MonitorOff01 = iconLazy(
  () =>
    import(
      /* webpackChunkName: "ua-icons-MonitorOff01" */ '../../components/outline/MonitorOff01'
    ),
);
const Move = iconLazy(
  () =>
    import(
      /* webpackChunkName: "ua-icons-Move" */ '../../components/outline/Move'
    ),
);
const MultiDevice = iconLazy(
  () =>
    import(
      /* webpackChunkName: "ua-icons-MultiDevice" */ '../../components/outline/MultiDevice'
    ),
);
const NetworkGraph = iconLazy(
  () =>
    import(
      /* webpackChunkName: "ua-icons-NetworkGraph" */ '../../components/outline/NetworkGraph'
    ),
);
const NoCodeAlert = iconLazy(
  () =>
    import(
      /* webpackChunkName: "ua-icons-NoCodeAlert" */ '../../components/outline/no-code/NoCodeAlert'
    ),
);
const NoCodeAudioPlayer = iconLazy(
  () =>
    import(
      /* webpackChunkName: "ua-icons-NoCodeAudioPlayer" */ '../../components/outline/no-code/NoCodeAudioPlayer'
    ),
);
const NoCodeAvatar = iconLazy(
  () =>
    import(
      /* webpackChunkName: "ua-icons-NoCodeAvatar" */ '../../components/outline/no-code/NoCodeAvatar'
    ),
);
const NoCodeAvatarGroup = iconLazy(
  () =>
    import(
      /* webpackChunkName: "ua-icons-NoCodeAvatarGroup" */ '../../components/outline/no-code/NoCodeAvatarGroup'
    ),
);
const NoCodeBarCode = iconLazy(
  () =>
    import(
      /* webpackChunkName: "ua-icons-NoCodeBarCode" */ '../../components/outline/no-code/NoCodeBarCode'
    ),
);
const NoCodeBottomsheet = iconLazy(
  () =>
    import(
      /* webpackChunkName: "ua-icons-NoCodeBottomsheet" */ '../../components/outline/no-code/NoCodeBottomsheet'
    ),
);
const NoCodeBusinessHour = iconLazy(
  () =>
    import(
      /* webpackChunkName: "ua-icons-NoCodeBusinessHour" */ '../../components/outline/no-code/NoCodeBusinessHour'
    ),
);
const NoCodeButton = iconLazy(
  () =>
    import(
      /* webpackChunkName: "ua-icons-NoCodeButton" */ '../../components/outline/no-code/NoCodeButton'
    ),
);
const NoCodeButtonGroup = iconLazy(
  () =>
    import(
      /* webpackChunkName: "ua-icons-NoCodeButtonGroup" */ '../../components/outline/no-code/NoCodeButtonGroup'
    ),
);
const NoCodeCalendar = iconLazy(
  () =>
    import(
      /* webpackChunkName: "ua-icons-NoCodeCalendar" */ '../../components/outline/no-code/NoCodeCalendar'
    ),
);
const NoCodeCamera = iconLazy(
  () =>
    import(
      /* webpackChunkName: "ua-icons-NoCodeCamera" */ '../../components/outline/no-code/NoCodeCamera'
    ),
);
const NoCodeCanvasEmptyState = iconLazy(
  () =>
    import(
      /* webpackChunkName: "ua-icons-NoCodeCanvasEmptyState" */ '../../components/colored/no-code/NoCodeCanvasEmptyState'
    ),
);
const NoCodeCard = iconLazy(
  () =>
    import(
      /* webpackChunkName: "ua-icons-NoCodeCard" */ '../../components/outline/no-code/NoCodeCard'
    ),
);
const NoCodeCarousel = iconLazy(
  () =>
    import(
      /* webpackChunkName: "ua-icons-NoCodeCarousel" */ '../../components/outline/no-code/NoCodeCarousel'
    ),
);
const NoCodeCategoryFilter = iconLazy(
  () =>
    import(
      /* webpackChunkName: "ua-icons-NoCodeCategoryFilter" */ '../../components/outline/no-code/NoCodeCategoryFilter'
    ),
);
const NoCodeChart = iconLazy(
  () =>
    import(
      /* webpackChunkName: "ua-icons-NoCodeChart" */ '../../components/outline/no-code/NoCodeChart'
    ),
);
const NoCodeCheckBox = iconLazy(
  () =>
    import(
      /* webpackChunkName: "ua-icons-NoCodeCheckBox" */ '../../components/outline/no-code/NoCodeCheckBox'
    ),
);
const NoCodeCodeEditor = iconLazy(
  () =>
    import(
      /* webpackChunkName: "ua-icons-NoCodeCodeEditor" */ '../../components/outline/no-code/NoCodeCodeEditor'
    ),
);
const NoCodeCollaboration = iconLazy(
  () =>
    import(
      /* webpackChunkName: "ua-icons-NoCodeCollaboration" */ '../../components/outline/no-code/NoCodeCollaboration'
    ),
);
const NoCodeColorAlert = iconLazy(
  () =>
    import(
      /* webpackChunkName: "ua-icons-NoCodeColorAlert" */ '../../components/colored/no-code/NoCodeColorAlert'
    ),
);
const NoCodeColorAudioPlayer = iconLazy(
  () =>
    import(
      /* webpackChunkName: "ua-icons-NoCodeColorAudioPlayer" */ '../../components/colored/no-code/NoCodeColorAudioPlayer'
    ),
);
const NoCodeColorAvatar = iconLazy(
  () =>
    import(
      /* webpackChunkName: "ua-icons-NoCodeColorAvatar" */ '../../components/colored/no-code/NoCodeColorAvatar'
    ),
);
const NoCodeColorAvatarGroup = iconLazy(
  () =>
    import(
      /* webpackChunkName: "ua-icons-NoCodeColorAvatarGroup" */ '../../components/colored/no-code/NoCodeColorAvatarGroup'
    ),
);
const NoCodeColorBarCode = iconLazy(
  () =>
    import(
      /* webpackChunkName: "ua-icons-NoCodeColorBarCode" */ '../../components/colored/no-code/NoCodeColorBarCode'
    ),
);
const NoCodeColorBottomsheet = iconLazy(
  () =>
    import(
      /* webpackChunkName: "ua-icons-NoCodeColorBottomsheet" */ '../../components/colored/no-code/NoCodeColorBottomsheet'
    ),
);
const NoCodeColorBusinessHour = iconLazy(
  () =>
    import(
      /* webpackChunkName: "ua-icons-NoCodeColorBusinessHour" */ '../../components/colored/no-code/NoCodeColorBusinessHour'
    ),
);
const NoCodeColorButton = iconLazy(
  () =>
    import(
      /* webpackChunkName: "ua-icons-NoCodeColorButton" */ '../../components/colored/no-code/NoCodeColorButton'
    ),
);
const NoCodeColorButtonGroup = iconLazy(
  () =>
    import(
      /* webpackChunkName: "ua-icons-NoCodeColorButtonGroup" */ '../../components/colored/no-code/NoCodeColorButtonGroup'
    ),
);
const NoCodeColorCalendar = iconLazy(
  () =>
    import(
      /* webpackChunkName: "ua-icons-NoCodeColorCalendar" */ '../../components/colored/no-code/NoCodeColorCalendar'
    ),
);
const NoCodeColorCamera = iconLazy(
  () =>
    import(
      /* webpackChunkName: "ua-icons-NoCodeColorCamera" */ '../../components/colored/no-code/NoCodeColorCamera'
    ),
);
const NoCodeColorCard = iconLazy(
  () =>
    import(
      /* webpackChunkName: "ua-icons-NoCodeColorCard" */ '../../components/colored/no-code/NoCodeColorCard'
    ),
);
const NoCodeColorCarousel = iconLazy(
  () =>
    import(
      /* webpackChunkName: "ua-icons-NoCodeColorCarousel" */ '../../components/colored/no-code/NoCodeColorCarousel'
    ),
);
const NoCodeColorCategoryFilter = iconLazy(
  () =>
    import(
      /* webpackChunkName: "ua-icons-NoCodeColorCategoryFilter" */ '../../components/colored/no-code/NoCodeColorCategoryFilter'
    ),
);
const NoCodeColorChart = iconLazy(
  () =>
    import(
      /* webpackChunkName: "ua-icons-NoCodeColorChart" */ '../../components/colored/no-code/NoCodeColorChart'
    ),
);
const NoCodeColorCodeEditor = iconLazy(
  () =>
    import(
      /* webpackChunkName: "ua-icons-NoCodeColorCodeEditor" */ '../../components/colored/no-code/NoCodeColorCodeEditor'
    ),
);
const NoCodeColorCollaboration = iconLazy(
  () =>
    import(
      /* webpackChunkName: "ua-icons-NoCodeColorCollaboration" */ '../../components/colored/no-code/NoCodeColorCollaboration'
    ),
);
const NoCodeColorComment = iconLazy(
  () =>
    import(
      /* webpackChunkName: "ua-icons-NoCodeColorComment" */ '../../components/colored/no-code/NoCodeColorComment'
    ),
);
const NoCodeColorContainer = iconLazy(
  () =>
    import(
      /* webpackChunkName: "ua-icons-NoCodeColorContainer" */ '../../components/colored/no-code/NoCodeColorContainer'
    ),
);
const NoCodeColorContextualDialog = iconLazy(
  () =>
    import(
      /* webpackChunkName: "ua-icons-NoCodeColorContextualDialog" */ '../../components/colored/no-code/NoCodeColorContextualDialog'
    ),
);
const NoCodeColorCopilot = iconLazy(
  () =>
    import(
      /* webpackChunkName: "ua-icons-NoCodeColorCopilot" */ '../../components/colored/no-code/NoCodeColorCopilot'
    ),
);
const NoCodeColorDatePicker = iconLazy(
  () =>
    import(
      /* webpackChunkName: "ua-icons-NoCodeColorDatePicker" */ '../../components/colored/no-code/NoCodeColorDatePicker'
    ),
);
const NoCodeColorDictation = iconLazy(
  () =>
    import(
      /* webpackChunkName: "ua-icons-NoCodeColorDictation" */ '../../components/colored/no-code/NoCodeColorDictation'
    ),
);
const NoCodeColorDivider = iconLazy(
  () =>
    import(
      /* webpackChunkName: "ua-icons-NoCodeColorDivider" */ '../../components/colored/no-code/NoCodeColorDivider'
    ),
);
const NoCodeColorDropdown = iconLazy(
  () =>
    import(
      /* webpackChunkName: "ua-icons-NoCodeColorDropdown" */ '../../components/colored/no-code/NoCodeColorDropdown'
    ),
);
const NoCodeColorEventsCalendar = iconLazy(
  () =>
    import(
      /* webpackChunkName: "ua-icons-NoCodeColorEventsCalendar" */ '../../components/colored/no-code/NoCodeColorEventsCalendar'
    ),
);
const NoCodeColorFileUpload = iconLazy(
  () =>
    import(
      /* webpackChunkName: "ua-icons-NoCodeColorFileUpload" */ '../../components/colored/no-code/NoCodeColorFileUpload'
    ),
);
const NoCodeColorFilters = iconLazy(
  () =>
    import(
      /* webpackChunkName: "ua-icons-NoCodeColorFilters" */ '../../components/colored/no-code/NoCodeColorFilters'
    ),
);
const NoCodeColorFlippable = iconLazy(
  () =>
    import(
      /* webpackChunkName: "ua-icons-NoCodeColorFlippable" */ '../../components/colored/no-code/NoCodeColorFlippable'
    ),
);
const NoCodeColorForm = iconLazy(
  () =>
    import(
      /* webpackChunkName: "ua-icons-NoCodeColorForm" */ '../../components/colored/no-code/NoCodeColorForm'
    ),
);
const NoCodeColorGrid = iconLazy(
  () =>
    import(
      /* webpackChunkName: "ua-icons-NoCodeColorGrid" */ '../../components/colored/no-code/NoCodeColorGrid'
    ),
);
const NoCodeColorIcon = iconLazy(
  () =>
    import(
      /* webpackChunkName: "ua-icons-NoCodeColorIcon" */ '../../components/colored/no-code/NoCodeColorIcon'
    ),
);
const NoCodeColorIconButton = iconLazy(
  () =>
    import(
      /* webpackChunkName: "ua-icons-NoCodeColorIconButton" */ '../../components/colored/no-code/NoCodeColorIconButton'
    ),
);
const NoCodeColorIframe = iconLazy(
  () =>
    import(
      /* webpackChunkName: "ua-icons-NoCodeColorIframe" */ '../../components/colored/no-code/NoCodeColorIframe'
    ),
);
const NoCodeColorImage = iconLazy(
  () =>
    import(
      /* webpackChunkName: "ua-icons-NoCodeColorImage" */ '../../components/colored/no-code/NoCodeColorImage'
    ),
);
const NoCodeColorInputDate = iconLazy(
  () =>
    import(
      /* webpackChunkName: "ua-icons-NoCodeColorInputDate" */ '../../components/colored/no-code/NoCodeColorInputDate'
    ),
);
const NoCodeColorInputDateTime = iconLazy(
  () =>
    import(
      /* webpackChunkName: "ua-icons-NoCodeColorInputDateTime" */ '../../components/colored/no-code/NoCodeColorInputDateTime'
    ),
);
const NoCodeColorInputTime = iconLazy(
  () =>
    import(
      /* webpackChunkName: "ua-icons-NoCodeColorInputTime" */ '../../components/colored/no-code/NoCodeColorInputTime'
    ),
);
const NoCodeColorKeyValue = iconLazy(
  () =>
    import(
      /* webpackChunkName: "ua-icons-NoCodeColorKeyValue" */ '../../components/colored/no-code/NoCodeColorKeyValue'
    ),
);
const NoCodeColorLink = iconLazy(
  () =>
    import(
      /* webpackChunkName: "ua-icons-NoCodeColorLink" */ '../../components/colored/no-code/NoCodeColorLink'
    ),
);
const NoCodeColorLoader = iconLazy(
  () =>
    import(
      /* webpackChunkName: "ua-icons-NoCodeColorLoader" */ '../../components/colored/no-code/NoCodeColorLoader'
    ),
);
const NoCodeColorMedia = iconLazy(
  () =>
    import(
      /* webpackChunkName: "ua-icons-NoCodeColorMedia" */ '../../components/colored/no-code/NoCodeColorMedia'
    ),
);
const NoCodeColorMenu = iconLazy(
  () =>
    import(
      /* webpackChunkName: "ua-icons-NoCodeColorMenu" */ '../../components/colored/no-code/NoCodeColorMenu'
    ),
);
const NoCodeColorMessageInput = iconLazy(
  () =>
    import(
      /* webpackChunkName: "ua-icons-NoCodeColorMessageInput" */ '../../components/colored/no-code/NoCodeColorMessageInput'
    ),
);
const NoCodeColorModal = iconLazy(
  () =>
    import(
      /* webpackChunkName: "ua-icons-NoCodeColorModal" */ '../../components/colored/no-code/NoCodeColorModal'
    ),
);
const NoCodeColorMultiStatCard = iconLazy(
  () =>
    import(
      /* webpackChunkName: "ua-icons-NoCodeColorMultiStatCard" */ '../../components/colored/no-code/NoCodeColorMultiStatCard'
    ),
);
const NoCodeColorNavigation = iconLazy(
  () =>
    import(
      /* webpackChunkName: "ua-icons-NoCodeColorNavigation" */ '../../components/colored/no-code/NoCodeColorNavigation'
    ),
);
const NoCodeColorNavigationContainer = iconLazy(
  () =>
    import(
      /* webpackChunkName: "ua-icons-NoCodeColorNavigationContainer" */ '../../components/colored/no-code/NoCodeColorNavigationContainer'
    ),
);
const NoCodeColorNestedTable = iconLazy(
  () =>
    import(
      /* webpackChunkName: "ua-icons-NoCodeColorNestedTable" */ '../../components/colored/no-code/NoCodeColorNestedTable'
    ),
);
const NoCodeColorPassword = iconLazy(
  () =>
    import(
      /* webpackChunkName: "ua-icons-NoCodeColorPassword" */ '../../components/colored/no-code/NoCodeColorPassword'
    ),
);
const NoCodeColorPdfViewer = iconLazy(
  () =>
    import(
      /* webpackChunkName: "ua-icons-NoCodeColorPdfViewer" */ '../../components/colored/no-code/NoCodeColorPdfViewer'
    ),
);
const NoCodeColorPhoneNumber = iconLazy(
  () =>
    import(
      /* webpackChunkName: "ua-icons-NoCodeColorPhoneNumber" */ '../../components/colored/no-code/NoCodeColorPhoneNumber'
    ),
);
const NoCodeColorPinInput = iconLazy(
  () =>
    import(
      /* webpackChunkName: "ua-icons-NoCodeColorPinInput" */ '../../components/colored/no-code/NoCodeColorPinInput'
    ),
);
const NoCodeColorPressable = iconLazy(
  () =>
    import(
      /* webpackChunkName: "ua-icons-NoCodeColorPressable" */ '../../components/colored/no-code/NoCodeColorPressable'
    ),
);
const NoCodeColorProgressBar = iconLazy(
  () =>
    import(
      /* webpackChunkName: "ua-icons-NoCodeColorProgressBar" */ '../../components/colored/no-code/NoCodeColorProgressBar'
    ),
);
const NoCodeColorQrCode = iconLazy(
  () =>
    import(
      /* webpackChunkName: "ua-icons-NoCodeColorQrCode" */ '../../components/colored/no-code/NoCodeColorQrCode'
    ),
);
const NoCodeColorRadioButton = iconLazy(
  () =>
    import(
      /* webpackChunkName: "ua-icons-NoCodeColorRadioButton" */ '../../components/colored/no-code/NoCodeColorRadioButton'
    ),
);
const NoCodeColorRating = iconLazy(
  () =>
    import(
      /* webpackChunkName: "ua-icons-NoCodeColorRating" */ '../../components/colored/no-code/NoCodeColorRating'
    ),
);
const NoCodeColorRecords = iconLazy(
  () =>
    import(
      /* webpackChunkName: "ua-icons-NoCodeColorRecords" */ '../../components/colored/no-code/NoCodeColorBusinessHour'
    ),
);
const NoCodeColorRepeatable = iconLazy(
  () =>
    import(
      /* webpackChunkName: "ua-icons-NoCodeColorRepeatable" */ '../../components/colored/no-code/NoCodeColorRepeatable'
    ),
);
const NoCodeColorRepeatableList = iconLazy(
  () =>
    import(
      /* webpackChunkName: "ua-icons-NoCodeColorRepeatableList" */ '../../components/colored/no-code/NoCodeColorRepeatableList'
    ),
);
const NoCodeColorRichtext = iconLazy(
  () =>
    import(
      /* webpackChunkName: "ua-icons-NoCodeColorRichtext" */ '../../components/colored/no-code/NoCodeColorRichtext'
    ),
);
const NoCodeColorScanner = iconLazy(
  () =>
    import(
      /* webpackChunkName: "ua-icons-NoCodeColorScanner" */ '../../components/colored/no-code/NoCodeColorScanner'
    ),
);
const NoCodeColorSelect = iconLazy(
  () =>
    import(
      /* webpackChunkName: "ua-icons-NoCodeColorSelect" */ '../../components/colored/no-code/NoCodeColorSelect'
    ),
);
const NoCodeColorSideDrawer = iconLazy(
  () =>
    import(
      /* webpackChunkName: "ua-icons-NoCodeColorSideDrawer" */ '../../components/colored/no-code/NoCodeColorSideDrawer'
    ),
);
const NoCodeColorSignature = iconLazy(
  () =>
    import(
      /* webpackChunkName: "ua-icons-NoCodeColorSignature" */ '../../components/colored/no-code/NoCodeColorSignature'
    ),
);
const NoCodeColorSlot = iconLazy(
  () =>
    import(
      /* webpackChunkName: "ua-icons-NoCodeColorSlot" */ '../../components/colored/no-code/NoCodeColorSlot'
    ),
);
const NoCodeColorStack = iconLazy(
  () =>
    import(
      /* webpackChunkName: "ua-icons-NoCodeColorStack" */ '../../components/colored/no-code/NoCodeColorStack'
    ),
);
const NoCodeColorStatCard = iconLazy(
  () =>
    import(
      /* webpackChunkName: "ua-icons-NoCodeColorStatCard" */ '../../components/colored/no-code/NoCodeColorStatCard'
    ),
);
const NoCodeColorStatus = iconLazy(
  () =>
    import(
      /* webpackChunkName: "ua-icons-NoCodeColorStatus" */ '../../components/colored/no-code/NoCodeColorStatus'
    ),
);
const NoCodeColorStepIndicator = iconLazy(
  () =>
    import(
      /* webpackChunkName: "ua-icons-NoCodeColorStepIndicator" */ '../../components/colored/no-code/NoCodeColorStepIndicator'
    ),
);
const NoCodeColorSteppedContainer = iconLazy(
  () =>
    import(
      /* webpackChunkName: "ua-icons-NoCodeColorSteppedContainer" */ '../../components/colored/no-code/NoCodeColorSteppedContainer'
    ),
);
const NoCodeColorStepper = iconLazy(
  () =>
    import(
      /* webpackChunkName: "ua-icons-NoCodeColorStepper" */ '../../components/colored/no-code/NoCodeColorStepper'
    ),
);
const NoCodeColorStepSeparator = iconLazy(
  () =>
    import(
      /* webpackChunkName: "ua-icons-NoCodeColorStepSeparator" */ '../../components/colored/no-code/NoCodeColorStepSeparator'
    ),
);
const NoCodeColorStories = iconLazy(
  () =>
    import(
      /* webpackChunkName: "ua-icons-NoCodeColorStories" */ '../../components/colored/no-code/NoCodeColorStories'
    ),
);
const NoCodeColorSwipeable = iconLazy(
  () =>
    import(
      /* webpackChunkName: "ua-icons-NoCodeColorSwipeable" */ '../../components/colored/no-code/NoCodeColorSwipeable'
    ),
);
const NoCodeColorSwipeableStack = iconLazy(
  () =>
    import(
      /* webpackChunkName: "ua-icons-NoCodeColorSwipeableStack" */ '../../components/colored/no-code/NoCodeColorSwipeableStack'
    ),
);
const NoCodeColorTable = iconLazy(
  () =>
    import(
      /* webpackChunkName: "ua-icons-NoCodeColorTable" */ '../../components/colored/no-code/NoCodeColorTable'
    ),
);
const NoCodeColorTabs = iconLazy(
  () =>
    import(
      /* webpackChunkName: "ua-icons-NoCodeColorTabs" */ '../../components/colored/no-code/NoCodeColorTabs'
    ),
);
const NoCodeColorTag = iconLazy(
  () =>
    import(
      /* webpackChunkName: "ua-icons-NoCodeColorTag" */ '../../components/colored/no-code/NoCodeColorTag'
    ),
);
const NoCodeColorTemplateComponent = iconLazy(
  () =>
    import(
      /* webpackChunkName: "ua-icons-NoCodeColorTemplateComponent" */ '../../components/colored/no-code/NoCodeColorTemplateComponent'
    ),
);
const NoCodeColorText = iconLazy(
  () =>
    import(
      /* webpackChunkName: "ua-icons-NoCodeColorText" */ '../../components/colored/no-code/NoCodeColorText'
    ),
);
const NoCodeColorTextArea = iconLazy(
  () =>
    import(
      /* webpackChunkName: "ua-icons-NoCodeColorTextArea" */ '../../components/colored/no-code/NoCodeColorTextArea'
    ),
);
const NoCodeColorTextInput = iconLazy(
  () =>
    import(
      /* webpackChunkName: "ua-icons-NoCodeColorTextInput" */ '../../components/colored/no-code/NoCodeColorTextInput'
    ),
);
const NoCodeColorTimeline = iconLazy(
  () =>
    import(
      /* webpackChunkName: "ua-icons-NoCodeColorTimeline" */ '../../components/colored/no-code/NoCodeColorTimeline'
    ),
);
const NoCodeColorTimer = iconLazy(
  () =>
    import(
      /* webpackChunkName: "ua-icons-NoCodeColorTimer" */ '../../components/colored/no-code/NoCodeColorTimer'
    ),
);
const NoCodeColorVideo = iconLazy(
  () =>
    import(
      /* webpackChunkName: "ua-icons-NoCodeColorVideo" */ '../../components/colored/no-code/NoCodeColorVideo'
    ),
);
const NoCodeColumns3 = iconLazy(
  () =>
    import(
      /* webpackChunkName: "ua-icons-NoCodeColumns3" */ '../../components/outline/no-code/NoCodeColumns3'
    ),
);
const NoCodeColumns4 = iconLazy(
  () =>
    import(
      /* webpackChunkName: "ua-icons-NoCodeColumns4" */ '../../components/outline/no-code/NoCodeColumns4'
    ),
);
const NoCodeColumns5 = iconLazy(
  () =>
    import(
      /* webpackChunkName: "ua-icons-NoCodeColumns5" */ '../../components/outline/no-code/NoCodeColumns5'
    ),
);
const NoCodeColumns6 = iconLazy(
  () =>
    import(
      /* webpackChunkName: "ua-icons-NoCodeColumns6" */ '../../components/outline/no-code/NoCodeColumns6'
    ),
);
const NoCodeComponentSelection = iconLazy(
  () =>
    import(
      /* webpackChunkName: "ua-icons-NoCodeComponentSelection" */ '../../components/outline/no-code/NoCodeComponentSelection'
    ),
);
const NoCodeContainer = iconLazy(
  () =>
    import(
      /* webpackChunkName: "ua-icons-NoCodeContainer" */ '../../components/outline/no-code/NoCodeContainer'
    ),
);
const NoCodeContainer11 = iconLazy(
  () =>
    import(
      /* webpackChunkName: "ua-icons-NoCodeContainer11" */ '../../components/outline/no-code/NoCodeContainer11'
    ),
);
const NoCodeContainer112 = iconLazy(
  () =>
    import(
      /* webpackChunkName: "ua-icons-NoCodeContainer112" */ '../../components/outline/no-code/NoCodeContainer112'
    ),
);
const NoCodeContainer12 = iconLazy(
  () =>
    import(
      /* webpackChunkName: "ua-icons-NoCodeContainer12" */ '../../components/outline/no-code/NoCodeContainer12'
    ),
);
const NoCodeContainer121 = iconLazy(
  () =>
    import(
      /* webpackChunkName: "ua-icons-NoCodeContainer121" */ '../../components/outline/no-code/NoCodeContainer121'
    ),
);
const NoCodeContainer13 = iconLazy(
  () =>
    import(
      /* webpackChunkName: "ua-icons-NoCodeContainer13" */ '../../components/outline/no-code/NoCodeContainer13'
    ),
);
const NoCodeContainer21 = iconLazy(
  () =>
    import(
      /* webpackChunkName: "ua-icons-NoCodeContainer21" */ '../../components/outline/no-code/NoCodeContainer21'
    ),
);
const NoCodeContainer211 = iconLazy(
  () =>
    import(
      /* webpackChunkName: "ua-icons-NoCodeContainer211" */ '../../components/outline/no-code/NoCodeContainer211'
    ),
);
const NoCodeContainer23 = iconLazy(
  () =>
    import(
      /* webpackChunkName: "ua-icons-NoCodeContainer23" */ '../../components/outline/no-code/NoCodeContainer23'
    ),
);
const NoCodeContainer31 = iconLazy(
  () =>
    import(
      /* webpackChunkName: "ua-icons-NoCodeContainer31" */ '../../components/outline/no-code/NoCodeContainer31'
    ),
);
const NoCodeContainer32 = iconLazy(
  () =>
    import(
      /* webpackChunkName: "ua-icons-NoCodeContainer32" */ '../../components/outline/no-code/NoCodeContainer32'
    ),
);
const NoCodeContextualDialog = iconLazy(
  () =>
    import(
      /* webpackChunkName: "ua-icons-NoCodeContextualDialog" */ '../../components/outline/no-code/NoCodeContextualDialog'
    ),
);
const NoCodeCopilot = iconLazy(
  () =>
    import(
      /* webpackChunkName: "ua-icons-NoCodeCopilot" */ '../../components/outline/no-code/NoCodeCopilot'
    ),
);
const NoCodeDatasource = iconLazy(
  () =>
    import(
      /* webpackChunkName: "ua-icons-NoCodeDatasource" */ '../../components/colored/no-code/NoCodeDatasource'
    ),
);
const NoCodeDatePicker = iconLazy(
  () =>
    import(
      /* webpackChunkName: "ua-icons-NoCodeDatePicker" */ '../../components/outline/no-code/NoCodeDatePicker'
    ),
);
const NoCodeDictation = iconLazy(
  () =>
    import(
      /* webpackChunkName: "ua-icons-NoCodeDictation" */ '../../components/outline/no-code/NoCodeDictation'
    ),
);
const NoCodeDivider = iconLazy(
  () =>
    import(
      /* webpackChunkName: "ua-icons-NoCodeDivider" */ '../../components/outline/no-code/NoCodeDivider'
    ),
);
const NoCodeDropdown = iconLazy(
  () =>
    import(
      /* webpackChunkName: "ua-icons-NoCodeDropdown" */ '../../components/outline/no-code/NoCodeDropdown'
    ),
);
const NoCodeEventsCalendar = iconLazy(
  () =>
    import(
      /* webpackChunkName: "ua-icons-NoCodeEventsCalendar" */ '../../components/outline/no-code/NoCodeEventsCalendar'
    ),
);
const NoCodeFileUpload = iconLazy(
  () =>
    import(
      /* webpackChunkName: "ua-icons-NoCodeFileUpload" */ '../../components/outline/no-code/NoCodeFileUpload'
    ),
);
const NoCodeFilters = iconLazy(
  () =>
    import(
      /* webpackChunkName: "ua-icons-NoCodeFilters" */ '../../components/outline/no-code/NoCodeFilters'
    ),
);
const NoCodeFlippable = iconLazy(
  () =>
    import(
      /* webpackChunkName: "ua-icons-NoCodeFlippable" */ '../../components/outline/no-code/NoCodeFlippable'
    ),
);
const NoCodeForm = iconLazy(
  () =>
    import(
      /* webpackChunkName: "ua-icons-NoCodeForm" */ '../../components/outline/no-code/NoCodeForm'
    ),
);
const NoCodeFunctions = iconLazy(
  () =>
    import(
      /* webpackChunkName: "ua-icons-NoCodeFunctions" */ '../../components/colored/no-code/NoCodeFunctions'
    ),
);
const NoCodeGrid = iconLazy(
  () =>
    import(
      /* webpackChunkName: "ua-icons-NoCodeGrid" */ '../../components/outline/no-code/NoCodeGrid'
    ),
);
const NoCodeHeatMap = iconLazy(
  () =>
    import(
      /* webpackChunkName: "ua-icons-NoCodeHeatMap" */ '../../components/outline/no-code/NoCodeHeatMap'
    ),
);
const NoCodeIcon = iconLazy(
  () =>
    import(
      /* webpackChunkName: "ua-icons-NoCodeIcon" */ '../../components/outline/no-code/NoCodeIcon'
    ),
);
const NoCodeIconButton = iconLazy(
  () =>
    import(
      /* webpackChunkName: "ua-icons-NoCodeIconButton" */ '../../components/outline/no-code/NoCodeIconButton'
    ),
);
const NoCodeIframe = iconLazy(
  () =>
    import(
      /* webpackChunkName: "ua-icons-NoCodeIframe" */ '../../components/outline/no-code/NoCodeIframe'
    ),
);
const NoCodeImage = iconLazy(
  () =>
    import(
      /* webpackChunkName: "ua-icons-NoCodeImage" */ '../../components/outline/no-code/NoCodeImage'
    ),
);
const NoCodeKanban = iconLazy(
  () =>
    import(
      /* webpackChunkName: "ua-icons-NoCodeKanban" */ '../../components/outline/NoCodeKanban'
    ),
);
const NoCodeKanbanColored = iconLazy(
  () =>
    import(
      /* webpackChunkName: "ua-icons-NoCodeKanbanColored" */ '../../components/colored/NoCodeKanbanColored'
    ),
);
const NoCodeKeyValue = iconLazy(
  () =>
    import(
      /* webpackChunkName: "ua-icons-NoCodeKeyValue" */ '../../components/outline/no-code/NoCodeKeyValue'
    ),
);
const NoCodeLink = iconLazy(
  () =>
    import(
      /* webpackChunkName: "ua-icons-NoCodeLink" */ '../../components/outline/no-code/NoCodeLink'
    ),
);
const NoCodeLoader = iconLazy(
  () =>
    import(
      /* webpackChunkName: "ua-icons-NoCodeLoader" */ '../../components/outline/no-code/NoCodeLoader'
    ),
);
const NoCodeMedia = iconLazy(
  () =>
    import(
      /* webpackChunkName: "ua-icons-NoCodeMedia" */ '../../components/outline/no-code/NoCodeMedia'
    ),
);
const NoCodeMenu = iconLazy(
  () =>
    import(
      /* webpackChunkName: "ua-icons-NoCodeMenu" */ '../../components/outline/no-code/NoCodeMenu'
    ),
);
const NoCodeMessageInput = iconLazy(
  () =>
    import(
      /* webpackChunkName: "ua-icons-NoCodeMessageInput" */ '../../components/outline/no-code/NoCodeMessageInput'
    ),
);
const NoCodeModal = iconLazy(
  () =>
    import(
      /* webpackChunkName: "ua-icons-NoCodeModal" */ '../../components/outline/no-code/NoCodeModal'
    ),
);
const NoCodeMultiStatCard = iconLazy(
  () =>
    import(
      /* webpackChunkName: "ua-icons-NoCodeMultiStatCard" */ '../../components/outline/no-code/NoCodeMultiStatCard'
    ),
);
const NoCodeNavigation = iconLazy(
  () =>
    import(
      /* webpackChunkName: "ua-icons-NoCodeNavigation" */ '../../components/outline/no-code/NoCodeNavigation'
    ),
);
const NoCodeNavigationContainer = iconLazy(
  () =>
    import(
      /* webpackChunkName: "ua-icons-NoCodeNavigationContainer" */ '../../components/outline/no-code/NoCodeNavigationContainer'
    ),
);
const NoCodeNestedTable = iconLazy(
  () =>
    import(
      /* webpackChunkName: "ua-icons-NoCodeNestedTable" */ '../../components/outline/no-code/NoCodeNestedTable'
    ),
);
const NoCodePassword = iconLazy(
  () =>
    import(
      /* webpackChunkName: "ua-icons-NoCodePassword" */ '../../components/outline/no-code/NoCodePassword'
    ),
);
const NoCodePdfViewer = iconLazy(
  () =>
    import(
      /* webpackChunkName: "ua-icons-NoCodePdfViewer" */ '../../components/outline/no-code/NoCodePdfViewer'
    ),
);
const NoCodePhoneNumber = iconLazy(
  () =>
    import(
      /* webpackChunkName: "ua-icons-NoCodePhoneNumber" */ '../../components/outline/no-code/NoCodePhoneNumber'
    ),
);
const NoCodePinInput = iconLazy(
  () =>
    import(
      /* webpackChunkName: "ua-icons-NoCodePinInput" */ '../../components/outline/no-code/NoCodePinInput'
    ),
);
const NoCodePinnedRightPane = iconLazy(
  () =>
    import(
      /* webpackChunkName: "ua-icons-NoCodePinnedRightPane" */ '../../components/outline/no-code/NoCodePinnedRightPane'
    ),
);
const NoCodePressable = iconLazy(
  () =>
    import(
      /* webpackChunkName: "ua-icons-NoCodePressable" */ '../../components/outline/no-code/NoCodePressable'
    ),
);
const NoCodeProgressBar = iconLazy(
  () =>
    import(
      /* webpackChunkName: "ua-icons-NoCodeProgressBar" */ '../../components/outline/no-code/NoCodeProgressBar'
    ),
);
const NoCodeQrCode = iconLazy(
  () =>
    import(
      /* webpackChunkName: "ua-icons-NoCodeQrCode" */ '../../components/outline/no-code/NoCodeQrCode'
    ),
);
const NoCodeRadioButton = iconLazy(
  () =>
    import(
      /* webpackChunkName: "ua-icons-NoCodeRadioButton" */ '../../components/outline/no-code/NoCodeRadioButton'
    ),
);
const NoCodeRating = iconLazy(
  () =>
    import(
      /* webpackChunkName: "ua-icons-NoCodeRating" */ '../../components/outline/no-code/NoCodeRating'
    ),
);
const NoCodeRecords = iconLazy(
  () =>
    import(
      /* webpackChunkName: "ua-icons-NoCodeRecords" */ '../../components/outline/no-code/NoCodeBusinessHour'
    ),
);
const NoCodeRepeatable = iconLazy(
  () =>
    import(
      /* webpackChunkName: "ua-icons-NoCodeRepeatable" */ '../../components/outline/no-code/NoCodeRepeatable'
    ),
);
const NoCodeRepeatableList = iconLazy(
  () =>
    import(
      /* webpackChunkName: "ua-icons-NoCodeRepeatableList" */ '../../components/outline/no-code/NoCodeRepeatableList'
    ),
);
const NoCodeRichtext = iconLazy(
  () =>
    import(
      /* webpackChunkName: "ua-icons-NoCodeRichtext" */ '../../components/outline/no-code/NoCodeRichtext'
    ),
);
const NoCodeScanner = iconLazy(
  () =>
    import(
      /* webpackChunkName: "ua-icons-NoCodeScanner" */ '../../components/outline/no-code/NoCodeScanner'
    ),
);
const NoCodeSideDrawer = iconLazy(
  () =>
    import(
      /* webpackChunkName: "ua-icons-NoCodeSideDrawer" */ '../../components/outline/no-code/NoCodeSideDrawer'
    ),
);
const NoCodeSignature = iconLazy(
  () =>
    import(
      /* webpackChunkName: "ua-icons-NoCodeSignature" */ '../../components/outline/no-code/NoCodeSignature'
    ),
);
const NoCodeSlot = iconLazy(
  () =>
    import(
      /* webpackChunkName: "ua-icons-NoCodeSlot" */ '../../components/outline/no-code/NoCodeSlot'
    ),
);
const NoCodeStack = iconLazy(
  () =>
    import(
      /* webpackChunkName: "ua-icons-NoCodeStack" */ '../../components/outline/no-code/NoCodeStack'
    ),
);
const NoCodeStatCard = iconLazy(
  () =>
    import(
      /* webpackChunkName: "ua-icons-NoCodeStatCard" */ '../../components/outline/no-code/NoCodeStatCard'
    ),
);
const NoCodeStepIndicator = iconLazy(
  () =>
    import(
      /* webpackChunkName: "ua-icons-NoCodeStepIndicator" */ '../../components/outline/no-code/NoCodeStepIndicator'
    ),
);
const NoCodeSteppedContainer = iconLazy(
  () =>
    import(
      /* webpackChunkName: "ua-icons-NoCodeSteppedContainer" */ '../../components/outline/no-code/NoCodeSteppedContainer'
    ),
);
const NoCodeStepper = iconLazy(
  () =>
    import(
      /* webpackChunkName: "ua-icons-NoCodeStepper" */ '../../components/outline/no-code/NoCodeStepper'
    ),
);
const NoCodeStepSeparator = iconLazy(
  () =>
    import(
      /* webpackChunkName: "ua-icons-NoCodeStepSeparator" */ '../../components/outline/no-code/NoCodeStepSeparator'
    ),
);
const NoCodeStories = iconLazy(
  () =>
    import(
      /* webpackChunkName: "ua-icons-NoCodeStories" */ '../../components/outline/no-code/NoCodeStories'
    ),
);
const NoCodeSwipeable = iconLazy(
  () =>
    import(
      /* webpackChunkName: "ua-icons-NoCodeSwipeable" */ '../../components/outline/no-code/NoCodeSwipeable'
    ),
);
const NoCodeSwipeableStack = iconLazy(
  () =>
    import(
      /* webpackChunkName: "ua-icons-NoCodeSwipeableStack" */ '../../components/outline/no-code/NoCodeSwipeableStack'
    ),
);
const NoCodeTable = iconLazy(
  () =>
    import(
      /* webpackChunkName: "ua-icons-NoCodeTable" */ '../../components/outline/no-code/NoCodeTable'
    ),
);
const NoCodeTabs = iconLazy(
  () =>
    import(
      /* webpackChunkName: "ua-icons-NoCodeTabs" */ '../../components/outline/no-code/NoCodeTabs'
    ),
);
const NoCodeTag = iconLazy(
  () =>
    import(
      /* webpackChunkName: "ua-icons-NoCodeTag" */ '../../components/outline/no-code/NoCodeTag'
    ),
);
const NoCodeTemplateComponent = iconLazy(
  () =>
    import(
      /* webpackChunkName: "ua-icons-NoCodeTemplateComponent" */ '../../components/outline/no-code/NoCodeTemplateComponent'
    ),
);
const NoCodeTemplatePlaceholder = iconLazy(
  () =>
    import(
      /* webpackChunkName: "ua-icons-NoCodeTemplatePlaceholder" */ '../../components/colored/NoCodeTemplatePlaceholder'
    ),
);
const NoCodeText = iconLazy(
  () =>
    import(
      /* webpackChunkName: "ua-icons-NoCodeText" */ '../../components/outline/no-code/NoCodeText'
    ),
);
const NoCodeTextArea = iconLazy(
  () =>
    import(
      /* webpackChunkName: "ua-icons-NoCodeTextArea" */ '../../components/outline/no-code/NoCodeTextArea'
    ),
);
const NoCodeTextInput = iconLazy(
  () =>
    import(
      /* webpackChunkName: "ua-icons-NoCodeTextInput" */ '../../components/outline/no-code/NoCodeTextInput'
    ),
);
const NoCodeTimeline = iconLazy(
  () =>
    import(
      /* webpackChunkName: "ua-icons-NoCodeTimeline" */ '../../components/outline/no-code/NoCodeTimeline'
    ),
);
const NoCodeTimer = iconLazy(
  () =>
    import(
      /* webpackChunkName: "ua-icons-NoCodeTimer" */ '../../components/outline/no-code/NoCodeTimer'
    ),
);
const NoCodeToggle = iconLazy(
  () =>
    import(
      /* webpackChunkName: "ua-icons-NoCodeToggle" */ '../../components/outline/no-code/NoCodeToggle'
    ),
);
const NoCodeVariables = iconLazy(
  () =>
    import(
      /* webpackChunkName: "ua-icons-NoCodeVariables" */ '../../components/colored/no-code/NoCodeVariables'
    ),
);
const NoCodeVideo = iconLazy(
  () =>
    import(
      /* webpackChunkName: "ua-icons-NoCodeVideo" */ '../../components/outline/no-code/NoCodeVideo'
    ),
);
const NoEntry = iconLazy(
  () =>
    import(
      /* webpackChunkName: "ua-icons-NoEntry" */ '../../components/colored/NoEntry'
    ),
);
const OpenSourceModel = iconLazy(
  () =>
    import(
      /* webpackChunkName: "ua-icons-OpenSourceModel" */ '../../components/colored/OpenSourceModel'
    ),
);
const PackageCheck = iconLazy(
  () =>
    import(
      /* webpackChunkName: "ua-icons-PackageCheck" */ '../../components/outline/PackageCheck'
    ),
);
const Paginate = iconLazy(
  () =>
    import(
      /* webpackChunkName: "ua-icons-Paginate" */ '../../components/outline/Paginate'
    ),
);
const Palette = iconLazy(
  () =>
    import(
      /* webpackChunkName: "ua-icons-Palette" */ '../../components/outline/Palette'
    ),
);
const Pause = iconLazy(
  () =>
    import(
      /* webpackChunkName: "ua-icons-Pause" */ '../../components/outline/Pause'
    ),
);
const Pdf2 = iconLazy(
  () =>
    import(
      /* webpackChunkName: "ua-icons-Pdf2" */ '../../components/colored/Pdf2'
    ),
);
const PermissionControl = iconLazy(
  () =>
    import(
      /* webpackChunkName: "ua-icons-PermissionControl" */ '../../components/outline/PermissionControl'
    ),
);
const Phone02 = iconLazy(
  () =>
    import(
      /* webpackChunkName: "ua-icons-Phone02" */ '../../components/outline/Phone02'
    ),
);
const PieChart01 = iconLazy(
  () =>
    import(
      /* webpackChunkName: "ua-icons-PieChart01" */ '../../components/outline/PieChart01'
    ),
);
const Placeholder = iconLazy(
  () =>
    import(
      /* webpackChunkName: "ua-icons-Placeholder" */ '../../components/outline/Placeholder'
    ),
);
const Play = iconLazy(
  () =>
    import(
      /* webpackChunkName: "ua-icons-Play" */ '../../components/outline/Play'
    ),
);
const PlayCircle = iconLazy(
  () =>
    import(
      /* webpackChunkName: "ua-icons-PlayCircle" */ '../../components/outline/PlayCircle'
    ),
);
const Plus = iconLazy(
  () =>
    import(
      /* webpackChunkName: "ua-icons-Plus" */ '../../components/outline/Plus'
    ),
);
const Ppt = iconLazy(
  () =>
    import(
      /* webpackChunkName: "ua-icons-Ppt" */ '../../components/colored/Ppt'
    ),
);
const Pptx = iconLazy(
  () =>
    import(
      /* webpackChunkName: "ua-icons-Pptx" */ '../../components/colored/Pptx'
    ),
);
const PresentationChart01 = iconLazy(
  () =>
    import(
      /* webpackChunkName: "ua-icons-PresentationChart01" */ '../../components/outline/PresentationChart01'
    ),
);
const Prohibition = iconLazy(
  () =>
    import(
      /* webpackChunkName: "ua-icons-Prohibition" */ '../../components/colored/Prohibition'
    ),
);
const Prompt = iconLazy(
  () =>
    import(
      /* webpackChunkName: "ua-icons-Prompt" */ '../../components/outline/Prompt'
    ),
);
const QuoteEnd = iconLazy(
  () =>
    import(
      /* webpackChunkName: "ua-icons-QuoteEnd" */ '../../components/outline/QuoteEnd'
    ),
);
const RadarSpiderChart = iconLazy(
  () =>
    import(
      /* webpackChunkName: "ua-icons-RadarSpiderChart" */ '../../components/outline/RadarSpiderChart'
    ),
);
const RadialBarChart = iconLazy(
  () =>
    import(
      /* webpackChunkName: "ua-icons-RadialBarChart" */ '../../components/outline/RadialBarChart'
    ),
);
const RadialColumnChart = iconLazy(
  () =>
    import(
      /* webpackChunkName: "ua-icons-RadialColumnChart" */ '../../components/outline/RadialColumnChart'
    ),
);
const RadialScatterChart = iconLazy(
  () =>
    import(
      /* webpackChunkName: "ua-icons-RadialScatterChart" */ '../../components/outline/RadialScatterChart'
    ),
);
const RefreshCcw01 = iconLazy(
  () =>
    import(
      /* webpackChunkName: "ua-icons-RefreshCcw01" */ '../../components/outline/RefreshCcw01'
    ),
);
const RefreshCcw02 = iconLazy(
  () =>
    import(
      /* webpackChunkName: "ua-icons-RefreshCcw02" */ '../../components/outline/RefreshCcw02'
    ),
);
const RefreshCcw05 = iconLazy(
  () =>
    import(
      /* webpackChunkName: "ua-icons-RefreshCcw05" */ '../../components/outline/RefreshCcw05'
    ),
);
const RefreshCcw06 = iconLazy(
  () =>
    import(
      /* webpackChunkName: "ua-icons-RefreshCcw06" */ '../../components/outline/RefreshCcw06'
    ),
);
const RefreshCw01 = iconLazy(
  () =>
    import(
      /* webpackChunkName: "ua-icons-RefreshCw01" */ '../../components/outline/RefreshCw01'
    ),
);
const Reply = iconLazy(
  () =>
    import(
      /* webpackChunkName: "ua-icons-Reply" */ '../../components/outline/Reply'
    ),
);
const RichText = iconLazy(
  () =>
    import(
      /* webpackChunkName: "ua-icons-RichText" */ '../../components/outline/RichText'
    ),
);
const Route = iconLazy(
  () =>
    import(
      /* webpackChunkName: "ua-icons-Route" */ '../../components/outline/Route'
    ),
);
const SankeyChart01 = iconLazy(
  () =>
    import(
      /* webpackChunkName: "ua-icons-SankeyChart01" */ '../../components/outline/SankeyChart01'
    ),
);
const Scales01 = iconLazy(
  () =>
    import(
      /* webpackChunkName: "ua-icons-Scales01" */ '../../components/outline/Scales01'
    ),
);
const Scales02 = iconLazy(
  () =>
    import(
      /* webpackChunkName: "ua-icons-Scales02" */ '../../components/outline/Scales02'
    ),
);
const Scan = iconLazy(
  () =>
    import(
      /* webpackChunkName: "ua-icons-Scan" */ '../../components/outline/Scan'
    ),
);
const ScatterChart = iconLazy(
  () =>
    import(
      /* webpackChunkName: "ua-icons-ScatterChart" */ '../../components/outline/ScatterChart'
    ),
);
const SchemaMapping = iconLazy(
  () =>
    import(
      /* webpackChunkName: "ua-icons-SchemaMapping" */ '../../components/outline/SchemaMapping'
    ),
);
const Scissors01 = iconLazy(
  () =>
    import(
      /* webpackChunkName: "ua-icons-Scissors01" */ '../../components/outline/Scissors01'
    ),
);
const Server04 = iconLazy(
  () =>
    import(
      /* webpackChunkName: "ua-icons-Server04" */ '../../components/outline/Server04'
    ),
);
const SessionStorage = iconLazy(
  () =>
    import(
      /* webpackChunkName: "ua-icons-SessionStorage" */ '../../components/outline/SessionStorage'
    ),
);
const Settings01 = iconLazy(
  () =>
    import(
      /* webpackChunkName: "ua-icons-Settings01" */ '../../components/outline/Settings01'
    ),
);
const Settings04 = iconLazy(
  () =>
    import(
      /* webpackChunkName: "ua-icons-Settings04" */ '../../components/outline/Settings04'
    ),
);
const Settings05 = iconLazy(
  () =>
    import(
      /* webpackChunkName: "ua-icons-Settings05" */ '../../components/outline/Settings05'
    ),
);
const Share04 = iconLazy(
  () =>
    import(
      /* webpackChunkName: "ua-icons-Share04" */ '../../components/outline/Share04'
    ),
);
const ShieldLock = iconLazy(
  () =>
    import(
      /* webpackChunkName: "ua-icons-ShieldLock" */ '../../components/outline/ShieldLock'
    ),
);
const SlashBox = iconLazy(
  () =>
    import(
      /* webpackChunkName: "ua-icons-SlashBox" */ '../../components/outline/SlashBox'
    ),
);
const SlashCircle01 = iconLazy(
  () =>
    import(
      /* webpackChunkName: "ua-icons-SlashCircle01" */ '../../components/outline/SlashCircle01'
    ),
);
const Sources = iconLazy(
  () =>
    import(
      /* webpackChunkName: "ua-icons-Sources" */ '../../components/outline/Sources'
    ),
);
const SquareFilled = iconLazy(
  () =>
    import(
      /* webpackChunkName: "ua-icons-SquareFilled" */ '../../components/solid/SquareFilled'
    ),
);
const Star01 = iconLazy(
  () =>
    import(
      /* webpackChunkName: "ua-icons-Star01" */ '../../components/outline/Star01'
    ),
);
const StarBackground = iconLazy(
  () =>
    import(
      /* webpackChunkName: "ua-icons-StarBackground" */ '../../components/solid/StarBackground'
    ),
);
const Stars01 = iconLazy(
  () =>
    import(
      /* webpackChunkName: "ua-icons-Stars01" */ '../../components/outline/Stars01'
    ),
);
const Stars02 = iconLazy(
  () =>
    import(
      /* webpackChunkName: "ua-icons-Stars02" */ '../../components/outline/Stars02'
    ),
);
const Stars02Colored = iconLazy(
  () =>
    import(
      /* webpackChunkName: "ua-icons-Stars02Colored" */ '../../components/colored/Stars02Colored'
    ),
);
const Stars02Filled = iconLazy(
  () =>
    import(
      /* webpackChunkName: "ua-icons-Stars02Filled" */ '../../components/solid/Stars02Filled'
    ),
);
const StatusClosed = iconLazy(
  () =>
    import(
      /* webpackChunkName: "ua-icons-StatusClosed" */ '../../components/colored/StatusClosed'
    ),
);
const StatusClosedPill = iconLazy(
  () =>
    import(
      /* webpackChunkName: "ua-icons-StatusClosedPill" */ '../../components/colored/StatusClosedPill'
    ),
);
const StatusInProgress = iconLazy(
  () =>
    import(
      /* webpackChunkName: "ua-icons-StatusInProgress" */ '../../components/colored/StatusInProgress'
    ),
);
const StatusOpen = iconLazy(
  () =>
    import(
      /* webpackChunkName: "ua-icons-StatusOpen" */ '../../components/colored/StatusOpen'
    ),
);
const StatusOpenPill = iconLazy(
  () =>
    import(
      /* webpackChunkName: "ua-icons-StatusOpenPill" */ '../../components/colored/StatusOpenPill'
    ),
);
const StatusResolved = iconLazy(
  () =>
    import(
      /* webpackChunkName: "ua-icons-StatusResolved" */ '../../components/colored/StatusResolved'
    ),
);
const StorageTools02 = iconLazy(
  () =>
    import(
      /* webpackChunkName: "ua-icons-StorageTools02" */ '../../components/outline/StorageTools02'
    ),
);
const SuccessCheck = iconLazy(
  () =>
    import(
      /* webpackChunkName: "ua-icons-SuccessCheck" */ '../../components/colored/SuccessCheck'
    ),
);
const Sun = iconLazy(
  () =>
    import(
      /* webpackChunkName: "ua-icons-Sun" */ '../../components/outline/Sun'
    ),
);
const Sunrise = iconLazy(
  () =>
    import(
      /* webpackChunkName: "ua-icons-Sunrise" */ '../../components/outline/Sunrise'
    ),
);
const Sunset = iconLazy(
  () =>
    import(
      /* webpackChunkName: "ua-icons-Sunset" */ '../../components/outline/Sunset'
    ),
);
const SvgA2AServer = iconLazy(
  () =>
    import(
      /* webpackChunkName: "ua-icons-SvgA2AServer" */ '../../components/outline/A2AServer'
    ),
);
const SvgActivity = iconLazy(
  () =>
    import(
      /* webpackChunkName: "ua-icons-SvgActivity" */ '../../components/outline/Activity'
    ),
);
const SvgAdaptiveTheme = iconLazy(
  () =>
    import(
      /* webpackChunkName: "ua-icons-SvgAdaptiveTheme" */ '../../components/outline/AdaptiveTheme'
    ),
);
const SvgAep = iconLazy(
  () =>
    import(
      /* webpackChunkName: "ua-icons-SvgAep" */ '../../components/colored/Aep'
    ),
);
const SvgAgentAvatar = iconLazy(
  () =>
    import(
      /* webpackChunkName: "ua-icons-SvgAgentAvatar" */ '../../components/colored/AgentAvatar'
    ),
);
const SvgAi = iconLazy(
  () =>
    import(
      /* webpackChunkName: "ua-icons-SvgAi" */ '../../components/colored/Ai'
    ),
);
const SvgAiAgent = iconLazy(
  () =>
    import(
      /* webpackChunkName: "ua-icons-SvgAiAgent" */ '../../components/outline/AiAgent'
    ),
);
const SvgAiAgent02 = iconLazy(
  () =>
    import(
      /* webpackChunkName: "ua-icons-SvgAiAgent02" */ '../../components/outline/AiAgent02'
    ),
);
const SvgAiChat = iconLazy(
  () =>
    import(
      /* webpackChunkName: "ua-icons-SvgAiChat" */ '../../components/outline/AiChat'
    ),
);
const SvgAiEsChat = iconLazy(
  () =>
    import(
      /* webpackChunkName: "ua-icons-SvgAiEsChat" */ '../../components/outline/AiEsChat'
    ),
);
const SvgAiMemory = iconLazy(
  () =>
    import(
      /* webpackChunkName: "ua-icons-SvgAiMemory" */ '../../components/outline/AiMemory'
    ),
);
const SvgAiPromptGuard = iconLazy(
  () =>
    import(
      /* webpackChunkName: "ua-icons-SvgAiPromptGuard" */ '../../components/outline/AiPromptGuard'
    ),
);
const SvgAiTeam = iconLazy(
  () =>
    import(
      /* webpackChunkName: "ua-icons-SvgAiTeam" */ '../../components/outline/AiTeam'
    ),
);
const SvgAlarmClockCheck = iconLazy(
  () =>
    import(
      /* webpackChunkName: "ua-icons-SvgAlarmClockCheck" */ '../../components/outline/AlarmClockCheck'
    ),
);
const SvgAlertCircleSolid = iconLazy(
  () =>
    import(
      /* webpackChunkName: "ua-icons-SvgAlertCircleSolid" */ '../../components/colored/AlertCircleSolid'
    ),
);
const SvgAlignHorizontalCenter = iconLazy(
  () =>
    import(
      /* webpackChunkName: "ua-icons-SvgAlignHorizontalCenter" */ '../../components/outline/AlignHorizontalCenter'
    ),
);
const SvgAlignHorizontalCentre02 = iconLazy(
  () =>
    import(
      /* webpackChunkName: "ua-icons-SvgAlignHorizontalCentre02" */ '../../components/outline/AlignHorizontalCentre02'
    ),
);
const SvgAlignHorizontalEnd = iconLazy(
  () =>
    import(
      /* webpackChunkName: "ua-icons-SvgAlignHorizontalEnd" */ '../../components/outline/AlignHorizontalEnd'
    ),
);
const SvgAlignHorizontalSpaceBetween = iconLazy(
  () =>
    import(
      /* webpackChunkName: "ua-icons-SvgAlignHorizontalSpaceBetween" */ '../../components/outline/AlignHorizontalSpaceBetween'
    ),
);
const SvgAlignHorizontalStart = iconLazy(
  () =>
    import(
      /* webpackChunkName: "ua-icons-SvgAlignHorizontalStart" */ '../../components/outline/AlignHorizontalStart'
    ),
);
const SvgAlignHorizontalStretch = iconLazy(
  () =>
    import(
      /* webpackChunkName: "ua-icons-SvgAlignHorizontalStretch" */ '../../components/outline/AlignHorizontalStretch'
    ),
);
const SvgAlignLeft02 = iconLazy(
  () =>
    import(
      /* webpackChunkName: "ua-icons-SvgAlignLeft02" */ '../../components/outline/AlignLeft02'
    ),
);
const SvgAlignVerticalCenter = iconLazy(
  () =>
    import(
      /* webpackChunkName: "ua-icons-SvgAlignVerticalCenter" */ '../../components/outline/AlignVerticalCenter'
    ),
);
const SvgAlignVerticalEnd = iconLazy(
  () =>
    import(
      /* webpackChunkName: "ua-icons-SvgAlignVerticalEnd" */ '../../components/outline/AlignVerticalEnd'
    ),
);
const SvgAlignVerticalSpaceBetween = iconLazy(
  () =>
    import(
      /* webpackChunkName: "ua-icons-SvgAlignVerticalSpaceBetween" */ '../../components/outline/AlignVerticalSpaceBetween'
    ),
);
const SvgAlignVerticalStart = iconLazy(
  () =>
    import(
      /* webpackChunkName: "ua-icons-SvgAlignVerticalStart" */ '../../components/outline/AlignVerticalStart'
    ),
);
const SvgAlignVerticalStretch = iconLazy(
  () =>
    import(
      /* webpackChunkName: "ua-icons-SvgAlignVerticalStretch" */ '../../components/outline/AlignVerticalStretch'
    ),
);
const SvgAnnotationAlert = iconLazy(
  () =>
    import(
      /* webpackChunkName: "ua-icons-SvgAnnotationAlert" */ '../../components/outline/AnnotationAlert'
    ),
);
const SvgApplicationsByUnifyapps = iconLazy(
  () =>
    import(
      /* webpackChunkName: "ua-icons-SvgApplicationsByUnifyapps" */ '../../components/outline/ApplicationsByUnifyapps'
    ),
);
const SvgAppWindow = iconLazy(
  () =>
    import(
      /* webpackChunkName: "ua-icons-SvgAppWindow" */ '../../components/solid/AppWindow'
    ),
);
const SvgArrowNarrowDownLeft = iconLazy(
  () =>
    import(
      /* webpackChunkName: "ua-icons-SvgArrowNarrowDownLeft" */ '../../components/outline/ArrowNarrowDownLeft'
    ),
);
const SvgArrowNarrowUp = iconLazy(
  () =>
    import(
      /* webpackChunkName: "ua-icons-SvgArrowNarrowUp" */ '../../components/outline/ArrowNarrowUp'
    ),
);
const SvgArrowNarrowUpRight = iconLazy(
  () =>
    import(
      /* webpackChunkName: "ua-icons-SvgArrowNarrowUpRight" */ '../../components/outline/ArrowNarrowUpRight'
    ),
);
const SvgArrowUpRight = iconLazy(
  () =>
    import(
      /* webpackChunkName: "ua-icons-SvgArrowUpRight" */ '../../components/outline/ArrowUpRight'
    ),
);
const SvgAsterisk03 = iconLazy(
  () =>
    import(
      /* webpackChunkName: "ua-icons-SvgAsterisk03" */ '../../components/outline/Asterisk03'
    ),
);
const SvgAtSign = iconLazy(
  () =>
    import(
      /* webpackChunkName: "ua-icons-SvgAtSign" */ '../../components/outline/AtSign'
    ),
);
const SvgAttachment01 = iconLazy(
  () =>
    import(
      /* webpackChunkName: "ua-icons-SvgAttachment01" */ '../../components/outline/Attachment01'
    ),
);
const SvgAudience = iconLazy(
  () =>
    import(
      /* webpackChunkName: "ua-icons-SvgAudience" */ '../../components/outline/Audience'
    ),
);
const SvgAudio = iconLazy(
  () =>
    import(
      /* webpackChunkName: "ua-icons-SvgAudio" */ '../../components/colored/Audio'
    ),
);
const SvgAuthByUnifyapps = iconLazy(
  () =>
    import(
      /* webpackChunkName: "ua-icons-SvgAuthByUnifyapps" */ '../..//components/outline/AuthByUnifyapps'
    ),
);
const SvgAutomations = iconLazy(
  () =>
    import(
      /* webpackChunkName: "ua-icons-SvgAutomations" */ '../../components/outline/Automations'
    ),
);
const SvgAvi = iconLazy(
  () =>
    import(
      /* webpackChunkName: "ua-icons-SvgAvi" */ '../../components/colored/Avi'
    ),
);
const SvgAward01 = iconLazy(
  () =>
    import(
      /* webpackChunkName: "ua-icons-SvgAward01" */ '../../components/outline/Award01'
    ),
);
const SvgAward05 = iconLazy(
  () =>
    import(
      /* webpackChunkName: "ua-icons-SvgAward05" */ '../../components/outline/Award05'
    ),
);
const SvgAzure = iconLazy(
  () =>
    import(
      /* webpackChunkName: "ua-icons-SvgAzure" */ '../../components/colored/Azure'
    ),
);
const SvgBankNote01 = iconLazy(
  () =>
    import(
      /* webpackChunkName: "ua-icons-SvgBankNote01" */ '../../components/outline/BankNote01'
    ),
);
const SvgBankNote02 = iconLazy(
  () =>
    import(
      /* webpackChunkName: "ua-icons-SvgBankNote02" */ '../../components/outline/BankNote02'
    ),
);
const SvgBarChart01 = iconLazy(
  () =>
    import(
      /* webpackChunkName: "ua-icons-SvgBarChart01" */ '../../components/outline/BarChart01'
    ),
);
const SvgBarChartSquare = iconLazy(
  () =>
    import(
      /* webpackChunkName: "ua-icons-SvgBarChartSquare" */ '../../components/outline/BarChartSquare'
    ),
);
const SvgBarChartSquareSolid = iconLazy(
  () =>
    import(
      /* webpackChunkName: "ua-icons-SvgBarChartSquareSolid" */ '../../components/solid/BarChartSquareSolid'
    ),
);
const SvgBarLineChart = iconLazy(
  () =>
    import(
      /* webpackChunkName: "ua-icons-SvgBarLineChart" */ '../../components/outline/BarLineChart'
    ),
);
const SvgBeaker01 = iconLazy(
  () =>
    import(
      /* webpackChunkName: "ua-icons-SvgBeaker01" */ '../../components/outline/Beaker01'
    ),
);
const SvgBell = iconLazy(
  () =>
    import(
      /* webpackChunkName: "ua-icons-SvgBell" */ '../../components/solid/Bell'
    ),
);
const SvgBike01 = iconLazy(
  () =>
    import(
      /* webpackChunkName: "ua-icons-SvgBike01" */ '../../components/outline/Bike01'
    ),
);
const SvgBolt = iconLazy(
  () =>
    import(
      /* webpackChunkName: "ua-icons-SvgBolt" */ '../../components/outline/Bolt'
    ),
);
const SvgBookClosed = iconLazy(
  () =>
    import(
      /* webpackChunkName: "ua-icons-SvgBookClosed" */ '../../components/outline/BookClosed'
    ),
);
const SvgBookOpen01 = iconLazy(
  () =>
    import(
      /* webpackChunkName: "ua-icons-SvgBookOpen01" */ '../../components/outline/BookOpen01'
    ),
);
const SvgBox = iconLazy(
  () =>
    import(
      /* webpackChunkName: "ua-icons-SvgBox" */ '../../components/outline/SvgBox'
    ),
);
const SvgBrackets = iconLazy(
  () =>
    import(
      /* webpackChunkName: "ua-icons-SvgBrackets" */ '../../components/outline/Brackets'
    ),
);
const SvgBracketsPlus = iconLazy(
  () =>
    import(
      /* webpackChunkName: "ua-icons-SvgBracketsPlus" */ '../../components/outline/BracketsPlus'
    ),
);
const SvgBracketsX = iconLazy(
  () =>
    import(
      /* webpackChunkName: "ua-icons-SvgBracketsX" */ '../../components/outline/BracketsX'
    ),
);
const SvgBranching = iconLazy(
  () =>
    import(
      /* webpackChunkName: "ua-icons-SvgBranching" */ '../../components/outline/Branching'
    ),
);
const SvgBranchSolid = iconLazy(
  () =>
    import(
      /* webpackChunkName: "ua-icons-SvgBranchSolid" */ '../../components/solid/BranchSolid'
    ),
);
const SvgBrowserEmitPage = iconLazy(
  () =>
    import(
      /* webpackChunkName: "ua-icons-SvgBrowserEmitPage" */ '../../components/outline/BrowserEmitPage'
    ),
);
const SvgButtonBrand = iconLazy(
  () =>
    import(
      /* webpackChunkName: "ua-icons-SvgButtonBrand" */ '../../components/colored/ButtonBrand'
    ),
);
const SvgCalculator = iconLazy(
  () =>
    import(
      /* webpackChunkName: "ua-icons-SvgCalculator" */ '../../components/outline/Calculator'
    ),
);
const SvgCalculator02 = iconLazy(
  () =>
    import(
      /* webpackChunkName: "ua-icons-SvgCalculator02" */ '../../components/outline/Calculator02'
    ),
);
const SvgCalendar = iconLazy(
  () =>
    import(
      /* webpackChunkName: "ua-icons-SvgCalendar" */ '../../components/outline/Calendar'
    ),
);
const SvgCalendarCheck01 = iconLazy(
  () =>
    import(
      /* webpackChunkName: "ua-icons-SvgCalendarCheck01" */ '../../components/outline/CalendarCheck01'
    ),
);
const SvgCalendarClock = iconLazy(
  () =>
    import(
      /* webpackChunkName: "ua-icons-SvgCalendarClock" */ '../../components/outline/CalendarClock'
    ),
);
const SvgCalendarFilled = iconLazy(
  () =>
    import(
      /* webpackChunkName: "ua-icons-SvgCalendarFilled" */ '../../components/solid/Calendar'
    ),
);
const SvgCalendarMinus01 = iconLazy(
  () =>
    import(
      /* webpackChunkName: "ua-icons-SvgCalendarMinus01" */ '../../components/outline/CalendarMinus01'
    ),
);
const SvgCar02 = iconLazy(
  () =>
    import(
      /* webpackChunkName: "ua-icons-SvgCar02" */ '../../components/outline/Car02'
    ),
);
const SvgCaretRight = iconLazy(
  () =>
    import(
      /* webpackChunkName: "ua-icons-SvgCaretRight" */ '../../components/solid/CaretRight'
    ),
);
const SvgCatalog = iconLazy(
  () =>
    import(
      /* webpackChunkName: "ua-icons-SvgCatalog" */ '../../components/outline/Catalog'
    ),
);
const SvgCeil = iconLazy(
  () =>
    import(
      /* webpackChunkName: "ua-icons-SvgCeil" */ '../../components/outline/Ceil'
    ),
);
const SvgCertificate02 = iconLazy(
  () =>
    import(
      /* webpackChunkName: "ua-icons-SvgCertificate02" */ '../../components/outline/Certificate02'
    ),
);
const SvgChartBreakoutCircle1 = iconLazy(
  () =>
    import(
      /* webpackChunkName: "ua-icons-SvgChartBreakoutCircle1" */ '../../components/outline/ChartBreakoutCircle1'
    ),
);
const SvgChatSolid = iconLazy(
  () =>
    import(
      /* webpackChunkName: "ua-icons-SvgChatSolid" */ '../../components/solid/Chat'
    ),
);
const SvgChatView = iconLazy(
  () =>
    import(
      /* webpackChunkName: "ua-icons-SvgChatView" */ '../../components/outline/ChatView'
    ),
);
const SvgCheck = iconLazy(
  () =>
    import(
      /* webpackChunkName: "ua-icons-SvgCheck" */ '../../components/outline/Check'
    ),
);
const SvgCheckboxGroup = iconLazy(
  () =>
    import(
      /* webpackChunkName: "ua-icons-SvgCheckboxGroup" */ '../../components/solid/CheckboxGroup'
    ),
);
const SvgCheckCircle = iconLazy(
  () =>
    import(
      /* webpackChunkName: "ua-icons-SvgCheckCircle" */ '../../components/outline/CheckCircle'
    ),
);
const SvgCheckDone01 = iconLazy(
  () =>
    import(
      /* webpackChunkName: "ua-icons-SvgCheckDone01" */ '../../components/outline/CheckDone01'
    ),
);
const SvgCheckSlim = iconLazy(
  () =>
    import(
      /* webpackChunkName: "ua-icons-SvgCheckSlim" */ '../../components/outline/CheckSlim'
    ),
);
const SvgCheckSquare = iconLazy(
  () =>
    import(
      /* webpackChunkName: "ua-icons-SvgCheckSquare" */ '../../components/outline/CheckSquare'
    ),
);
const SvgCheckVerified02 = iconLazy(
  () =>
    import(
      /* webpackChunkName: "ua-icons-SvgCheckVerified02" */ '../../components/outline/CheckVerified02'
    ),
);
const SvgChevronLeftSingle = iconLazy(
  () =>
    import(
      /* webpackChunkName: "ua-icons-SvgChevronLeftSingle" */ '../../components/outline/ChevronLeftSingle'
    ),
);
const SvgChevronNarrowRightSm = iconLazy(
  () =>
    import(
      /* webpackChunkName: "ua-icons-SvgChevronNarrowRightSm" */ '../../components/outline/ChevronNarrowRightSm'
    ),
);
const SvgChevronRightSm = iconLazy(
  () =>
    import(
      /* webpackChunkName: "ua-icons-SvgChevronRightSm" */ '../../components/outline/ChevronRightSm'
    ),
);
const SvgCircle = iconLazy(
  () =>
    import(
      /* webpackChunkName: "ua-icons-SvgCircle" */ '../../components/outline/Circle'
    ),
);
const SvgCircleDotted = iconLazy(
  () =>
    import(
      /* webpackChunkName: "ua-icons-SvgCircleDotted" */ '../../components/colored/CircleDotted'
    ),
);
const SvgClapperboardFillSolid = iconLazy(
  () =>
    import(
      /* webpackChunkName: "ua-icons-SvgClapperboardFillSolid" */ '../../components/solid/ClapperboardFillSolid'
    ),
);
const SvgClipboardCheck = iconLazy(
  () =>
    import(
      /* webpackChunkName: "ua-icons-SvgClipboardCheck" */ '../../components/outline/ClipboardCheck'
    ),
);
const SvgClipboardSettings = iconLazy(
  () =>
    import(
      /* webpackChunkName: "ua-icons-SvgClipboardSettings" */ '../../components/outline/ClipboardSettings'
    ),
);
const SvgClock = iconLazy(
  () =>
    import(
      /* webpackChunkName: "ua-icons-SvgClock" */ '../../components/outline/Clock'
    ),
);
const SvgClockCheck = iconLazy(
  () =>
    import(
      /* webpackChunkName: "ua-icons-SvgClockCheck" */ '../../components/outline/ClockCheck'
    ),
);
const SvgClockFastForward = iconLazy(
  () =>
    import(
      /* webpackChunkName: "ua-icons-SvgClockFastForward" */ '../../components/outline/ClockFastForward'
    ),
);
const SvgClockFastForwardSolid = iconLazy(
  () =>
    import(
      /* webpackChunkName: "ua-icons-SvgClockFastForwardSolid" */ '../../components/solid/ClockFastForwardSolid'
    ),
);
const SvgClockRewind = iconLazy(
  () =>
    import(
      /* webpackChunkName: "ua-icons-SvgClockRewind" */ '../../components/outline/ClockRewind'
    ),
);
const SvgClockRewindSolid = iconLazy(
  () =>
    import(
      /* webpackChunkName: "ua-icons-SvgClockRewindSolid" */ '../../components/solid/ClockRewindSolid'
    ),
);
const SvgCode = iconLazy(
  () =>
    import(
      /* webpackChunkName: "ua-icons-SvgCode" */ '../../components/colored/Code'
    ),
);
const SvgCodeBrowser = iconLazy(
  () =>
    import(
      /* webpackChunkName: "ua-icons-SvgCodeBrowser" */ '../../components/outline/CodeBrowser'
    ),
);
const SvgCodeCircle01 = iconLazy(
  () =>
    import(
      /* webpackChunkName: "ua-icons-SvgCodeCircle01" */ '../../components/outline/CodeCircle01'
    ),
);
const SvgCodeSquare02 = iconLazy(
  () =>
    import(
      /* webpackChunkName: "ua-icons-SvgCodeSquare02" */ '../../components/outline/CodeSquare02'
    ),
);
const SvgColors = iconLazy(
  () =>
    import(
      /* webpackChunkName: "ua-icons-SvgColors" */ '../../components/outline/Colors'
    ),
);
const SvgColumns03 = iconLazy(
  () =>
    import(
      /* webpackChunkName: "ua-icons-SvgColumns03" */ '../../components/outline/Columns03'
    ),
);
const SvgControlPushNotifications = iconLazy(
  () =>
    import(
      /* webpackChunkName: "ua-icons-SvgControlPushNotifications" */ '../../components/outline/ControlPushNotifications'
    ),
);
const SvgCopy07 = iconLazy(
  () =>
    import(
      /* webpackChunkName: "ua-icons-SvgCopy07" */ '../../components/outline/Copy07'
    ),
);
const SvgCornerDownLeft = iconLazy(
  () =>
    import(
      /* webpackChunkName: "ua-icons-SvgCornerDownLeft" */ '../../components/outline/CornerDownLeft'
    ),
);
const SvgCornerDownRight = iconLazy(
  () =>
    import(
      /* webpackChunkName: "ua-icons-SvgCornerDownRight" */ '../../components/outline/CornerDownRight'
    ),
);
const SvgCpuChip01 = iconLazy(
  () =>
    import(
      /* webpackChunkName: "ua-icons-SvgCpuChip01" */ '../../components/outline/CpuChip01'
    ),
);
const SvgCreateBranch = iconLazy(
  () =>
    import(
      /* webpackChunkName: "ua-icons-SvgCreateBranch" */ '../../components/outline/CreateBranch'
    ),
);
const SvgCreditCard02 = iconLazy(
  () =>
    import(
      /* webpackChunkName: "ua-icons-SvgCreditCard02" */ '../../components/outline/CreditCard02'
    ),
);
const SvgCreditCardLock = iconLazy(
  () =>
    import(
      /* webpackChunkName: "ua-icons-SvgCreditCardLock" */ '../../components/outline/CreditCardLock'
    ),
);
const SvgCreditCardMinus = iconLazy(
  () =>
    import(
      /* webpackChunkName: "ua-icons-SvgCreditCardMinus" */ '../../components/outline/CreditCardMinus'
    ),
);
const SvgCreditCardPlus = iconLazy(
  () =>
    import(
      /* webpackChunkName: "ua-icons-SvgCreditCardPlus" */ '../../components/outline/CreditCardPlus'
    ),
);
const SvgCryptocurrency01 = iconLazy(
  () =>
    import(
      /* webpackChunkName: "ua-icons-SvgCryptocurrency01" */ '../../components/outline/Cryptocurrency01'
    ),
);
const SvgCss = iconLazy(
  () =>
    import(
      /* webpackChunkName: "ua-icons-SvgCss" */ '../../components/colored/Css'
    ),
);
const SvgCsv = iconLazy(
  () =>
    import(
      /* webpackChunkName: "ua-icons-SvgCsv" */ '../../components/colored/Csv'
    ),
);
const SvgCurrencyDirham = iconLazy(
  () =>
    import(
      /* webpackChunkName: "ua-icons-SvgCurrencyDirham" */ '../../components/outline/CurrencyDirham'
    ),
);
const SvgCurrencyDollar = iconLazy(
  () =>
    import(
      /* webpackChunkName: "ua-icons-SvgCurrencyDollar" */ '../../components/outline/CurrencyDollar'
    ),
);
const SvgCurrencyDollarCircle = iconLazy(
  () =>
    import(
      /* webpackChunkName: "ua-icons-SvgCurrencyDollarCircle" */ '../../components/outline/CurrencyDollarCircle'
    ),
);
const SvgCurrencyEuro = iconLazy(
  () =>
    import(
      /* webpackChunkName: "ua-icons-SvgCurrencyEuro" */ '../../components/outline/CurrencyEuro'
    ),
);
const SvgCurrencyPound = iconLazy(
  () =>
    import(
      /* webpackChunkName: "ua-icons-SvgCurrencyPound" */ '../../components/outline/CurrencyPound'
    ),
);
const SvgCurrencyRuble = iconLazy(
  () =>
    import(
      /* webpackChunkName: "ua-icons-SvgCurrencyRuble" */ '../../components/outline/CurrencyRuble'
    ),
);
const SvgCurrencyRupee = iconLazy(
  () =>
    import(
      /* webpackChunkName: "ua-icons-SvgCurrencyRupee" */ '../../components/outline/CurrencyRupee'
    ),
);
const SvgCurrencyYen = iconLazy(
  () =>
    import(
      /* webpackChunkName: "ua-icons-SvgCurrencyYen" */ '../../components/outline/CurrencyYen'
    ),
);
const SvgDarkTheme = iconLazy(
  () =>
    import(
      /* webpackChunkName: "ua-icons-SvgDarkTheme" */ '../../components/outline/DarkTheme'
    ),
);
const SvgData = iconLazy(
  () =>
    import(
      /* webpackChunkName: "ua-icons-SvgData" */ '../../components/outline/Data'
    ),
);
const SvgDatabase02 = iconLazy(
  () =>
    import(
      /* webpackChunkName: "ua-icons-SvgDatabase02" */ '../../components/outline/Database02'
    ),
);
const SvgDatabase03 = iconLazy(
  () =>
    import(
      /* webpackChunkName: "ua-icons-SvgDatabase03" */ '../../components/outline/Database03'
    ),
);
const SvgDatabase05 = iconLazy(
  () =>
    import(
      /* webpackChunkName: "ua-icons-SvgDatabase05" */ '../../components/outline/Database05'
    ),
);
const SvgDatabaseCylinder = iconLazy(
  () =>
    import(
      /* webpackChunkName: "ua-icons-SvgDatabaseCylinder" */ '../../components/solid/DatabaseCylinder'
    ),
);
const SvgDataflow01 = iconLazy(
  () =>
    import(
      /* webpackChunkName: "ua-icons-SvgDataflow01" */ '../../components/outline/Dataflow01'
    ),
);
const SvgDataNodes = iconLazy(
  () =>
    import(
      /* webpackChunkName: "ua-icons-SvgDataNodes" */ '../../components/solid/DataNodes'
    ),
);
const SvgDeployRestart = iconLazy(
  () =>
    import(
      /* webpackChunkName: "ua-icons-SvgDeployRestart" */ '../../components/outline/DeployRestart'
    ),
);
const SvgDetokenisation = iconLazy(
  () =>
    import(
      /* webpackChunkName: "ua-icons-SvgDetokenisation" */ '../../components/outline/Detokenisation'
    ),
);
const SvgDmg = iconLazy(
  () =>
    import(
      /* webpackChunkName: "ua-icons-SvgDmg" */ '../../components/colored/Dmg'
    ),
);
const SvgDoc = iconLazy(
  () =>
    import(
      /* webpackChunkName: "ua-icons-SvgDoc" */ '../../components/colored/Doc'
    ),
);
const SvgDocument = iconLazy(
  () =>
    import(
      /* webpackChunkName: "ua-icons-SvgDocument" */ '../../components/colored/Document'
    ),
);
const SvgDocumentOpen = iconLazy(
  () =>
    import(
      /* webpackChunkName: "ua-icons-SvgDocumentOpen" */ '../../components/outline/DocumentOpen'
    ),
);
const SvgDocx = iconLazy(
  () =>
    import(
      /* webpackChunkName: "ua-icons-SvgDocx" */ '../../components/colored/Docx'
    ),
);
const SvgDot = iconLazy(
  () =>
    import(
      /* webpackChunkName: "ua-icons-SvgDot" */ '../../components/solid/Dot'
    ),
);
const SvgDottedCircle = iconLazy(
  () =>
    import(
      /* webpackChunkName: "ua-icons-SvgDottedCircle" */ '../../components/outline/DottedCircle'
    ),
);
const SvgDownload01 = iconLazy(
  () =>
    import(
      /* webpackChunkName: "ua-icons-SvgDownload01" */ '../../components/outline/Download01'
    ),
);
const SvgDownloadCloud02 = iconLazy(
  () =>
    import(
      /* webpackChunkName: "ua-icons-SvgDownloadCloud02" */ '../../components/outline/DownloadCloud02'
    ),
);
const SvgEdit03 = iconLazy(
  () =>
    import(
      /* webpackChunkName: "ua-icons-SvgEdit03" */ '../../components/outline/Edit03'
    ),
);
const SvgEmptyBox = iconLazy(
  () =>
    import(
      /* webpackChunkName: "ua-icons-SvgEmptyBox" */ '../../components/colored/EmptyBox'
    ),
);
const SvgEnvironmentVariable = iconLazy(
  () =>
    import(
      /* webpackChunkName: "ua-icons-SvgEnvironmentVariable" */ '../../components/outline/EnvironmentVariable'
    ),
);
const SvgEps = iconLazy(
  () =>
    import(
      /* webpackChunkName: "ua-icons-SvgEps" */ '../../components/colored/Eps'
    ),
);
const SvgEpubs = iconLazy(
  () =>
    import(
      /* webpackChunkName: "ua-icons-SvgEpubs" */ '../../components/colored/Epubs'
    ),
);
const SvgEraser = iconLazy(
  () =>
    import(
      /* webpackChunkName: "ua-icons-SvgEraser" */ '../../components/outline/Eraser'
    ),
);
const SvgErp = iconLazy(
  () =>
    import(
      /* webpackChunkName: "ua-icons-SvgErp" */ '../../components/outline/Erp'
    ),
);
const SvgExe = iconLazy(
  () =>
    import(
      /* webpackChunkName: "ua-icons-SvgExe" */ '../../components/colored/Exe'
    ),
);
const SvgExpand03 = iconLazy(
  () =>
    import(
      /* webpackChunkName: "ua-icons-SvgExpand03" */ '../../components/outline/Expand03'
    ),
);
const SvgExploreAiAgents = iconLazy(
  () =>
    import(
      /* webpackChunkName: "ua-icons-SvgExploreAiAgents" */ '../../components/outline/ExploreAiAgents'
    ),
);
const SvgEye = iconLazy(
  () =>
    import(
      /* webpackChunkName: "ua-icons-SvgEye" */ '../../components/outline/Eye'
    ),
);
const SvgEyeClosed = iconLazy(
  () =>
    import(
      /* webpackChunkName: "ua-icons-SvgEyeClosed" */ '../../components/outline/EyeClosed'
    ),
);
const SvgEyeOff = iconLazy(
  () =>
    import(
      /* webpackChunkName: "ua-icons-SvgEyeOff" */ '../../components/outline/EyeOff'
    ),
);
const SvgFaceId = iconLazy(
  () =>
    import(
      /* webpackChunkName: "ua-icons-SvgFaceId" */ '../../components/outline/FaceId'
    ),
);
const SvgFastBackward = iconLazy(
  () =>
    import(
      /* webpackChunkName: "ua-icons-SvgFastBackward" */ '../../components/outline/FastBackward'
    ),
);
const SvgFastForward = iconLazy(
  () =>
    import(
      /* webpackChunkName: "ua-icons-SvgFastForward" */ '../../components/outline/FastForward'
    ),
);
const SvgFig = iconLazy(
  () =>
    import(
      /* webpackChunkName: "ua-icons-SvgFig" */ '../../components/colored/Fig'
    ),
);
const SvgFigma = iconLazy(
  () =>
    import(
      /* webpackChunkName: "ua-icons-SvgFigma" */ '../../components/colored/Figma'
    ),
);
const SvgFile02 = iconLazy(
  () =>
    import(
      /* webpackChunkName: "ua-icons-SvgFile02" */ '../../components/outline/File02'
    ),
);
const SvgFile08 = iconLazy(
  () =>
    import(
      /* webpackChunkName: "ua-icons-SvgFile08" */ '../../components/outline/File08'
    ),
);
const SvgFileCheck02 = iconLazy(
  () =>
    import(
      /* webpackChunkName: "ua-icons-SvgFileCheck02" */ '../../components/outline/FileCheck02'
    ),
);
const SvgFileCheck03 = iconLazy(
  () =>
    import(
      /* webpackChunkName: "ua-icons-SvgFileCheck03" */ '../../components/outline/FileCheck03'
    ),
);
const SvgFileCode01 = iconLazy(
  () =>
    import(
      /* webpackChunkName: "ua-icons-SvgFileCode01" */ '../../components/outline/FileCode01'
    ),
);
const SvgFileCode01Solid = iconLazy(
  () =>
    import(
      /* webpackChunkName: "ua-icons-SvgFileCode01Solid" */ '../../components/solid/FileCode01'
    ),
);
const SvgFileEdit = iconLazy(
  () =>
    import(
      /* webpackChunkName: "ua-icons-SvgFileEdit" */ '../../components/outline/FileEdit'
    ),
);
const SvgFileLock02 = iconLazy(
  () =>
    import(
      /* webpackChunkName: "ua-icons-SvgFileLock02" */ '../../components/outline/FileLock02'
    ),
);
const SvgFileSearch02 = iconLazy(
  () =>
    import(
      /* webpackChunkName: "ua-icons-SvgFileSearch02" */ '../../components/outline/FileSearch02'
    ),
);
const SvgFileXls = iconLazy(
  () =>
    import(
      /* webpackChunkName: "ua-icons-SvgFileXls" */ '../../components/outline/FileXls'
    ),
);
const SvgFill = iconLazy(
  () =>
    import(
      /* webpackChunkName: "ua-icons-SvgFill" */ '../../components/outline/Fill'
    ),
);
const SvgFilterFunnel01 = iconLazy(
  () =>
    import(
      /* webpackChunkName: "ua-icons-SvgFilterFunnel01" */ '../../components/outline/FilterFunnel01'
    ),
);
const SvgFilterFunnel02 = iconLazy(
  () =>
    import(
      /* webpackChunkName: "ua-icons-SvgFilterFunnel02" */ '../../components/outline/FilterFunnel02'
    ),
);
const SvgFingerprint04 = iconLazy(
  () =>
    import(
      /* webpackChunkName: "ua-icons-SvgFingerprint04" */ '../../components/outline/Fingerprint04'
    ),
);
const SvgFlag01 = iconLazy(
  () =>
    import(
      /* webpackChunkName: "ua-icons-SvgFlag01" */ '../../components/outline/Flag01'
    ),
);
const SvgFlagged = iconLazy(
  () =>
    import(
      /* webpackChunkName: "ua-icons-SvgFlagged" */ '../../components/colored/Flagged'
    ),
);
const SvgFloor = iconLazy(
  () =>
    import(
      /* webpackChunkName: "ua-icons-SvgFloor" */ '../../components/outline/Floor'
    ),
);
const SvgFlowChart = iconLazy(
  () =>
    import(
      /* webpackChunkName: "ua-icons-SvgFlowChart" */ '../../components/solid/FlowChart'
    ),
);
const SvgFolder = iconLazy(
  () =>
    import(
      /* webpackChunkName: "ua-icons-SvgFolder" */ '../../components/colored/Folder'
    ),
);
const SvgFolder02 = iconLazy(
  () =>
    import(
      /* webpackChunkName: "ua-icons-SvgFolder02" */ '../../components/outline/Folder02'
    ),
);
const SvgFolder02Solid = iconLazy(
  () =>
    import(
      /* webpackChunkName: "ua-icons-SvgFolder02Solid" */ '../../components/solid/Folder02'
    ),
);
const SvgFolderCheck = iconLazy(
  () =>
    import(
      /* webpackChunkName: "ua-icons-SvgFolderCheck" */ '../../components/outline/FolderCheck'
    ),
);
const SvgFolderClosed = iconLazy(
  () =>
    import(
      /* webpackChunkName: "ua-icons-SvgFolderClosed" */ '../../components/colored/FolderClosed'
    ),
);
const SvgFolderMinus = iconLazy(
  () =>
    import(
      /* webpackChunkName: "ua-icons-SvgFolderMinus" */ '../../components/outline/FolderMinus'
    ),
);
const SvgFolderOpen = iconLazy(
  () =>
    import(
      /* webpackChunkName: "ua-icons-SvgFolderOpen" */ '../../components/colored/FolderOpen'
    ),
);
const SvgFolderPlus = iconLazy(
  () =>
    import(
      /* webpackChunkName: "ua-icons-SvgFolderPlus" */ '../../components/outline/FolderPlus'
    ),
);
const SvgFolderQuestion = iconLazy(
  () =>
    import(
      /* webpackChunkName: "ua-icons-SvgFolderQuestion" */ '../../components/outline/FolderQuestion'
    ),
);
const SvgFolderSolid = iconLazy(
  () =>
    import(
      /* webpackChunkName: "ua-icons-SvgFolderSolid" */ '../../components/solid/FolderSolid'
    ),
);
const SvgFolderX = iconLazy(
  () =>
    import(
      /* webpackChunkName: "ua-icons-SvgFolderX" */ '../../components/outline/FolderX'
    ),
);
const SvgForwardArrow = iconLazy(
  () =>
    import(
      /* webpackChunkName: "ua-icons-SvgForwardArrow" */ '../../components/outline/ForwardArrow'
    ),
);
const SvgFunction = iconLazy(
  () =>
    import(
      /* webpackChunkName: "ua-icons-SvgFunction" */ '../../components/outline/Function'
    ),
);
const SvgFunctions = iconLazy(
  () =>
    import(
      /* webpackChunkName: "ua-icons-SvgFunctions" */ '../../components/outline/Functions'
    ),
);
const SvgGear = iconLazy(
  () =>
    import(
      /* webpackChunkName: "ua-icons-SvgGear" */ '../../components/solid/Gear'
    ),
);
const SvgGif = iconLazy(
  () =>
    import(
      /* webpackChunkName: "ua-icons-SvgGif" */ '../../components/colored/Gif'
    ),
);
const SvgGoogle = iconLazy(
  () =>
    import(
      /* webpackChunkName: "ua-icons-SvgGoogle" */ '../../components/colored/Google'
    ),
);
const SvgGoogleChrome = iconLazy(
  () =>
    import(
      /* webpackChunkName: "ua-icons-SvgGoogleChrome" */ '../../components/colored/GoogleChrome'
    ),
);
const SvgGoogleDoc = iconLazy(
  () =>
    import(
      /* webpackChunkName: "ua-icons-SvgGoogleDoc" */ '../../components/colored/GoogleDoc'
    ),
);
const SvgGoogleDocs = iconLazy(
  () =>
    import(
      /* webpackChunkName: "ua-icons-SvgGoogleDocs" */ '../../components/colored/GoogleDocs'
    ),
);
const SvgGoogleMeet = iconLazy(
  () =>
    import(
      /* webpackChunkName: "ua-icons-SvgGoogleMeet" */ '../../components/colored/GoogleMeet'
    ),
);
const SvgGoogleSheets = iconLazy(
  () =>
    import(
      /* webpackChunkName: "ua-icons-SvgGoogleSheets" */ '../../components/colored/GoogleSheets'
    ),
);
const SvgGoogleSlides = iconLazy(
  () =>
    import(
      /* webpackChunkName: "ua-icons-SvgGoogleSlides" */ '../../components/colored/GoogleSlides'
    ),
);
const SvgGraduationHat01 = iconLazy(
  () =>
    import(
      /* webpackChunkName: "ua-icons-SvgGraduationHat01" */ '../../components/outline/GraduationHat01'
    ),
);
const SvgGraduationHat01Solid = iconLazy(
  () =>
    import(
      /* webpackChunkName: "ua-icons-SvgGraduationHat01Solid" */ '../../components/solid/GraduationHat01Solid'
    ),
);
const SvgGrid01 = iconLazy(
  () =>
    import(
      /* webpackChunkName: "ua-icons-SvgGrid01" */ '../../components/outline/Grid01'
    ),
);
const SvgGrid01Solid = iconLazy(
  () =>
    import(
      /* webpackChunkName: "ua-icons-SvgGrid01Solid" */ '../../components/solid/Grid01'
    ),
);
const SvgGrid03 = iconLazy(
  () =>
    import(
      /* webpackChunkName: "ua-icons-SvgGrid03" */ '../../components/solid/Grid03'
    ),
);
const SvgGridAdd = iconLazy(
  () =>
    import(
      /* webpackChunkName: "ua-icons-SvgGridAdd" */ '../../components/solid/GridAdd'
    ),
);
const SvgGridCompact = iconLazy(
  () =>
    import(
      /* webpackChunkName: "ua-icons-SvgGridCompact" */ '../../components/outline/GridCompact'
    ),
);
const SvgGridPlus = iconLazy(
  () =>
    import(
      /* webpackChunkName: "ua-icons-SvgGridPlus" */ '../../components/outline/GridPlus'
    ),
);
const SvgGroovyLanguage = iconLazy(
  () =>
    import(
      /* webpackChunkName: "ua-icons-SvgGroovyLanguage" */ '../../components/outline/GroovyLanguage'
    ),
);
const SvgHanger = iconLazy(
  () =>
    import(
      /* webpackChunkName: "ua-icons-SvgHanger" */ '../../components/outline/Hanger'
    ),
);
const SvgHierarchySolid = iconLazy(
  () =>
    import(
      /* webpackChunkName: "ua-icons-SvgHierarchySolid" */ '../../components/outline/HierarchySolid'
    ),
);
const SvgHighlighter = iconLazy(
  () =>
    import(
      /* webpackChunkName: "ua-icons-SvgHighlighter" */ '../../components/outline/Highlighter'
    ),
);
const SvgHtml = iconLazy(
  () =>
    import(
      /* webpackChunkName: "ua-icons-SvgHtml" */ '../../components/colored/Html'
    ),
);
const SvgHubspot = iconLazy(
  () =>
    import(
      /* webpackChunkName: "ua-icons-SvgHubspot" */ '../../components/colored/Hubspot'
    ),
);
const SvgHumanize = iconLazy(
  () =>
    import(
      /* webpackChunkName: "ua-icons-SvgHumanize" */ '../../components/outline/Humanize'
    ),
);
const SvgImage = iconLazy(
  () =>
    import(
      /* webpackChunkName: "ua-icons-SvgImage" */ '../../components/colored/Image'
    ),
);
const SvgImage01 = iconLazy(
  () =>
    import(
      /* webpackChunkName: "ua-icons-SvgImage01" */ '../../components/colored/file/Image'
    ),
);
const SvgImg = iconLazy(
  () =>
    import(
      /* webpackChunkName: "ua-icons-SvgImg" */ '../../components/colored/Img'
    ),
);
const SvgIndd = iconLazy(
  () =>
    import(
      /* webpackChunkName: "ua-icons-SvgIndd" */ '../../components/colored/Indd'
    ),
);
const SvgInfoSquare = iconLazy(
  () =>
    import(
      /* webpackChunkName: "ua-icons-SvgInfoSquare" */ '../../components/outline/InfoSquare'
    ),
);
const SvgInputSolid = iconLazy(
  () =>
    import(
      /* webpackChunkName: "ua-icons-SvgInputSolid" */ '../../components/colored/InputSolid'
    ),
);
const SvgJava = iconLazy(
  () =>
    import(
      /* webpackChunkName: "ua-icons-SvgJava" */ '../../components/colored/Java'
    ),
);
const SvgJavaLanguage = iconLazy(
  () =>
    import(
      /* webpackChunkName: "ua-icons-SvgJavaLanguage" */ '../../components/outline/JavaLanguage'
    ),
);
const SvgJpeg = iconLazy(
  () =>
    import(
      /* webpackChunkName: "ua-icons-SvgJpeg" */ '../../components/colored/Jpeg'
    ),
);
const SvgJpg = iconLazy(
  () =>
    import(
      /* webpackChunkName: "ua-icons-SvgJpg" */ '../../components/colored/Jpg'
    ),
);
const SvgJs = iconLazy(
  () =>
    import(
      /* webpackChunkName: "ua-icons-SvgJs" */ '../../components/colored/Js'
    ),
);
const SvgJsLanguage = iconLazy(
  () =>
    import(
      /* webpackChunkName: "ua-icons-SvgJsLanguage" */ '../../components/outline/JsLanguage'
    ),
);
const SvgJson = iconLazy(
  () =>
    import(
      /* webpackChunkName: "ua-icons-SvgJson" */ '../../components/colored/Json'
    ),
);
const SvgJsonLanguage = iconLazy(
  () =>
    import(
      /* webpackChunkName: "ua-icons-SvgJsonLanguage" */ '../../components/outline/JsonLanguage'
    ),
);
const SvgJsonSchemaLanguage = iconLazy(
  () =>
    import(
      /* webpackChunkName: "ua-icons-SvgJsonSchemaLanguage" */ '../../components/outline/JsonSchemaLanguage'
    ),
);
const SvgJwtValidation = iconLazy(
  () =>
    import(
      /* webpackChunkName: "ua-icons-SvgJwtValidation" */ '../../components/outline/JwtValidation'
    ),
);
const SvgKey01 = iconLazy(
  () =>
    import(
      /* webpackChunkName: "ua-icons-SvgKey01" */ '../../components/outline/Key01'
    ),
);
const SvgLayers = iconLazy(
  () =>
    import(
      /* webpackChunkName: "ua-icons-SvgLayers" */ '../../components/outline/Layers'
    ),
);
const SvgLayersStack = iconLazy(
  () =>
    import(
      /* webpackChunkName: "ua-icons-SvgLayersStack" */ '../../components/solid/LayersStack'
    ),
);
const SvgLayoutAlt01 = iconLazy(
  () =>
    import(
      /* webpackChunkName: "ua-icons-SvgLayoutAlt01" */ '../../components/solid/LayoutAlt01'
    ),
);
const SvgLayoutGrid02 = iconLazy(
  () =>
    import(
      /* webpackChunkName: "ua-icons-SvgLayoutGrid02" */ '../../components/outline/LayoutGrid02'
    ),
);
const SvgLayoutTop = iconLazy(
  () =>
    import(
      /* webpackChunkName: "ua-icons-SvgLayoutTop" */ '../../components/outline/LayoutTop'
    ),
);
const SvgLcCard = iconLazy(
  () =>
    import(
      /* webpackChunkName: "ua-icons-SvgLcCard" */ '../../components/outline/LcCard'
    ),
);
const SvgLcContainer = iconLazy(
  () =>
    import(
      /* webpackChunkName: "ua-icons-SvgLcContainer" */ '../../components/outline/LcContainer'
    ),
);
const SvgLcContainer02 = iconLazy(
  () =>
    import(
      /* webpackChunkName: "ua-icons-SvgLcContainer02" */ '../../components/outline/LcContainer02'
    ),
);
const SvgLcCopilot = iconLazy(
  () =>
    import(
      /* webpackChunkName: "ua-icons-SvgLcCopilot" */ '../../components/colored/LcCopilot'
    ),
);
const SvgLcIcon = iconLazy(
  () =>
    import(
      /* webpackChunkName: "ua-icons-SvgLcIcon" */ '../../components/outline/LcIcon'
    ),
);
const SvgLcIconButton = iconLazy(
  () =>
    import(
      /* webpackChunkName: "ua-icons-SvgLcIconButton" */ '../../components/outline/LcIconButton'
    ),
);
const SvgLcLink = iconLazy(
  () =>
    import(
      /* webpackChunkName: "ua-icons-SvgLcLink" */ '../../components/outline/LcLink'
    ),
);
const SvgLcProgressBar = iconLazy(
  () =>
    import(
      /* webpackChunkName: "ua-icons-SvgLcProgressBar" */ '../../components/outline/LcProgressBar'
    ),
);
const SvgLcSectionColumn = iconLazy(
  () =>
    import(
      /* webpackChunkName: "ua-icons-SvgLcSectionColumn" */ '../../components/outline/LcSectionColumn'
    ),
);
const SvgLcSheets = iconLazy(
  () =>
    import(
      /* webpackChunkName: "ua-icons-SvgLcSheets" */ '../../components/outline/LcSheets'
    ),
);
const SvgLcTimeline = iconLazy(
  () =>
    import(
      /* webpackChunkName: "ua-icons-SvgLcTimeline" */ '../../components/outline/LcTimeline'
    ),
);
const SvgLdap = iconLazy(
  () =>
    import(
      /* webpackChunkName: "ua-icons-SvgLdap" */ '../../components/colored/Ldap'
    ),
);
const SvgLibrary = iconLazy(
  () =>
    import(
      /* webpackChunkName: "ua-icons-SvgLibrary" */ '../../components/outline/Library'
    ),
);
const SvgLightbulb02 = iconLazy(
  () =>
    import(
      /* webpackChunkName: "ua-icons-SvgLightbulb02" */ '../../components/outline/Lightbulb02'
    ),
);
const SvgLightbulb03 = iconLazy(
  () =>
    import(
      /* webpackChunkName: "ua-icons-SvgLightbulb03" */ '../../components/outline/Lightbulb03'
    ),
);
const SvgLightbulb05 = iconLazy(
  () =>
    import(
      /* webpackChunkName: "ua-icons-SvgLightbulb05" */ '../../components/outline/Lightbulb05'
    ),
);
const SvgLineChartDown01 = iconLazy(
  () =>
    import(
      /* webpackChunkName: "ua-icons-SvgLineChartDown01" */ '../../components/outline/LineChartDown01'
    ),
);
const SvgLineChartUp03 = iconLazy(
  () =>
    import(
      /* webpackChunkName: "ua-icons-SvgLineChartUp03" */ '../../components/outline/LineChartUp03'
    ),
);
const SvgLink01 = iconLazy(
  () =>
    import(
      /* webpackChunkName: "ua-icons-SvgLink01" */ '../../components/outline/Link01'
    ),
);
const SvgLinkHorizontal = iconLazy(
  () =>
    import(
      /* webpackChunkName: "ua-icons-SvgLinkHorizontal" */ '../../components/outline/LinkHorizontal'
    ),
);
const SvgList = iconLazy(
  () =>
    import(
      /* webpackChunkName: "ua-icons-SvgList" */ '../../components/outline/List'
    ),
);
const SvgListCheck = iconLazy(
  () =>
    import(
      /* webpackChunkName: "ua-icons-SvgListCheck" */ '../../components/outline/ListCheck'
    ),
);
const SvgLoading01 = iconLazy(
  () =>
    import(
      /* webpackChunkName: "ua-icons-SvgLoading01" */ '../../components/outline/Loading01'
    ),
);
const SvgLocalStorage = iconLazy(
  () =>
    import(
      /* webpackChunkName: "ua-icons-SvgLocalStorage" */ '../../components/outline/LocalStorage'
    ),
);
const SvgLocation = iconLazy(
  () =>
    import(
      /* webpackChunkName: "ua-icons-SvgLocation" */ '../../components/outline/Location'
    ),
);
const SvgLock01 = iconLazy(
  () =>
    import(
      /* webpackChunkName: "ua-icons-SvgLock01" */ '../../components/outline/Lock01'
    ),
);
const SvgLoop = iconLazy(
  () =>
    import(
      /* webpackChunkName: "ua-icons-SvgLoop" */ '../../components/outline/Loop'
    ),
);
const SvgLowercase = iconLazy(
  () =>
    import(
      /* webpackChunkName: "ua-icons-SvgLowercase" */ '../../components/outline/Lowercase'
    ),
);
const SvgMagicWand = iconLazy(
  () =>
    import(
      /* webpackChunkName: "ua-icons-SvgMagicWand" */ '../../components/solid/MagicWand'
    ),
);
const SvgMagicWand01 = iconLazy(
  () =>
    import(
      /* webpackChunkName: "ua-icons-SvgMagicWand01" */ '../../components/outline/MagicWand01'
    ),
);
const SvgMapEdge = iconLazy(
  () =>
    import(
      /* webpackChunkName: "ua-icons-SvgMapEdge" */ '../../components/outline/MapEdge'
    ),
);
const SvgMapNode = iconLazy(
  () =>
    import(
      /* webpackChunkName: "ua-icons-SvgMapNode" */ '../../components/outline/MapNode'
    ),
);
const SvgMarginVertical = iconLazy(
  () =>
    import(
      /* webpackChunkName: "ua-icons-SvgMarginVertical" */ '../../components/outline/MarginVertical'
    ),
);
const SvgMarkerPin01 = iconLazy(
  () =>
    import(
      /* webpackChunkName: "ua-icons-SvgMarkerPin01" */ '../../components/outline/MarkerPin01'
    ),
);
const SvgMaximize01 = iconLazy(
  () =>
    import(
      /* webpackChunkName: "ua-icons-SvgMaximize01" */ '../../components/outline/Maximize01'
    ),
);
const SvgMedicalCross = iconLazy(
  () =>
    import(
      /* webpackChunkName: "ua-icons-SvgMedicalCross" */ '../../components/outline/MedicalCross'
    ),
);
const SvgMessageChatSquare = iconLazy(
  () =>
    import(
      /* webpackChunkName: "ua-icons-SvgMessageChatSquare" */ '../../components/outline/MessageChatSquare'
    ),
);
const SvgMessageHeartSquare = iconLazy(
  () =>
    import(
      /* webpackChunkName: "ua-icons-SvgMessageHeartSquare" */ '../../components/outline/MessageHeartSquare'
    ),
);
const SvgMessageSquare02 = iconLazy(
  () =>
    import(
      /* webpackChunkName: "ua-icons-SvgMessageSquare02" */ '../../components/outline/MessageSquare02'
    ),
);
const SvgMessageTextSquare01 = iconLazy(
  () =>
    import(
      /* webpackChunkName: "ua-icons-SvgMessageTextSquare01" */ '../../components/outline/MessageTextSquare01'
    ),
);
const SvgMicrosoft = iconLazy(
  () =>
    import(
      /* webpackChunkName: "ua-icons-SvgMicrosoft" */ '../../components/colored/Microsoft'
    ),
);
const SvgMicrosoftTeams = iconLazy(
  () =>
    import(
      /* webpackChunkName: "ua-icons-SvgMicrosoftTeams" */ '../../components/colored/MicrosoftTeams'
    ),
);
const SvgMinimize01 = iconLazy(
  () =>
    import(
      /* webpackChunkName: "ua-icons-SvgMinimize01" */ '../../components/outline/Minimize01'
    ),
);
const SvgModified = iconLazy(
  () =>
    import(
      /* webpackChunkName: "ua-icons-SvgModified" */ '../../components/outline/Modified'
    ),
);
const SvgMonitor01Solid = iconLazy(
  () =>
    import(
      /* webpackChunkName: "ua-icons-SvgMonitor01Solid" */ '../../components/solid/Monitor01'
    ),
);
const SvgMonitoringExperiment = iconLazy(
  () =>
    import(
      /* webpackChunkName: "ua-icons-SvgMonitoringExperiment" */ '../../components/outline/MonitoringExperiment'
    ),
);
const SvgMoon01 = iconLazy(
  () =>
    import(
      /* webpackChunkName: "ua-icons-SvgMoon01" */ '../../components/outline/Moon01'
    ),
);
const SvgMoon01Solid = iconLazy(
  () =>
    import(
      /* webpackChunkName: "ua-icons-SvgMoon01Solid" */ '../../components/solid/Moon01'
    ),
);
const SvgMove = iconLazy(
  () =>
    import(
      /* webpackChunkName: "ua-icons-SvgMove" */ '../../components/outline/Move'
    ),
);
const SvgMozillaFirefox = iconLazy(
  () =>
    import(
      /* webpackChunkName: "ua-icons-SvgMozillaFirefox" */ '../../components/colored/MozillaFirefox'
    ),
);
const SvgMp3 = iconLazy(
  () =>
    import(
      /* webpackChunkName: "ua-icons-SvgMp3" */ '../../components/colored/Mp3'
    ),
);
const SvgMp4 = iconLazy(
  () =>
    import(
      /* webpackChunkName: "ua-icons-SvgMp4" */ '../../components/colored/Mp4'
    ),
);
const SvgMpeg = iconLazy(
  () =>
    import(
      /* webpackChunkName: "ua-icons-SvgMpeg" */ '../../components/colored/Mpeg'
    ),
);
const SvgMqtt = iconLazy(
  () =>
    import(
      /* webpackChunkName: "ua-icons-SvgMqtt" */ '../../components/outline/Mqtt'
    ),
);
const SvgMultiSelect = iconLazy(
  () =>
    import(
      /* webpackChunkName: "ua-icons-SvgMultiSelect" */ '../../components/outline/MultiSelect'
    ),
);
const SvgNavigationMenu = iconLazy(
  () =>
    import(
      /* webpackChunkName: "ua-icons-SvgNavigationMenu" */ '../../components/outline/NavigationMenu'
    ),
);
const SvgNoCodeBottomsheet = iconLazy(
  () =>
    import(
      /* webpackChunkName: "ua-icons-SvgNoCodeBottomsheet" */ '../../components/outline/no-code/NoCodeBottomsheet'
    ),
);
const SvgNoCodeCascader = iconLazy(
  () =>
    import(
      /* webpackChunkName: "ua-icons-SvgNoCodeCascader" */ '../../components/outline/no-code/NoCodeCascader'
    ),
);
const SvgNoCodeColorCascader = iconLazy(
  () =>
    import(
      /* webpackChunkName: "ua-icons-SvgNoCodeColorCascader" */ '../../components/colored/no-code/NoCodeColorCascader'
    ),
);
const SvgNoCodeColorCheckbox = iconLazy(
  () =>
    import(
      /* webpackChunkName: "ua-icons-SvgNoCodeColorCheckbox" */ '../../components/colored/no-code/NoCodeColorCheckbox'
    ),
);
const SvgNoCodeColorEventsTimeline = iconLazy(
  () =>
    import(
      /* webpackChunkName: "ua-icons-SvgNoCodeColorEventsTimeline" */ '../../components/colored/no-code/NoCodeColorEventsTimeline'
    ),
);
const SvgNoCodeColorFloatingActionbutton = iconLazy(
  () =>
    import(
      /* webpackChunkName: "ua-icons-SvgNoCodeColorFloatingActionbutton" */ '../../components/colored/no-code/NoCodeColorFloatingActionbutton'
    ),
);
const SvgNoCodeColorImageGrid = iconLazy(
  () =>
    import(
      /* webpackChunkName: "ua-icons-SvgNoCodeColorImageGrid" */ '../../components/colored/no-code/NoCodeColorImageGrid'
    ),
);
const SvgNoCodeColorLottieAnimation = iconLazy(
  () =>
    import(
      /* webpackChunkName: "ua-icons-SvgNoCodeColorLottieAnimation" */ '../../components/colored/no-code/NoCodeColorLottieAnimation'
    ),
);
const SvgNoCodeColorModule = iconLazy(
  () =>
    import(
      /* webpackChunkName: "ua-icons-SvgNoCodeColorModule" */ '../../components/colored/no-code/NoCodeColorModule'
    ),
);
const SvgNoCodeColorOrgChart = iconLazy(
  () =>
    import(
      /* webpackChunkName: "ua-icons-SvgNoCodeColorOrgChart" */ '../../components/colored/no-code/NoCodeColorOrgChart'
    ),
);
const SvgNoCodeColorSheetPreview = iconLazy(
  () =>
    import(
      /* webpackChunkName: "ua-icons-SvgNoCodeColorSheetPreview" */ '../../components/colored/no-code/NoCodeColorSheetPreview'
    ),
);
const SvgNoCodeColorToggle = iconLazy(
  () =>
    import(
      /* webpackChunkName: "ua-icons-SvgNoCodeColorToggle" */ '../../components/colored/no-code/NoCodeColorToggle'
    ),
);
const SvgNoCodeCustomIcons = iconLazy(
  () =>
    import(
      /* webpackChunkName: "ua-icons-SvgNoCodeCustomIcons" */ '../../components/colored/NoCodeCustomIcons'
    ),
);
const SvgNoCodeDesign = iconLazy(
  () =>
    import(
      /* webpackChunkName: "ua-icons-SvgNoCodeDesign" */ '../../components/outline/no-code/NoCodeDesign'
    ),
);
const SvgNoCodeEventsTimeline = iconLazy(
  () =>
    import(
      /* webpackChunkName: "ua-icons-SvgNoCodeEventsTimeline" */ '../../components/outline/no-code/NoCodeEventsTimeline'
    ),
);
const SvgNoCodeFloatingActionbutton = iconLazy(
  () =>
    import(
      /* webpackChunkName: "ua-icons-SvgNoCodeFloatingActionbutton" */ '../../components/outline/no-code/NoCodeFloatingActionbutton'
    ),
);
const SvgNoCodeFolderClose = iconLazy(
  () =>
    import(
      /* webpackChunkName: "ua-icons-SvgNoCodeFolderClose" */ '../../components/colored/no-code/NoCodeFolderClose'
    ),
);
const SvgNoCodeFolderOpen = iconLazy(
  () =>
    import(
      /* webpackChunkName: "ua-icons-SvgNoCodeFolderOpen" */ '../../components/colored/no-code/NoCodeFolderOpen'
    ),
);
const SvgNoCodeFolderPlus = iconLazy(
  () =>
    import(
      /* webpackChunkName: "ua-icons-SvgNoCodeFolderPlus" */ '../../components/outline/no-code/NoCodeFolderPlus'
    ),
);
const SvgNoCodeForm = iconLazy(
  () =>
    import(
      /* webpackChunkName: "ua-icons-SvgNoCodeForm" */ '../../components/outline/no-code/NoCodeForm'
    ),
);
const SvgNoCodeImageGrid = iconLazy(
  () =>
    import(
      /* webpackChunkName: "ua-icons-SvgNoCodeImageGrid" */ '../../components/outline/no-code/NoCodeImageGrid'
    ),
);
const SvgNoCodeLottieAnimation = iconLazy(
  () =>
    import(
      /* webpackChunkName: "ua-icons-SvgNoCodeLottieAnimation" */ '../../components/outline/no-code/NoCodeLottieAnimation'
    ),
);
const SvgNoCodeModulePlus = iconLazy(
  () =>
    import(
      /* webpackChunkName: "ua-icons-SvgNoCodeModulePlus" */ '../../components/outline/no-code/NoCodeModulePlus'
    ),
);
const SvgNoCodeNavigatorActive = iconLazy(
  () =>
    import(
      /* webpackChunkName: "ua-icons-SvgNoCodeNavigatorActive" */ '../../components/outline/no-code/NoCodeNavigatorActive'
    ),
);
const SvgNoCodeOrgChart = iconLazy(
  () =>
    import(
      /* webpackChunkName: "ua-icons-SvgNoCodeOrgChart" */ '../../components/outline/no-code/NoCodeOrgChart'
    ),
);
const SvgNoCodePage = iconLazy(
  () =>
    import(
      /* webpackChunkName: "ua-icons-SvgNoCodePage" */ '../../components/outline/no-code/NoCodePage'
    ),
);
const SvgNoCodePagePlus = iconLazy(
  () =>
    import(
      /* webpackChunkName: "ua-icons-SvgNoCodePagePlus" */ '../../components/outline/no-code/NoCodePagePlus'
    ),
);
const SvgNoCodeSheetPreview = iconLazy(
  () =>
    import(
      /* webpackChunkName: "ua-icons-SvgNoCodeSheetPreview" */ '../../components/outline/no-code/NoCodeSheetPreview'
    ),
);
const SvgNoCodeSideDrawer = iconLazy(
  () =>
    import(
      /* webpackChunkName: "ua-icons-SvgNoCodeSideDrawer" */ '../../components/outline/no-code/NoCodeSideDrawer'
    ),
);
const SvgNoCodeSlot = iconLazy(
  () =>
    import(
      /* webpackChunkName: "ua-icons-SvgNoCodeSlot" */ '../../components/outline/no-code/NoCodeSlot'
    ),
);
const SvgNoCodeTemplateComponent = iconLazy(
  () =>
    import(
      /* webpackChunkName: "ua-icons-SvgNoCodeTemplateComponent" */ '../../components/outline/no-code/NoCodeTemplateComponent'
    ),
);
const SvgNoCodeUnifyAppsChat = iconLazy(
  () =>
    import(
      /* webpackChunkName: "ua-icons-SvgNoCodeUnifyAppsChat" */ '../../components/colored/NoCodeUnifyappsChat'
    ),
);
const SvgNotification = iconLazy(
  () =>
    import(
      /* webpackChunkName: "ua-icons-SvgNotification" */ '../../components/outline/Bell01'
    ),
);
const SvgNotificationMuted = iconLazy(
  () =>
    import(
      /* webpackChunkName: "ua-icons-SvgNotificationMuted" */ '../../components/outline/BellMuted'
    ),
);
const SvgNotificationText = iconLazy(
  () =>
    import(
      /* webpackChunkName: "ua-icons-SvgNotificationText" */ '../../components/outline/NotificationText'
    ),
);
const SvgOkta = iconLazy(
  () =>
    import(
      /* webpackChunkName: "ua-icons-SvgOkta" */ '../../components/colored/Okta'
    ),
);
const SvgOkta02 = iconLazy(
  () =>
    import(
      /* webpackChunkName: "ua-icons-SvgOkta02" */ '../../components/colored/Okta02'
    ),
);
const SvgOpenFolder = iconLazy(
  () =>
    import(
      /* webpackChunkName: "ua-icons-SvgOpenFolder" */ '../../components/outline/OpenFolder'
    ),
);
const SvgOpenId = iconLazy(
  () =>
    import(
      /* webpackChunkName: "ua-icons-SvgOpenId" */ '../../components/colored/OpenId'
    ),
);
const SvgOtel = iconLazy(
  () =>
    import(
      /* webpackChunkName: "ua-icons-SvgOtel" */ '../../components/solid/Otel'
    ),
);
const SvgOutlineFolder = iconLazy(
  () =>
    import(
      /* webpackChunkName: "ua-icons-SvgOutlineFolder" */ '../../components/outline/Folder'
    ),
);
const SvgPackage = iconLazy(
  () =>
    import(
      /* webpackChunkName: "ua-icons-SvgPackage" */ '../../components/outline/Package'
    ),
);
const SvgPage = iconLazy(
  () =>
    import(
      /* webpackChunkName: "ua-icons-SvgPage" */ '../../components/outline/File04'
    ),
);
const SvgPageVariables = iconLazy(
  () =>
    import(
      /* webpackChunkName: "ua-icons-SvgPageVariables" */ '../../components/outline/PageVariables'
    ),
);
const SvgPaginate = iconLazy(
  () =>
    import(
      /* webpackChunkName: "ua-icons-SvgPaginate" */ '../../components/outline/Paginate'
    ),
);
const SvgPaginateSolid = iconLazy(
  () =>
    import(
      /* webpackChunkName: "ua-icons-SvgPaginateSolid" */ '../../components/outline/PaginateSolid'
    ),
);
const SvgPaintPour = iconLazy(
  () =>
    import(
      /* webpackChunkName: "ua-icons-SvgPaintPour" */ '../../components/outline/PaintPour'
    ),
);
const SvgPaperAirplane = iconLazy(
  () =>
    import(
      /* webpackChunkName: "ua-icons-SvgPaperAirplane" */ '../../components/outline/PaperAirplane'
    ),
);
const SvgPasscode = iconLazy(
  () =>
    import(
      /* webpackChunkName: "ua-icons-SvgPasscode" */ '../../components/outline/Passcode'
    ),
);
const SvgPasscodeLock = iconLazy(
  () =>
    import(
      /* webpackChunkName: "ua-icons-SvgPasscodeLock" */ '../../components/outline/PasscodeLock'
    ),
);
const SvgPaste = iconLazy(
  () =>
    import(
      /* webpackChunkName: "ua-icons-SvgPaste" */ '../../components/outline/Paste'
    ),
);
const SvgPaste02 = iconLazy(
  () =>
    import(
      /* webpackChunkName: "ua-icons-SvgPaste02" */ '../../components/outline/Paste02'
    ),
);
const SvgPdf = iconLazy(
  () =>
    import(
      /* webpackChunkName: "ua-icons-SvgPdf" */ '../../components/colored/Pdf'
    ),
);
const SvgPdf01 = iconLazy(
  () =>
    import(
      /* webpackChunkName: "ua-icons-SvgPdf01" */ '../../components/colored/file/Pdf'
    ),
);
const SvgPencil01 = iconLazy(
  () =>
    import(
      /* webpackChunkName: "ua-icons-SvgPencil01" */ '../../components/outline/Pencil01'
    ),
);
const SvgPencilRuler = iconLazy(
  () =>
    import(
      /* webpackChunkName: "ua-icons-SvgPencilRuler" */ '../../components/outline/PencilRuler'
    ),
);
const SvgPenTool = iconLazy(
  () =>
    import(
      /* webpackChunkName: "ua-icons-SvgPenTool" */ '../../components/colored/PenTool'
    ),
);
const SvgPeople = iconLazy(
  () =>
    import(
      /* webpackChunkName: "ua-icons-SvgPeople" */ '../../components/outline/People'
    ),
);
const SvgPercent02 = iconLazy(
  () =>
    import(
      /* webpackChunkName: "ua-icons-SvgPercent02" */ '../../components/outline/Percent02'
    ),
);
const SvgPhone = iconLazy(
  () =>
    import(
      /* webpackChunkName: "ua-icons-SvgPhone" */ '../../components/outline/Phone'
    ),
);
const SvgPhone01 = iconLazy(
  () =>
    import(
      /* webpackChunkName: "ua-icons-SvgPhone01" */ '../../components/outline/Phone01'
    ),
);
const SvgPhone02 = iconLazy(
  () =>
    import(
      /* webpackChunkName: "ua-icons-SvgPhone02" */ '../../components/outline/Phone02'
    ),
);
const SvgPhone02Solid = iconLazy(
  () =>
    import(
      /* webpackChunkName: "ua-icons-SvgPhone02Solid" */ '../../components/solid/Phone02'
    ),
);
const SvgPin02 = iconLazy(
  () =>
    import(
      /* webpackChunkName: "ua-icons-SvgPin02" */ '../../components/outline/Pin02'
    ),
);
const SvgPin02Solid = iconLazy(
  () =>
    import(
      /* webpackChunkName: "ua-icons-SvgPin02Solid" */ '../../components/outline/Pin02Solid'
    ),
);
const SvgPinInput = iconLazy(
  () =>
    import(
      /* webpackChunkName: "ua-icons-SvgPinInput" */ '../../components/outline/PinInput'
    ),
);
const SvgPipeline01 = iconLazy(
  () =>
    import(
      /* webpackChunkName: "ua-icons-SvgPipeline01" */ '../../components/outline/Pipelines01'
    ),
);
const SvgPlatformSettings = iconLazy(
  () =>
    import(
      /* webpackChunkName: "ua-icons-SvgPlatformSettings" */ '../../components/outline/no-code/PlatformSettings'
    ),
);
const SvgPlayCircle = iconLazy(
  () =>
    import(
      /* webpackChunkName: "ua-icons-SvgPlayCircle" */ '../../components/outline/PlayCircle'
    ),
);
const SvgPlaylist = iconLazy(
  () =>
    import(
      /* webpackChunkName: "ua-icons-SvgPlaylist" */ '../../components/outline/Playlist'
    ),
);
const SvgPlugIn = iconLazy(
  () =>
    import(
      /* webpackChunkName: "ua-icons-SvgPlugIn" */ '../../components/outline/PlugIn'
    ),
);
const SvgPlusSolid = iconLazy(
  () =>
    import(
      /* webpackChunkName: "ua-icons-SvgPlusSolid" */ '../../components/outline/PlusSolid'
    ),
);
const SvgPng = iconLazy(
  () =>
    import(
      /* webpackChunkName: "ua-icons-SvgPng" */ '../../components/colored/Png'
    ),
);
const SvgPpt = iconLazy(
  () =>
    import(
      /* webpackChunkName: "ua-icons-SvgPpt" */ '../../components/colored/Ppt'
    ),
);
const SvgPptx = iconLazy(
  () =>
    import(
      /* webpackChunkName: "ua-icons-SvgPptx" */ '../../components/colored/Pptx'
    ),
);
const SvgPreprocessingRequest = iconLazy(
  () =>
    import(
      /* webpackChunkName: "ua-icons-SvgPreprocessingRequest" */ '../../components/outline/PreprocessingRequest'
    ),
);
const SvgPresentationDeck = iconLazy(
  () =>
    import(
      /* webpackChunkName: "ua-icons-SvgPresentationDeck" */ '../../components/colored/PresentationDeck'
    ),
);
const SvgPsd = iconLazy(
  () =>
    import(
      /* webpackChunkName: "ua-icons-SvgPsd" */ '../../components/colored/Psd'
    ),
);
const SvgPublish = iconLazy(
  () =>
    import(
      /* webpackChunkName: "ua-icons-SvgPublish" */ '../../components/colored/Publish'
    ),
);
const SvgPusher = iconLazy(
  () =>
    import(
      /* webpackChunkName: "ua-icons-SvgPusher" */ '../../components/colored/Pusher'
    ),
);
const SvgPuzzlePiece02 = iconLazy(
  () =>
    import(
      /* webpackChunkName: "ua-icons-SvgPuzzlePiece02" */ '../../components/outline/PuzzlePiece02'
    ),
);
const SvgPythonLanguage = iconLazy(
  () =>
    import(
      /* webpackChunkName: "ua-icons-SvgPythonLanguage" */ '../../components/outline/PythonLanguage'
    ),
);
const SvgQuestionMark = iconLazy(
  () =>
    import(
      /* webpackChunkName: "ua-icons-SvgQuestionMark" */ '../../components/outline/QuestionMark'
    ),
);
const SvgQuotes = iconLazy(
  () =>
    import(
      /* webpackChunkName: "ua-icons-SvgQuotes" */ '../../components/outline/QuoteStart'
    ),
);
const SvgRadioSelect = iconLazy(
  () =>
    import(
      /* webpackChunkName: "ua-icons-SvgRadioSelect" */ '../../components/outline/RadioSelect'
    ),
);
const SvgRar = iconLazy(
  () =>
    import(
      /* webpackChunkName: "ua-icons-SvgRar" */ '../../components/colored/Rar'
    ),
);
const SvgReflect01 = iconLazy(
  () =>
    import(
      /* webpackChunkName: "ua-icons-SvgReflect01" */ '../../components/outline/Reflect01'
    ),
);
const SvgRefreshCcw01Solid = iconLazy(
  () =>
    import(
      /* webpackChunkName: "ua-icons-SvgRefreshCcw01Solid" */ '../../components/solid/RefreshCcw01Solid'
    ),
);
const SvgRefreshCcw05Solid = iconLazy(
  () =>
    import(
      /* webpackChunkName: "ua-icons-SvgRefreshCcw05Solid" */ '../../components/solid/RefreshCcw05Solid'
    ),
);
const SvgRepeat04 = iconLazy(
  () =>
    import(
      /* webpackChunkName: "ua-icons-SvgRepeat04" */ '../../components/outline/Repeat04'
    ),
);
const SvgRequestTransformer = iconLazy(
  () =>
    import(
      /* webpackChunkName: "ua-icons-SvgRequestTransformer" */ '../../components/outline/RequestTransformer'
    ),
);
const SvgResetPassword = iconLazy(
  () =>
    import(
      /* webpackChunkName: "ua-icons-SvgResetPassword" */ '../../components/outline/ResetPassword'
    ),
);
const SvgReverseLeft = iconLazy(
  () =>
    import(
      /* webpackChunkName: "ua-icons-SvgReverseLeft" */ '../../components/outline/ReverseLeft'
    ),
);
const SvgReview = iconLazy(
  () =>
    import(
      /* webpackChunkName: "ua-icons-SvgReview" */ '../../components/colored/Review'
    ),
);
const SvgRocket02 = iconLazy(
  () =>
    import(
      /* webpackChunkName: "ua-icons-SvgRocket02" */ '../../components/outline/Rocket02'
    ),
);
const SvgRotateLeft = iconLazy(
  () =>
    import(
      /* webpackChunkName: "ua-icons-SvgRotateLeft" */ '../../components/outline/RotateLeft'
    ),
);
const SvgRotateRight = iconLazy(
  () =>
    import(
      /* webpackChunkName: "ua-icons-SvgRotateRight" */ '../../components/outline/RotateRight'
    ),
);
const SvgRound = iconLazy(
  () =>
    import(
      /* webpackChunkName: "ua-icons-SvgRound" */ '../../components/outline/Round'
    ),
);
const SvgRows01 = iconLazy(
  () =>
    import(
      /* webpackChunkName: "ua-icons-SvgRows01" */ '../../components/outline/Rows01'
    ),
);
const SvgRows03 = iconLazy(
  () =>
    import(
      /* webpackChunkName: "ua-icons-SvgRows03" */ '../../components/outline/Rows03'
    ),
);
const SvgRss = iconLazy(
  () =>
    import(
      /* webpackChunkName: "ua-icons-SvgRss" */ '../../components/colored/Rss'
    ),
);
const SvgSafari = iconLazy(
  () =>
    import(
      /* webpackChunkName: "ua-icons-SvgSafari" */ '../../components/colored/Safari'
    ),
);
const SvgSalesforce = iconLazy(
  () =>
    import(
      /* webpackChunkName: "ua-icons-SvgSalesforce" */ '../../components/colored/Salesforce'
    ),
);
const SvgScan = iconLazy(
  () =>
    import(
      /* webpackChunkName: "ua-icons-SvgScan" */ '../../components/outline/Scan'
    ),
);
const SvgScissorsCut02 = iconLazy(
  () =>
    import(
      /* webpackChunkName: "ua-icons-SvgScissorsCut02" */ '../../components/outline/ScissorsCut02'
    ),
);
const SvgScript = iconLazy(
  () =>
    import(
      /* webpackChunkName: "ua-icons-SvgScript" */ '../../components/outline/Script'
    ),
);
const SvgScript02 = iconLazy(
  () =>
    import(
      /* webpackChunkName: "ua-icons-SvgScript02" */ '../../components/colored/Script02'
    ),
);
const SvgSearchBook = iconLazy(
  () =>
    import(
      /* webpackChunkName: "ua-icons-SvgSearchBook" */ '../../components/colored/SearchBook'
    ),
);
const SvgSearchMd = iconLazy(
  () =>
    import(
      /* webpackChunkName: "ua-icons-SvgSearchMd" */ '../../components/outline/SearchMd'
    ),
);
const SvgSearchMdFilled = iconLazy(
  () =>
    import(
      /* webpackChunkName: "ua-icons-SvgSearchMdFilled" */ '../../components/outline/SearchMdFilled'
    ),
);
const SvgSearchMdSolid = iconLazy(
  () =>
    import(
      /* webpackChunkName: "ua-icons-SvgSearchMdSolid" */ '../../components/outline/SearchMdSolid'
    ),
);
const SvgSearchRefraction = iconLazy(
  () =>
    import(
      /* webpackChunkName: "ua-icons-SvgSearchRefraction" */ '../../components/outline/SearchRefraction'
    ),
);
const SvgSearchStar02 = iconLazy(
  () =>
    import(
      /* webpackChunkName: "ua-icons-SvgSearchStar02" */ '../../components/solid/SearchStar02'
    ),
);
const SvgSend01 = iconLazy(
  () =>
    import(
      /* webpackChunkName: "ua-icons-SvgSend01" */ '../../components/outline/Send01'
    ),
);
const SvgSeoOptimise = iconLazy(
  () =>
    import(
      /* webpackChunkName: "ua-icons-SvgSeoOptimise" */ '../../components/outline/SeoOptimise'
    ),
);
const SvgSettings = iconLazy(
  () =>
    import(
      /* webpackChunkName: "ua-icons-SvgSettings" */ '../../components/outline/Settings'
    ),
);
const SvgSettings01 = iconLazy(
  () =>
    import(
      /* webpackChunkName: "ua-icons-SvgSettings01" */ '../../components/outline/Settings01'
    ),
);
const SvgSettingsSolid = iconLazy(
  () =>
    import(
      /* webpackChunkName: "ua-icons-SvgSettingsSolid" */ '../../components/outline/SettingsSolid'
    ),
);
const SvgShare07 = iconLazy(
  () =>
    import(
      /* webpackChunkName: "ua-icons-SvgShare07" */ '../../components/outline/Share07'
    ),
);
const SvgShield01 = iconLazy(
  () =>
    import(
      /* webpackChunkName: "ua-icons-SvgShield01" */ '../../components/outline/Shield01'
    ),
);
const SvgShield02 = iconLazy(
  () =>
    import(
      /* webpackChunkName: "ua-icons-SvgShield02" */ '../../components/outline/Shield02'
    ),
);
const SvgShield03 = iconLazy(
  () =>
    import(
      /* webpackChunkName: "ua-icons-SvgShield03" */ '../../components/outline/Shield03'
    ),
);
const SvgShieldAgent02 = iconLazy(
  () =>
    import(
      /* webpackChunkName: "ua-icons-SvgShieldAgent02" */ '../../components/outline/ShieldAgent02'
    ),
);
const SvgShieldOff = iconLazy(
  () =>
    import(
      /* webpackChunkName: "ua-icons-SvgShieldOff" */ '../../components/outline/ShieldOff'
    ),
);
const SvgShieldStar = iconLazy(
  () =>
    import(
      /* webpackChunkName: "ua-icons-SvgShieldStar" */ '../../components/solid/ShieldStar'
    ),
);
const SvgShieldStarOutline = iconLazy(
  () =>
    import(
      /* webpackChunkName: "ua-icons-SvgShieldStarOutline" */ '../../components/outline/ShieldStar'
    ),
);
const SvgShieldTick = iconLazy(
  () =>
    import(
      /* webpackChunkName: "ua-icons-SvgShieldTick" */ '../../components/outline/ShieldTick'
    ),
);
const SvgShoppingBag02 = iconLazy(
  () =>
    import(
      /* webpackChunkName: "ua-icons-SvgShoppingBag02" */ '../../components/outline/ShoppingBag02'
    ),
);
const SvgShoppingCart01 = iconLazy(
  () =>
    import(
      /* webpackChunkName: "ua-icons-SvgShoppingCart01" */ '../../components/outline/ShoppingCart01'
    ),
);
const SvgShuffle01 = iconLazy(
  () =>
    import(
      /* webpackChunkName: "ua-icons-SvgShuffle01" */ '../../components/outline/Shuffle01'
    ),
);
const SvgSignal01 = iconLazy(
  () =>
    import(
      /* webpackChunkName: "ua-icons-SvgSignal01" */ '../../components/outline/Signal01'
    ),
);
const SvgSignal02 = iconLazy(
  () =>
    import(
      /* webpackChunkName: "ua-icons-SvgSignal02" */ '../../components/outline/Signal02'
    ),
);
const SvgSignal03 = iconLazy(
  () =>
    import(
      /* webpackChunkName: "ua-icons-SvgSignal03" */ '../../components/outline/Signal03'
    ),
);
const SvgSimcard = iconLazy(
  () =>
    import(
      /* webpackChunkName: "ua-icons-SvgSimcard" */ '../../components/outline/Simcard'
    ),
);
const SvgSingleSelect = iconLazy(
  () =>
    import(
      /* webpackChunkName: "ua-icons-SvgSingleSelect" */ '../../components/outline/SingleSelect'
    ),
);
const SvgSlack = iconLazy(
  () =>
    import(
      /* webpackChunkName: "ua-icons-SvgSlack" */ '../../components/colored/Slack'
    ),
);
const SvgSlashDivider = iconLazy(
  () =>
    import(
      /* webpackChunkName: "ua-icons-SvgSlashDivider" */ '../../components/outline/SlashDivider'
    ),
);
const SvgSliders01 = iconLazy(
  () =>
    import(
      /* webpackChunkName: "ua-icons-SvgSliders01" */ '../../components/colored/Sliders01'
    ),
);
const SvgSliders01Outline = iconLazy(
  () =>
    import(
      /* webpackChunkName: "ua-icons-SvgSliders01Outline" */ '../../components/outline/Sliders01'
    ),
);
const SvgSliders04 = iconLazy(
  () =>
    import(
      /* webpackChunkName: "ua-icons-SvgSliders04" */ '../../components/outline/Sliders04'
    ),
);
const SvgSolidLock = iconLazy(
  () =>
    import(
      /* webpackChunkName: "ua-icons-SvgSolidLock" */ '../../components/solid/SolidLock'
    ),
);
const SvgSpacingHeight01 = iconLazy(
  () =>
    import(
      /* webpackChunkName: "ua-icons-SvgSpacingHeight01" */ '../../components/outline/SpacingHeight01'
    ),
);
const SvgSpacingWidth02 = iconLazy(
  () =>
    import(
      /* webpackChunkName: "ua-icons-SvgSpacingWidth02" */ '../../components/outline/SpacingWidth02'
    ),
);
const SvgSpeedMeterSolid = iconLazy(
  () =>
    import(
      /* webpackChunkName: "ua-icons-SvgSpeedMeterSolid" */ '../../components/outline/SpeedMeterSolid'
    ),
);
const SvgSpeedometer01 = iconLazy(
  () =>
    import(
      /* webpackChunkName: "ua-icons-SvgSpeedometer01" */ '../../components/outline/Speedometer01'
    ),
);
const SvgSpeedometer03 = iconLazy(
  () =>
    import(
      /* webpackChunkName: "ua-icons-SvgSpeedometer03" */ '../../components/outline/Speedometer03'
    ),
);
const SvgSpreadsheet = iconLazy(
  () =>
    import(
      /* webpackChunkName: "ua-icons-SvgSpreadsheet" */ '../../components/colored/Spreadsheet'
    ),
);
const SvgSprinklr = iconLazy(
  () =>
    import(
      /* webpackChunkName: "ua-icons-SvgSprinklr" */ '../../components/colored/Sprinklr'
    ),
);
const SvgSql = iconLazy(
  () =>
    import(
      /* webpackChunkName: "ua-icons-SvgSql" */ '../../components/colored/Sql'
    ),
);
const SvgSquared = iconLazy(
  () =>
    import(
      /* webpackChunkName: "ua-icons-SvgSquared" */ '../../components/outline/Squared'
    ),
);
const SvgStar02 = iconLazy(
  () =>
    import(
      /* webpackChunkName: "ua-icons-SvgStar02" */ '../../components/outline/Star02'
    ),
);
const SvgStar04 = iconLazy(
  () =>
    import(
      /* webpackChunkName: "ua-icons-SvgStar04" */ '../../components/outline/Star04'
    ),
);
const SvgStar04Solid = iconLazy(
  () =>
    import(
      /* webpackChunkName: "ua-icons-SvgStar04Solid" */ '../../components/solid/Star04Solid'
    ),
);
const SvgStar07 = iconLazy(
  () =>
    import(
      /* webpackChunkName: "ua-icons-SvgStar07" */ '../../components/outline/Star07'
    ),
);
const SvgStarOff = iconLazy(
  () =>
    import(
      /* webpackChunkName: "ua-icons-SvgStarOff" */ '../../components/outline/StarOff'
    ),
);
const SvgStars01 = iconLazy(
  () =>
    import(
      /* webpackChunkName: "ua-icons-SvgStars01" */ '../../components/outline/Stars01'
    ),
);
const SvgStatusArchived = iconLazy(
  () =>
    import(
      /* webpackChunkName: "ua-icons-SvgStatusArchived" */ '../../components/colored/StatusArchived'
    ),
);
const SvgStatusDraft = iconLazy(
  () =>
    import(
      /* webpackChunkName: "ua-icons-SvgStatusDraft" */ '../../components/colored/StatusDraft'
    ),
);
const SvgStatusError = iconLazy(
  () =>
    import(
      /* webpackChunkName: "ua-icons-SvgStatusError" */ '../../components/colored/StatusError'
    ),
);
const SvgStatusLive = iconLazy(
  () =>
    import(
      /* webpackChunkName: "ua-icons-SvgStatusLive" */ '../../components/colored/StatusLive'
    ),
);
const SvgStatusPaused = iconLazy(
  () =>
    import(
      /* webpackChunkName: "ua-icons-SvgStatusPaused" */ '../../components/colored/StatusPaused'
    ),
);
const SvgStatusPaused02 = iconLazy(
  () =>
    import(
      /* webpackChunkName: "ua-icons-SvgStatusPaused02" */ '../../components/colored/StatusPaused02'
    ),
);
const SvgStepComplete = iconLazy(
  () =>
    import(
      /* webpackChunkName: "ua-icons-SvgStepComplete" */ '../../components/colored/StepComplete'
    ),
);
const SvgStepCurrent = iconLazy(
  () =>
    import(
      /* webpackChunkName: "ua-icons-SvgStepCurrent" */ '../../components/colored/StepCurrent'
    ),
);
const SvgStepError = iconLazy(
  () =>
    import(
      /* webpackChunkName: "ua-icons-SvgStepError" */ '../../components/colored/StepError'
    ),
);
const SvgStepIncomplete = iconLazy(
  () =>
    import(
      /* webpackChunkName: "ua-icons-SvgStepIncomplete" */ '../../components/outline/StepIncomplete'
    ),
);
const SvgStore = iconLazy(
  () =>
    import(
      /* webpackChunkName: "ua-icons-SvgStore" */ '../../components/outline/Store'
    ),
);
const SvgStructure = iconLazy(
  () =>
    import(
      /* webpackChunkName: "ua-icons-SvgStructure" */ '../../components/outline/Structure'
    ),
);
const SvgSupport = iconLazy(
  () =>
    import(
      /* webpackChunkName: "ua-icons-SvgSupport" */ '../../components/outline/Support'
    ),
);
const SvgSvg = iconLazy(
  () =>
    import(
      /* webpackChunkName: "ua-icons-SvgSvg" */ '../../components/colored/Svg'
    ),
);
const SvgSvgBreaker02 = iconLazy(
  () =>
    import(
      /* webpackChunkName: "ua-icons-SvgSvgBreaker02" */ '../../components/outline/SvgBreaker02'
    ),
);
const SvgSwitchHorizontal01 = iconLazy(
  () =>
    import(
      /* webpackChunkName: "ua-icons-SvgSwitchHorizontal01" */ '../../components/outline/SwitchHorizontal01'
    ),
);
const SvgSwitchOff = iconLazy(
  () =>
    import(
      /* webpackChunkName: "ua-icons-SvgSwitchOff" */ '../../components/outline/SwitchOff'
    ),
);
const SvgSwitchOn = iconLazy(
  () =>
    import(
      /* webpackChunkName: "ua-icons-SvgSwitchOn" */ '../../components/outline/SwitchOn'
    ),
);
const SvgSwitchVertical02 = iconLazy(
  () =>
    import(
      /* webpackChunkName: "ua-icons-SvgSwitchVertical02" */ '../../components/outline/SwitchVertical02'
    ),
);
const SvgSyncing = iconLazy(
  () =>
    import(
      /* webpackChunkName: "ua-icons-SvgSyncing" */ '../../components/colored/Syncing'
    ),
);
const SvgTablet01 = iconLazy(
  () =>
    import(
      /* webpackChunkName: "ua-icons-SvgTablet01" */ '../../components/outline/Tablet01'
    ),
);
const SvgTabletHorizontal = iconLazy(
  () =>
    import(
      /* webpackChunkName: "ua-icons-SvgTabletHorizontal" */ '../../components/outline/TabletHorizontal'
    ),
);
const SvgTag01 = iconLazy(
  () =>
    import(
      /* webpackChunkName: "ua-icons-SvgTag01" */ '../../components/outline/Tag01'
    ),
);
const SvgTag02 = iconLazy(
  () =>
    import(
      /* webpackChunkName: "ua-icons-SvgTag02" */ '../../components/outline/Tag02'
    ),
);
const SvgTarget = iconLazy(
  () =>
    import(
      /* webpackChunkName: "ua-icons-SvgTarget" */ '../../components/outline/Target'
    ),
);
const SvgTarget04 = iconLazy(
  () =>
    import(
      /* webpackChunkName: "ua-icons-SvgTarget04" */ '../../components/outline/Target04'
    ),
);
const SvgTelescope = iconLazy(
  () =>
    import(
      /* webpackChunkName: "ua-icons-SvgTelescope" */ '../../components/outline/Telescope'
    ),
);
const SvgTerminalBrowser = iconLazy(
  () =>
    import(
      /* webpackChunkName: "ua-icons-SvgTerminalBrowser" */ '../../components/outline/TerminalBrowser'
    ),
);
const SvgTerminalSquareSolid = iconLazy(
  () =>
    import(
      /* webpackChunkName: "ua-icons-SvgTerminalSquareSolid" */ '../../components/solid/TerminalSquare'
    ),
);
const SvgTextColor = iconLazy(
  () =>
    import(
      /* webpackChunkName: "ua-icons-SvgTextColor" */ '../../components/outline/TextColor'
    ),
);
const SvgTextInput = iconLazy(
  () =>
    import(
      /* webpackChunkName: "ua-icons-SvgTextInput" */ '../../components/outline/TextInput'
    ),
);
const SvgTiff = iconLazy(
  () =>
    import(
      /* webpackChunkName: "ua-icons-SvgTiff" */ '../../components/colored/Tiff'
    ),
);
const SvgTimeStamp = iconLazy(
  () =>
    import(
      /* webpackChunkName: "ua-icons-SvgTimeStamp" */ '../../components/outline/TimeStamp'
    ),
);
const SvgToastBrand = iconLazy(
  () =>
    import(
      /* webpackChunkName: "ua-icons-SvgToastBrand" */ '../../components/colored/ToastBrand'
    ),
);
const SvgTool01 = iconLazy(
  () =>
    import(
      /* webpackChunkName: "ua-icons-SvgTool01" */ '../../components/outline/Tool01'
    ),
);
const SvgTool02 = iconLazy(
  () =>
    import(
      /* webpackChunkName: "ua-icons-SvgTool02" */ '../../components/outline/Tool02'
    ),
);
const SvgTrain = iconLazy(
  () =>
    import(
      /* webpackChunkName: "ua-icons-SvgTrain" */ '../../components/outline/Train'
    ),
);
const SvgTranscript = iconLazy(
  () =>
    import(
      /* webpackChunkName: "ua-icons-SvgTranscript" */ '../../components/outline/Transcript'
    ),
);
const SvgTranscriptOff = iconLazy(
  () =>
    import(
      /* webpackChunkName: "ua-icons-SvgTranscriptOff" */ '../../components/outline/TranscriptOff'
    ),
);
const SvgTranslate02 = iconLazy(
  () =>
    import(
      /* webpackChunkName: "ua-icons-SvgTranslate02" */ '../../components/outline/Translate02'
    ),
);
const SvgTrash01 = iconLazy(
  () =>
    import(
      /* webpackChunkName: "ua-icons-SvgTrash01" */ '../../components/outline/Trash01'
    ),
);
const SvgTrash02 = iconLazy(
  () =>
    import(
      /* webpackChunkName: "ua-icons-SvgTrash02" */ '../../components/outline/Trash02'
    ),
);
const SvgTriangleDownSolid = iconLazy(
  () =>
    import(
      /* webpackChunkName: "ua-icons-SvgTriangleDownSolid" */ '../../components/solid/TriangleDownSolid'
    ),
);
const SvgTriangleSolid = iconLazy(
  () =>
    import(
      /* webpackChunkName: "ua-icons-SvgTriangleSolid" */ '../../components/solid/TriangleSolid'
    ),
);
const SvgTruck02 = iconLazy(
  () =>
    import(
      /* webpackChunkName: "ua-icons-SvgTruck02" */ '../../components/outline/Truck02'
    ),
);
const SvgTv02 = iconLazy(
  () =>
    import(
      /* webpackChunkName: "ua-icons-SvgTv02" */ '../../components/outline/Tv02'
    ),
);
const SvgTv02Solid = iconLazy(
  () =>
    import(
      /* webpackChunkName: "ua-icons-SvgTv02Solid" */ '../../components/solid/Tv02'
    ),
);
const SvgTxt = iconLazy(
  () =>
    import(
      /* webpackChunkName: "ua-icons-SvgTxt" */ '../../components/colored/Txt'
    ),
);
const SvgTypeColorMd = iconLazy(
  () =>
    import(
      /* webpackChunkName: "ua-icons-SvgTypeColorMd" */ '../../components/colored/TypeColorMd'
    ),
);
const SvgTypeMd = iconLazy(
  () =>
    import(
      /* webpackChunkName: "ua-icons-SvgTypeMd" */ '../../components/outline/TypeMd'
    ),
);
const SvgUnifyAi = iconLazy(
  () =>
    import(
      /* webpackChunkName: "ua-icons-SvgUnifyAi" */ '../../components/outline/no-code/UnifyAi'
    ),
);
const SvgUnifyAiSolid = iconLazy(
  () =>
    import(
      /* webpackChunkName: "ua-icons-SvgUnifyAiSolid" */ '../../components/solid/UnifyAiSolid'
    ),
);
const SvgUnifyApi = iconLazy(
  () =>
    import(
      /* webpackChunkName: "ua-icons-SvgUnifyApi" */ '../../components/outline/UnifyApi'
    ),
);
const SvgUnStar01 = iconLazy(
  () =>
    import(
      /* webpackChunkName: "ua-icons-SvgUnStar01" */ '../../components/outline/UnStar01'
    ),
);
const SvgUpload01 = iconLazy(
  () =>
    import(
      /* webpackChunkName: "ua-icons-SvgUpload01" */ '../../components/outline/Upload01'
    ),
);
const SvgUploadCloud02 = iconLazy(
  () =>
    import(
      /* webpackChunkName: "ua-icons-SvgUploadCloud02" */ '../../components/outline/UploadCloud02'
    ),
);
const SvgUppercase = iconLazy(
  () =>
    import(
      /* webpackChunkName: "ua-icons-SvgUppercase" */ '../../components/outline/Uppercase'
    ),
);
const SvgUserCheck01 = iconLazy(
  () =>
    import(
      /* webpackChunkName: "ua-icons-SvgUserCheck01" */ '../../components/outline/UserCheck01'
    ),
);
const SvgUserManager = iconLazy(
  () =>
    import(
      /* webpackChunkName: "ua-icons-SvgUserManager" */ '../../components/outline/UserManager'
    ),
);
const SvgUserPlus01 = iconLazy(
  () =>
    import(
      /* webpackChunkName: "ua-icons-SvgUserPlus01" */ '../../components/outline/UserPlus01'
    ),
);
const SvgUserRight01 = iconLazy(
  () =>
    import(
      /* webpackChunkName: "ua-icons-SvgUserRight01" */ '../../components/outline/UserRight01'
    ),
);
const SvgUsers01 = iconLazy(
  () =>
    import(
      /* webpackChunkName: "ua-icons-SvgUsers01" */ '../../components/outline/Users01'
    ),
);
const SvgUsersCheck = iconLazy(
  () =>
    import(
      /* webpackChunkName: "ua-icons-SvgUsersCheck" */ '../../components/outline/UsersCheck'
    ),
);
const SvgUserSquare = iconLazy(
  () =>
    import(
      /* webpackChunkName: "ua-icons-SvgUserSquare" */ '../../components/outline/UserSquare'
    ),
);
const SvgUsersRight = iconLazy(
  () =>
    import(
      /* webpackChunkName: "ua-icons-SvgUsersRight" */ '../../components/outline/UsersRight'
    ),
);
const SvgUsersX = iconLazy(
  () =>
    import(
      /* webpackChunkName: "ua-icons-SvgUsersX" */ '../../components/outline/UsersX'
    ),
);
const SvgUserThree = iconLazy(
  () =>
    import(
      /* webpackChunkName: "ua-icons-SvgUserThree" */ '../../components/outline/UserThree'
    ),
);
const SvgVariable = iconLazy(
  () =>
    import(
      /* webpackChunkName: "ua-icons-SvgVariable" */ '../../components/outline/Variable'
    ),
);
const SvgVideo = iconLazy(
  () =>
    import(
      /* webpackChunkName: "ua-icons-SvgVideo" */ '../../components/colored/file/Video'
    ),
);
const SvgVideo01 = iconLazy(
  () =>
    import(
      /* webpackChunkName: "ua-icons-SvgVideo01" */ '../../components/colored/Video01'
    ),
);
const SvgVolumeMax = iconLazy(
  () =>
    import(
      /* webpackChunkName: "ua-icons-SvgVolumeMax" */ '../../components/outline/VolumeMax'
    ),
);
const SvgVolumeMin = iconLazy(
  () =>
    import(
      /* webpackChunkName: "ua-icons-SvgVolumeMin" */ '../../components/outline/VolumeMin'
    ),
);
const SvgVolumeMinus = iconLazy(
  () =>
    import(
      /* webpackChunkName: "ua-icons-SvgVolumeMinus" */ '../../components/outline/VolumeMinus'
    ),
);
const SvgVolumePlus = iconLazy(
  () =>
    import(
      /* webpackChunkName: "ua-icons-SvgVolumePlus" */ '../../components/outline/VolumePlus'
    ),
);
const SvgVolumeX = iconLazy(
  () =>
    import(
      /* webpackChunkName: "ua-icons-SvgVolumeX" */ '../../components/outline/VolumeX'
    ),
);
const SvgWav = iconLazy(
  () =>
    import(
      /* webpackChunkName: "ua-icons-SvgWav" */ '../../components/colored/Wav'
    ),
);
const SvgWebcam01 = iconLazy(
  () =>
    import(
      /* webpackChunkName: "ua-icons-SvgWebcam01" */ '../../components/solid/Webcam01'
    ),
);
const SvgWebhookSolid = iconLazy(
  () =>
    import(
      /* webpackChunkName: "ua-icons-SvgWebhookSolid" */ '../../components/solid/WebhookSolid'
    ),
);
const SvgWebp = iconLazy(
  () =>
    import(
      /* webpackChunkName: "ua-icons-SvgWebp" */ '../../components/colored/Webp'
    ),
);
const SvgWhatsapp = iconLazy(
  () =>
    import(
      /* webpackChunkName: "ua-icons-SvgWhatsapp" */ '../../components/colored/Whatsapp'
    ),
);
const SvgWidgetAdd = iconLazy(
  () =>
    import(
      /* webpackChunkName: "ua-icons-SvgWidgetAdd" */ '../../components/outline/WidgetAdd'
    ),
);
const SvgWorkspace = iconLazy(
  () =>
    import(
      /* webpackChunkName: "ua-icons-SvgWorkspace" */ '../../components/outline/Workspace'
    ),
);
const SvgXCircleSolid = iconLazy(
  () =>
    import(
      /* webpackChunkName: "ua-icons-SvgXCircleSolid" */ '../../components/solid/XCircleSolid'
    ),
);
const SvgXClose = iconLazy(
  () =>
    import(
      /* webpackChunkName: "ua-icons-SvgXClose" */ '../../components/outline/XButton'
    ),
);
const SvgXLogo = iconLazy(
  () =>
    import(
      /* webpackChunkName: "ua-icons-SvgXLogo" */ '../../components/outline/XLogo'
    ),
);
const SvgXls = iconLazy(
  () =>
    import(
      /* webpackChunkName: "ua-icons-SvgXls" */ '../../components/colored/Xls'
    ),
);
const SvgXml = iconLazy(
  () =>
    import(
      /* webpackChunkName: "ua-icons-SvgXml" */ '../../components/colored/Xml'
    ),
);
const SvgXmlLanguage = iconLazy(
  () =>
    import(
      /* webpackChunkName: "ua-icons-SvgXmlLanguage" */ '../../components/outline/XmlLanguage'
    ),
);
const SvgZapOff = iconLazy(
  () =>
    import(
      /* webpackChunkName: "ua-icons-SvgZapOff" */ '../../components/outline/ZapOff'
    ),
);
const SvgZip = iconLazy(
  () =>
    import(
      /* webpackChunkName: "ua-icons-SvgZip" */ '../../components/colored/Zip'
    ),
);
const SvgZoom = iconLazy(
  () =>
    import(
      /* webpackChunkName: "ua-icons-SvgZoom" */ '../../components/colored/Zoom'
    ),
);
const SvgZoomInfo = iconLazy(
  () =>
    import(
      /* webpackChunkName: "ua-icons-SvgZoomInfo" */ '../../components/colored/ZoomInfo'
    ),
);
const TerminalSquare = iconLazy(
  () =>
    import(
      /* webpackChunkName: "ua-icons-TerminalSquare" */ '../../components/outline/TerminalSquare'
    ),
);
const TextAlignCenter = iconLazy(
  () =>
    import(
      /* webpackChunkName: "ua-icons-TextAlignCenter" */ '../../components/outline/AlignCenter'
    ),
);
const TextAlignJustify = iconLazy(
  () =>
    import(
      /* webpackChunkName: "ua-icons-TextAlignJustify" */ '../../components/outline/AlignJustify'
    ),
);
const TextAlignLeft = iconLazy(
  () =>
    import(
      /* webpackChunkName: "ua-icons-TextAlignLeft" */ '../../components/outline/AlignLeft'
    ),
);
const TextAlignRight = iconLazy(
  () =>
    import(
      /* webpackChunkName: "ua-icons-TextAlignRight" */ '../../components/outline/AlignRight'
    ),
);
const ThumbsDown = iconLazy(
  () =>
    import(
      /* webpackChunkName: "ua-icons-ThumbsDown" */ '../../components/outline/ThumbsDown'
    ),
);
const ThumbsUp = iconLazy(
  () =>
    import(
      /* webpackChunkName: "ua-icons-ThumbsUp" */ '../../components/outline/ThumbsUp'
    ),
);
const Ticket01 = iconLazy(
  () =>
    import(
      /* webpackChunkName: "ua-icons-Ticket01" */ '../../components/outline/Ticket01'
    ),
);
const Toggle01Right = iconLazy(
  () =>
    import(
      /* webpackChunkName: "ua-icons-Toggle01Right" */ '../../components/outline/Toggle01Right'
    ),
);
const Tool02 = iconLazy(
  () =>
    import(
      /* webpackChunkName: "ua-icons-Tool02" */ '../../components/outline/Tool02'
    ),
);
const Transform = iconLazy(
  () =>
    import(
      /* webpackChunkName: "ua-icons-Transform" */ '../../components/outline/Transform'
    ),
);
const Trash01 = iconLazy(
  () =>
    import(
      /* webpackChunkName: "ua-icons-Trash01" */ '../../components/outline/Trash01'
    ),
);
const Type01 = iconLazy(
  () =>
    import(
      /* webpackChunkName: "ua-icons-Type01" */ '../../components/outline/Type01'
    ),
);
const Type03 = iconLazy(
  () =>
    import(
      /* webpackChunkName: "ua-icons-Type03" */ '../../components/outline/Type03'
    ),
);
const TypeFeature = iconLazy(
  () =>
    import(
      /* webpackChunkName: "ua-icons-TypeFeature" */ '../../components/colored/TypeFeature'
    ),
);
const TypeIssue = iconLazy(
  () =>
    import(
      /* webpackChunkName: "ua-icons-TypeIssue" */ '../../components/colored/TypeIssue'
    ),
);
const TypeQuestion = iconLazy(
  () =>
    import(
      /* webpackChunkName: "ua-icons-TypeQuestion" */ '../../components/colored/TypeQuestion'
    ),
);
const Unfold = iconLazy(
  () =>
    import(
      /* webpackChunkName: "ua-icons-Unfold" */ '../../components/outline/Unfold'
    ),
);
const UnifyAi3 = iconLazy(
  () =>
    import(
      /* webpackChunkName: "ua-icons-UnifyAi3" */ '../../components/colored/UnifyAi3'
    ),
);
const UploadCloud01 = iconLazy(
  () =>
    import(
      /* webpackChunkName: "ua-icons-UploadCloud01" */ '../../components/outline/UploadCloud01'
    ),
);
const User01 = iconLazy(
  () =>
    import(
      /* webpackChunkName: "ua-icons-User01" */ '../../components/outline/User01'
    ),
);
const UsersPlus = iconLazy(
  () =>
    import(
      /* webpackChunkName: "ua-icons-UsersPlus" */ '../../components/outline/UsersPlus'
    ),
);
const Verif = iconLazy(
  () =>
    import(
      /* webpackChunkName: "ua-icons-Verif" */ '../../components/colored/Verif'
    ),
);
const VideoRecorder = iconLazy(
  () =>
    import(
      /* webpackChunkName: "ua-icons-VideoRecorder" */ '../../components/outline/VideoRecorder'
    ),
);
const VideoRecorderOff = iconLazy(
  () =>
    import(
      /* webpackChunkName: "ua-icons-VideoRecorderOff" */ '../../components/outline/VideoRecorderOff'
    ),
);
const Warning = iconLazy(
  () =>
    import(
      /* webpackChunkName: "ua-icons-Warning" */ '../../components/colored/Warning'
    ),
);
const WaterfallChart = iconLazy(
  () =>
    import(
      /* webpackChunkName: "ua-icons-WaterfallChart" */ '../../components/outline/WaterfallChart'
    ),
);
const Webhook = iconLazy(
  () =>
    import(
      /* webpackChunkName: "ua-icons-Webhook" */ '../../components/outline/Webhook'
    ),
);
const Wifi = iconLazy(
  () =>
    import(
      /* webpackChunkName: "ua-icons-Wifi" */ '../../components/outline/Wifi'
    ),
);
const WifiOff = iconLazy(
  () =>
    import(
      /* webpackChunkName: "ua-icons-WifiOff" */ '../../components/outline/WifiOff'
    ),
);
const WordCloudChart = iconLazy(
  () =>
    import(
      /* webpackChunkName: "ua-icons-WordCloudChart" */ '../../components/outline/WordCloudChart'
    ),
);
const XCircle = iconLazy(
  () =>
    import(
      /* webpackChunkName: "ua-icons-XCircle" */ '../../components/outline/XCircle'
    ),
);
const Xls = iconLazy(
  () =>
    import(
      /* webpackChunkName: "ua-icons-Xls" */ '../../components/colored/Xls'
    ),
);
const Xlsx = iconLazy(
  () =>
    import(
      /* webpackChunkName: "ua-icons-Xlsx" */ '../../components/colored/Xlsx'
    ),
);
const Zap = iconLazy(
  () =>
    import(
      /* webpackChunkName: "ua-icons-Zap" */ '../../components/outline/Zap'
    ),
);
const Zap01 = iconLazy(
  () =>
    import(
      /* webpackChunkName: "ua-icons-Zap01" */ '../../components/outline/Zap01'
    ),
);
const ZapFast = iconLazy(
  () =>
    import(
      /* webpackChunkName: "ua-icons-ZapFast" */ '../../components/outline/ZapFast'
    ),
);
const ZapSolid = iconLazy(
  () =>
    import(
      /* webpackChunkName: "ua-icons-ZapSolid" */ '../../components/solid/Zap'
    ),
);

export const iconRegistry: Record<
  string,
  {
    icon?: ComponentType<SVGProps<SVGSVGElement>>;
    label: string;
    category: IconCategoryId;
  }
> = {
  AddTable: {
    icon: AddTable,
    label: 'AddTable',
    category: IconCategoryId.LAYOUT,
  },
  AgenticAiAgents: {
    icon: AgenticAiAgents,
    label: 'AI Agents',
    category: IconCategoryId.AI,
  },
  AgenticAiApps: {
    icon: AgenticAiApps,
    label: 'AI Apps',
    category: IconCategoryId.AI,
  },
  AgenticAiChat: {
    icon: AgenticAiChat,
    label: 'AI Chat',
    category: IconCategoryId.AI,
  },
  AgenticAiChatSolid: {
    icon: AgenticAiChatSolid,
    label: 'AI Chat Solid',
    category: IconCategoryId.AI,
  },
  AgenticAiPeople: {
    icon: AgenticAiPeople,
    label: 'AI People',
    category: IconCategoryId.AI,
  },
  AgenticAiSearch: {
    icon: AgenticAiSearch,
    label: 'AI Search',
    category: IconCategoryId.AI,
  },
  AgenticAiSearchSolid: {
    icon: AgenticAiSearchSolid,
    label: 'AI Search Solid',
    category: IconCategoryId.AI,
  },
  AiAgentSolid: {
    icon: AiAgentSolid,
    label: 'AI Agent Solid',
    category: IconCategoryId.AI,
  },
  AiDataPipelines: {
    icon: AiDataPipelines,
    label: 'AiDataPipelines',
    category: IconCategoryId.AI,
  },
  AiEditor: {
    icon: AiEditor,
    label: 'AI Editor',
    category: IconCategoryId.AI,
  },
  AiEditorSolid: {
    icon: AiEditorSolid,
    label: 'AI Editor',
    category: IconCategoryId.AI,
  },
  AiEnrichment: {
    icon: AiEnrichment,
    label: 'AI Enrichment',
    category: IconCategoryId.AI,
  },
  AiGenerateDoc: {
    icon: AiGenerateDoc,
    label: 'AI Generate Doc',
    category: IconCategoryId.AI,
  },
  AiGenerateDocOff: {
    icon: AiGenerateDocOff,
    label: 'AI Generate Doc Off',
    category: IconCategoryId.AI,
  },
  AiGenerateText: {
    icon: AiGenerateText,
    label: 'AI Generate Text',
    category: IconCategoryId.AI,
  },
  AiStar: {
    icon: AiStar,
    label: 'Ai Star',
    category: IconCategoryId.GENERAL,
  },
  AISummary: {
    icon: AISummary,
    label: 'AI Summary',
    category: IconCategoryId.AI,
  },
  AiZapFast: {
    icon: AiZapFast,
    label: 'AiZapFast',
    category: IconCategoryId.AI,
  },
  AlertCircle: {
    icon: AlertCircle,
    label: 'Alert Circle',
    category: IconCategoryId.ALERTS_AND_FEEDBACK,
  },
  AlertTriangle: {
    icon: AlertTriangle,
    label: 'Alert Triangle',
    category: IconCategoryId.ALERTS_AND_FEEDBACK,
  },
  AlertTrianlgeSolid: {
    icon: AlertTrianlgeSolid,
    label: 'Alert Triangle Solid',
    category: IconCategoryId.ALERTS_AND_FEEDBACK,
  },
  AlignLeft: {
    icon: AlignLeft,
    label: 'Align Left',
    category: IconCategoryId.EDITOR,
  },
  Announcement03: {
    icon: Announcement03,
    label: 'Announcement',
    category: IconCategoryId.ALERTS_AND_FEEDBACK,
  },
  Archive: {
    icon: Archive,
    label: 'Archive',
    category: IconCategoryId.GENERAL,
  },
  ArrowCircleBrokenDownRight: {
    icon: ArrowCircleBrokenDownRight,
    label: 'Arrow Circle Down Right',
    category: IconCategoryId.ARROWS,
  },
  ArrowCircleBrokenRight: {
    icon: ArrowCircleBrokenRight,
    label: 'Arrow Circle Broken Right',
    category: IconCategoryId.ARROWS,
  },
  ArrowCircleBrokenUpRight: {
    icon: ArrowCircleBrokenUpRight,
    label: 'Arrow Circle Up Right',
    category: IconCategoryId.ARROWS,
  },
  ArrowCircleRight: {
    icon: ArrowCircleRight,
    label: 'Arrow Circle Right',
    category: IconCategoryId.ARROWS,
  },
  ArrowCircleUpLeft: {
    icon: ArrowCircleUpLeft,
    label: 'Arrow Circle Up Left',
    category: IconCategoryId.ARROWS,
  },
  ArrowDown: {
    icon: ArrowDown,
    label: 'Arrow Down',
    category: IconCategoryId.ARROWS,
  },
  ArrowDownToLine: {
    icon: ArrowDownToLine,
    label: 'Arrow Down To Line',
    category: IconCategoryId.ARROWS,
  },
  ArrowLeft: {
    icon: ArrowLeft,
    label: 'Arrow Left',
    category: IconCategoryId.ARROWS,
  },
  ArrowLeftToLine: {
    icon: ArrowLeftToLine,
    label: 'Arrow Left To Line',
    category: IconCategoryId.ARROWS,
  },
  ArrowNarrowDown: {
    icon: ArrowNarrowDown,
    label: 'Arrow Down',
    category: IconCategoryId.ARROWS,
  },
  ArrowNarrowLeft: {
    icon: ArrowNarrowLeft,
    label: 'Arrow Narrow Left',
    category: IconCategoryId.ARROWS,
  },
  ArrowNarrowRight: {
    icon: ArrowNarrowRight,
    label: 'Arrow Narrow Right',
    category: IconCategoryId.ARROWS,
  },
  ArrowRight: {
    icon: ArrowRight,
    label: 'Arrow Right',
    category: IconCategoryId.ARROWS,
  },
  ArrowRightToLine: {
    icon: ArrowRightToLine,
    label: 'Arrow Right To Line',
    category: IconCategoryId.ARROWS,
  },
  ArrowsDown: {
    icon: ArrowsDown,
    label: 'Arrows Down',
    category: IconCategoryId.ARROWS,
  },
  ArrowsLeft: {
    icon: ArrowsLeft,
    label: 'Arrows Left',
    category: IconCategoryId.ARROWS,
  },
  ArrowSquareUpRight: {
    icon: ArrowSquareUpRight,
    label: 'Arrow Square Up Right',
    category: IconCategoryId.ARROWS,
  },
  ArrowsRight: {
    icon: ArrowsRight,
    label: 'Arrows Right',
    category: IconCategoryId.ARROWS,
  },
  ArrowsUp: {
    icon: ArrowsUp,
    label: 'Arrows Up',
    category: IconCategoryId.ARROWS,
  },
  ArrowUp: {
    icon: ArrowUp,
    label: 'Arrow Up',
    category: IconCategoryId.ARROWS,
  },
  ArrowUpToLine: {
    icon: ArrowUpToLine,
    label: 'Arrow Up To Line',
    category: IconCategoryId.ARROWS,
  },
  Atom02: {
    icon: Atom02,
    label: 'Atom',
    category: IconCategoryId.EDUCATION,
  },
  AtSign: {
    icon: AtSign,
    label: 'At Sign',
    category: IconCategoryId.GENERAL,
  },
  AxisStatusBacklog: {
    icon: AxisStatusBacklog,
    label: 'Axis Status Backlog',
    category: IconCategoryId.GENERAL,
  },
  AxisStatusCanceled: {
    icon: AxisStatusCanceled,
    label: 'Axis Status Canceled',
    category: IconCategoryId.GENERAL,
  },
  AxisStatusCompleted: {
    icon: AxisStatusCompleted,
    label: 'Axis Status Completed',
    category: IconCategoryId.GENERAL,
  },
  AxisStatusInProgress: {
    icon: AxisStatusInProgress,
    label: 'Axis Status In Progress',
    category: IconCategoryId.GENERAL,
  },
  AxisStatusInReview: {
    icon: AxisStatusInReview,
    label: 'Axis Status In Review',
    category: IconCategoryId.GENERAL,
  },
  AxisStatusPlanned: {
    icon: AxisStatusPlanned,
    label: 'Axis Status Planned',
    category: IconCategoryId.GENERAL,
  },
  AxisStatusStarted: {
    icon: AxisStatusStarted,
    label: 'Axis Status Started',
    category: IconCategoryId.GENERAL,
  },
  AxisStatusStarted100: {
    icon: AxisStatusStarted100,
    label: 'Axis Status Started 100',
    category: IconCategoryId.GENERAL,
  },
  AxisStatusStarted25: {
    icon: AxisStatusStarted25,
    label: 'Axis Status Started 25',
    category: IconCategoryId.GENERAL,
  },
  AxisStatusUnstarted: {
    icon: AxisStatusUnstarted,
    label: 'Axis Status Unstarted',
    category: IconCategoryId.GENERAL,
  },
  BarChart10: {
    icon: BarChart10,
    label: 'Bar Chart',
    category: IconCategoryId.CHARTS,
  },
  BarChartSquare01: {
    icon: BarChartSquare01,
    label: 'Bar Chart Square',
    category: IconCategoryId.CHARTS,
  },
  BellNotification: {
    icon: BellNotification,
    label: 'Bell Notification',
    category: IconCategoryId.GENERAL,
  },
  Bloomberg: {
    icon: Bloomberg,
    label: 'Bloomberg',
    category: IconCategoryId.LOGOS,
  },
  BracketsCheck: {
    icon: BracketsCheck,
    label: 'Brackets Check',
    category: IconCategoryId.DEVELOPMENT,
  },
  BracketsEllipses: {
    icon: BracketsEllipses,
    label: 'Brackets Ellipses',
    category: IconCategoryId.DEVELOPMENT,
  },
  BracketsSquare: {
    icon: BracketsSquare,
    label: 'Brackets Square',
    category: IconCategoryId.DEVELOPMENT,
  },
  BriefCase02: {
    icon: BriefCase02,
    label: 'Briefcase',
    category: IconCategoryId.EDUCATION,
  },
  BubbleChart: {
    icon: BubbleChart,
    label: 'Bubble Chart',
    category: IconCategoryId.CHARTS,
  },
  Bug: {
    icon: Bug,
    label: 'Bug',
    category: IconCategoryId.DEVELOPMENT,
  },
  Calendar: {
    icon: Calendar,
    label: 'Calendar',
    category: IconCategoryId.TIME,
  },
  CalendarDate02: {
    icon: CalendarDate02,
    label: 'Calendar Date',
    category: IconCategoryId.TIME,
  },
  CalendarMonthView: {
    icon: CalendarMonthView,
    label: 'Calendar Month View',
    category: IconCategoryId.LAYOUT,
  },
  CalendarSingleDayView: {
    icon: CalendarSingleDayView,
    label: 'Calendar Single Day View',
    category: IconCategoryId.LAYOUT,
  },
  CalendarSolid: {
    icon: CalendarSolid,
    label: 'Calendar Solid',
    category: IconCategoryId.TIME,
  },
  CalendarTwoDayView: {
    icon: CalendarTwoDayView,
    label: 'Calendar Two Day View',
    category: IconCategoryId.LAYOUT,
  },
  Chat: {
    icon: Chat,
    label: 'Chat',
    category: IconCategoryId.COMMUNICATION,
  },
  ChatRoundLine: {
    icon: ChatRoundLine,
    label: 'Chat Round Line',
    category: IconCategoryId.COMMUNICATION,
  },
  CheckCircleBroken: {
    icon: CheckCircleBroken,
    label: 'Check Circle Broken',
    category: IconCategoryId.GENERAL,
  },
  CheckHeart: {
    icon: CheckHeart,
    label: 'Check Heart',
    category: IconCategoryId.GENERAL,
  },
  CheckSquare: {
    icon: CheckSquare,
    label: 'Check Square',
    category: IconCategoryId.GENERAL,
  },
  ChevronDown: {
    icon: ChevronDown,
    label: 'Chevron Down',
    category: IconCategoryId.ARROWS,
  },
  ChevronDownDouble: {
    icon: ChevronDownDouble,
    label: 'Chevron Down Double',
    category: IconCategoryId.ARROWS,
  },
  ChevronDownSm: {
    icon: ChevronDownSm,
    label: 'Chevron Down Small',
    category: IconCategoryId.ARROWS,
  },
  ChevronLeft: {
    icon: ChevronLeft,
    label: 'Chevron Left',
    category: IconCategoryId.ARROWS,
  },
  ChevronLeftDouble: {
    icon: ChevronLeftDouble,
    label: 'Chevron Left Double',
    category: IconCategoryId.ARROWS,
  },
  ChevronRight: {
    icon: ChevronRight,
    label: 'Chevron Right',
    category: IconCategoryId.ARROWS,
  },
  ChevronRightDouble: {
    icon: ChevronRightDouble,
    label: 'Chevron Right Double',
    category: IconCategoryId.ARROWS,
  },
  ChevronSelectorVertical: {
    icon: ChevronSelectorVertical,
    label: 'Chevron Selector',
    category: IconCategoryId.ARROWS,
  },
  ChevronUp: {
    icon: ChevronUp,
    label: 'Chevron Up',
    category: IconCategoryId.ARROWS,
  },
  ChevronUpDouble: {
    icon: ChevronUpDouble,
    label: 'Chevron Up Double',
    category: IconCategoryId.ARROWS,
  },
  Clock: {
    icon: Clock,
    label: 'Clock',
    category: IconCategoryId.TIME,
  },
  ClockFastForward: {
    icon: ClockFastForward,
    label: 'Clock Fast Forward',
    category: IconCategoryId.TIME,
  },
  ClockRefresh: {
    icon: ClockRefresh,
    label: 'Clock Refresh',
    category: IconCategoryId.TIME,
  },
  ClockStopwatch: {
    icon: ClockStopwatch,
    label: 'Stopwatch',
    category: IconCategoryId.TIME,
  },
  Code01: {
    icon: Code01,
    label: 'Code 1',
    category: IconCategoryId.DEVELOPMENT,
  },
  Code02: {
    icon: Code02,
    label: 'Code 2',
    category: IconCategoryId.DEVELOPMENT,
  },
  Codepen: {
    icon: Codepen,
    label: 'CodePen',
    category: IconCategoryId.DEVELOPMENT,
  },
  CodeSnippet02: {
    icon: CodeSnippet02,
    label: 'Code Snippet 02',
    category: IconCategoryId.GENERAL,
  },
  Coins03: {
    icon: Coins03,
    label: 'Coins',
    category: IconCategoryId.FINANCE,
  },
  CoinsStacked04: {
    icon: CoinsStacked04,
    label: 'Coins Stacked',
    category: IconCategoryId.FINANCE,
  },
  CollapseAll: {
    icon: CollapseAll,
    label: 'Collapse All',
    category: IconCategoryId.GENERAL,
  },
  ColoredMoon: {
    icon: ColoredMoon,
    label: 'Colored Moon',
    category: IconCategoryId.GENERAL,
  },
  ColoredSun: {
    icon: ColoredSun,
    label: 'Colored Sun',
    category: IconCategoryId.GENERAL,
  },
  Command: {
    icon: Command,
    label: 'Command',
    category: IconCategoryId.GENERAL,
  },
  Container: {
    icon: Container,
    label: 'Container',
    category: IconCategoryId.DEVELOPMENT,
  },
  ControlWalkthrough: {
    icon: ControlWalkthrough,
    label: 'Control Walkthrough',
    category: IconCategoryId.COMPONENTS,
  },
  Copy01: {
    icon: Copy01,
    label: 'Copy',
    category: IconCategoryId.GENERAL,
  },
  Cross: {
    icon: Cross,
    label: 'Close',
    category: IconCategoryId.GENERAL,
  },
  Csv: {
    icon: Csv,
    label: 'CSV',
    category: IconCategoryId.FILES,
  },
  Cube02: {
    icon: Cube02,
    label: 'Cube',
    category: IconCategoryId.GENERAL,
  },
  CursorBox: {
    icon: CursorBox,
    label: 'Cursor Box',
    category: IconCategoryId.GENERAL,
  },
  CursorInteractive: {
    icon: CursorInteractive,
    label: 'Cursor Interactive',
    category: IconCategoryId.GENERAL,
  },
  CustomConnector01: {
    icon: CustomConnector01,
    label: 'Custom Connector',
    category: IconCategoryId.DEVELOPMENT,
  },
  Dash2: {
    icon: Dash2,
    label: 'Dash 2',
    category: IconCategoryId.GENERAL,
  },
  Database01: {
    icon: Database01,
    label: 'Database 1',
    category: IconCategoryId.DEVELOPMENT,
  },
  Database01Filled: {
    icon: Database01Filled,
    label: 'Database01 Filled',
    category: IconCategoryId.DEVELOPMENT,
  },
  Dataflow02: {
    icon: Dataflow02,
    label: 'Data Flow 2',
    category: IconCategoryId.DEVELOPMENT,
  },
  Dataflow04: {
    icon: Dataflow04,
    label: 'Data Flow 4',
    category: IconCategoryId.DEVELOPMENT,
  },
  DataTypeArray: {
    icon: DataTypeArray,
    label: 'Array Type',
    category: IconCategoryId.EDITOR,
  },
  DataTypeArrayZero: {
    icon: DataTypeArrayZero,
    label: 'Array Zero Type',
    category: IconCategoryId.EDITOR,
  },
  DataTypeBinary: {
    icon: DataTypeBinary,
    label: 'Binary Type',
    category: IconCategoryId.EDITOR,
  },
  DataTypeBoolean: {
    icon: DataTypeBoolean,
    label: 'Boolean Type',
    category: IconCategoryId.EDITOR,
  },
  DataTypeDate: {
    icon: DataTypeDate,
    label: 'Date Type',
    category: IconCategoryId.EDITOR,
  },
  DataTypeDatetime: {
    icon: DataTypeDatetime,
    label: 'Date Time Type',
    category: IconCategoryId.EDITOR,
  },
  DataTypeDecimal: {
    icon: DataTypeDecimal,
    label: 'Decimal Type',
    category: IconCategoryId.EDITOR,
  },
  DataTypeDouble: {
    icon: DataTypeDouble,
    label: 'Double Type',
    category: IconCategoryId.EDITOR,
  },
  DataTypeInteger: {
    icon: DataTypeInteger,
    label: 'Integer Type',
    category: IconCategoryId.EDITOR,
  },
  DataTypeObject: {
    icon: DataTypeObject,
    label: 'Object Type',
    category: IconCategoryId.EDITOR,
  },
  DataTypeText: {
    icon: DataTypeText,
    label: 'Text Type',
    category: IconCategoryId.EDITOR,
  },
  DataTypeTime: {
    icon: DataTypeTime,
    label: 'Time Type',
    category: IconCategoryId.EDITOR,
  },
  DataTypeTimestamp: {
    icon: DataTypeTimestamp,
    label: 'Timestamp Type',
    category: IconCategoryId.TIME,
  },
  Debugger: {
    icon: Debugger,
    label: 'Debugger',
    category: IconCategoryId.GENERAL,
  },
  Decimal: {
    icon: Decimal,
    label: 'Decimal',
    category: IconCategoryId.EDITOR,
  },
  Doc: {
    icon: Doc,
    label: 'DOC',
    category: IconCategoryId.FILES,
  },
  Docx: {
    icon: Docx,
    label: 'DOCX',
    category: IconCategoryId.FILES,
  },
  DotsGrid: {
    icon: DotsGrid,
    label: 'Dots Grid',
    category: IconCategoryId.LAYOUT,
  },
  DotsHorizontal: {
    icon: DotsHorizontal,
    label: 'More Horizontal',
    category: IconCategoryId.GENERAL,
  },
  DotsVertical: {
    icon: DotsVertical,
    label: 'More Vertical',
    category: IconCategoryId.GENERAL,
  },
  Double: {
    icon: Double,
    label: 'Double',
    category: IconCategoryId.EDITOR,
  },
  DualAxesLineChartUp01: {
    icon: DualAxesLineChartUp01,
    label: 'Dual Axes Line Chart',
    category: IconCategoryId.CHARTS,
  },
  Edit01: {
    icon: Edit01,
    label: 'Edit 1',
    category: IconCategoryId.GENERAL,
  },
  Edit05: {
    icon: Edit05,
    label: 'Edit 5',
    category: IconCategoryId.GENERAL,
  },
  Epubs: {
    icon: Epubs,
    label: 'EPUB',
    category: IconCategoryId.FILES,
  },
  ErrorOutline: {
    icon: ErrorOutline,
    label: 'Error Outline',
    category: IconCategoryId.ALERTS_AND_FEEDBACK,
  },
  EventPayload: {
    icon: EventPayload,
    label: 'Event Payload',
    category: IconCategoryId.GENERAL,
  },
  Expand06: {
    icon: Expand06,
    label: 'Expand',
    category: IconCategoryId.LAYOUT,
  },
  ExpandAll: {
    icon: ExpandAll,
    label: 'Expand All',
    category: IconCategoryId.GENERAL,
  },
  ExtractData02: {
    icon: ExtractData02,
    label: 'ExtractData02',
    category: IconCategoryId.GENERAL,
  },
  Facebook: {
    icon: Facebook,
    label: 'Facebook',
    category: IconCategoryId.LOGOS,
  },
  FaceSmile: {
    icon: FaceSmile,
    label: 'Face Smile',
    category: IconCategoryId.USERS,
  },
  File02: {
    icon: File02,
    label: 'File 2',
    category: IconCategoryId.FILES,
  },
  File05: {
    icon: File05,
    label: 'File 5',
    category: IconCategoryId.FILES,
  },
  File05Filled: {
    icon: File05Filled,
    label: 'File 5 Filled',
    category: IconCategoryId.FILES,
  },
  FileCheck02: {
    icon: FileCheck02,
    label: 'File Check 2',
    category: IconCategoryId.FILES,
  },
  FileCode01: {
    icon: FileCode01,
    label: 'File Code 1',
    category: IconCategoryId.DEVELOPMENT,
  },
  FileDownload03: {
    icon: FileDownload03,
    label: 'File Download',
    category: IconCategoryId.FILES,
  },
  FilePlus02: {
    icon: FilePlus02,
    label: 'File Plus 2',
    category: IconCategoryId.FILES,
  },
  FileQuestion02: {
    icon: FileQuestion02,
    label: 'File Question 2',
    category: IconCategoryId.FILES,
  },
  FileSearch02: {
    icon: FileSearch02,
    label: 'File Search 2',
    category: IconCategoryId.FILES,
  },
  FileShield02: {
    icon: FileShield02,
    label: 'File Shield',
    category: IconCategoryId.SECURITY,
  },
  FileX02: {
    icon: FileX02,
    label: 'File X 2',
    category: IconCategoryId.FILES,
  },
  FileX03: {
    icon: FileX03,
    label: 'File X',
    category: IconCategoryId.FILES,
  },
  FilterLines: {
    icon: FilterLines,
    label: 'Filter',
    category: IconCategoryId.GENERAL,
  },
  FilterLines02: {
    icon: FilterLines02,
    label: 'Filter_2',
    category: IconCategoryId.GENERAL,
  },
  Fold: {
    icon: Fold,
    label: 'Fold',
    category: IconCategoryId.GENERAL,
  },
  FolderColored: {
    icon: FolderColored,
    label: 'Folder Colored',
    category: IconCategoryId.FILES,
  },
  Gauge: {
    icon: Gauge,
    label: 'Gauge',
    category: IconCategoryId.GENERAL,
  },
  GenAiApps: {
    icon: GenAiApps,
    label: 'GenAiApps',
    category: IconCategoryId.AI,
  },
  GitBranch01: {
    icon: GitBranch01,
    label: 'Git Branch',
    category: IconCategoryId.DEVELOPMENT,
  },
  Github: {
    icon: Github,
    label: 'Github',
    category: IconCategoryId.DEVELOPMENT,
  },
  Gitlab: {
    icon: Gitlab,
    label: 'Gitlab',
    category: IconCategoryId.DEVELOPMENT,
  },
  Globe01: {
    icon: Globe01,
    label: 'Globe',
    category: IconCategoryId.TRAVEL,
  },
  GoogleMaps: {
    icon: GoogleMaps,
    label: 'Google Maps',
    category: IconCategoryId.TRAVEL,
  },
  Governance: {
    icon: Governance,
    label: 'Governance',
    category: IconCategoryId.USERS,
  },
  GridDotsBottom: {
    icon: GridDotsBottom,
    label: 'Grid Dots Bottom',
    category: IconCategoryId.LAYOUT,
  },
  GridDotsLeft: {
    icon: GridDotsLeft,
    label: 'Grid Dots Left',
    category: IconCategoryId.LAYOUT,
  },
  GridDotsOuter: {
    icon: GridDotsOuter,
    label: 'Grid Dots Outer',
    category: IconCategoryId.LAYOUT,
  },
  GridDotsRight: {
    icon: GridDotsRight,
    label: 'Grid Dots Right',
    category: IconCategoryId.LAYOUT,
  },
  GridDotsTop: {
    icon: GridDotsTop,
    label: 'Grid Dots Top',
    category: IconCategoryId.LAYOUT,
  },
  Hash01: {
    icon: Hash01,
    label: 'Hash',
    category: IconCategoryId.GENERAL,
  },
  Headphones01: {
    icon: Headphones01,
    label: 'Headphones',
    category: IconCategoryId.MEDIA_AND_DEVICES,
  },
  HealthMeter: {
    icon: HealthMeter,
    label: 'HealthMeter',
    category: IconCategoryId.GENERAL,
  },
  Heart: {
    icon: Heart,
    label: 'Heart',
    category: IconCategoryId.GENERAL,
  },
  HeartFilled: {
    icon: HeartFilled,
    label: 'Heart Filled',
    category: IconCategoryId.GENERAL,
  },
  HelpCircle: {
    icon: HelpCircle,
    label: 'Help',
    category: IconCategoryId.GENERAL,
  },
  Home01: {
    icon: Home01,
    label: 'Home 1',
    category: IconCategoryId.GENERAL,
  },
  Home02: {
    icon: Home02,
    label: 'Home 2',
    category: IconCategoryId.GENERAL,
  },
  Home03: {
    icon: Home03,
    label: 'Home 3',
    category: IconCategoryId.GENERAL,
  },
  Home04: {
    icon: Home04,
    label: 'Home 4',
    category: IconCategoryId.GENERAL,
  },
  Home05: {
    icon: Home05,
    label: 'Home 5',
    category: IconCategoryId.GENERAL,
  },
  HomeLine: {
    icon: HomeLine,
    label: 'Home Line',
    category: IconCategoryId.GENERAL,
  },
  HomeSmile: {
    icon: HomeSmile,
    label: 'Home Smile',
    category: IconCategoryId.GENERAL,
  },
  HomeWhite: {
    icon: HomeWhite,
    label: 'Home White',
    category: IconCategoryId.GENERAL,
  },
  HorizontalBarChart02: {
    icon: HorizontalBarChart02,
    label: 'Horizontal Bar Chart',
    category: IconCategoryId.CHARTS,
  },
  Hourglass01: {
    icon: Hourglass01,
    label: 'Hourglass',
    category: IconCategoryId.TIME,
  },
  Image01: {
    icon: Image01,
    label: 'Image 1',
    category: IconCategoryId.IMAGES,
  },
  InfoCircle: {
    icon: InfoCircle,
    label: 'Info Circle',
    category: IconCategoryId.GENERAL,
  },
  Integer: {
    icon: Integer,
    label: 'Integer',
    category: IconCategoryId.EDITOR,
  },
  IntersectCircle: {
    icon: IntersectCircle,
    label: 'Intersect Circle',
    category: IconCategoryId.LAYOUT,
  },
  Json: {
    icon: Json,
    label: 'JSON',
    category: IconCategoryId.FILES,
  },
  Laptop02: {
    icon: Laptop02,
    label: 'Laptop',
    category: IconCategoryId.MEDIA_AND_DEVICES,
  },
  LayersThree01: {
    icon: LayersThree01,
    label: 'Layers 1',
    category: IconCategoryId.LAYOUT,
  },
  LayersThree02: {
    icon: LayersThree02,
    label: 'Layers 2',
    category: IconCategoryId.LAYOUT,
  },
  LayersTwo01: {
    icon: LayersTwo01,
    label: 'Layers 2',
    category: IconCategoryId.LAYOUT,
  },
  LayoutAlt01: {
    icon: LayoutAlt01,
    label: 'Layout Alternative 1',
    category: IconCategoryId.LAYOUT,
  },
  LayoutAlt04: {
    icon: LayoutAlt04,
    label: 'Layout Alternative 4',
    category: IconCategoryId.LAYOUT,
  },
  LayoutBottom: {
    icon: LayoutBottom,
    label: 'Layout Bottom',
    category: IconCategoryId.LAYOUT,
  },
  LayoutLeft: {
    icon: LayoutLeft,
    label: 'Layout Left',
    category: IconCategoryId.LAYOUT,
  },
  LayoutRight: {
    icon: LayoutRight,
    label: 'Layout Right',
    category: IconCategoryId.LAYOUT,
  },
  LayoutTop: {
    icon: LayoutTop,
    label: 'Layout Top',
    category: IconCategoryId.LAYOUT,
  },
  LcBarChart: {
    icon: LcBarChart,
    label: 'Bar Chart',
    category: IconCategoryId.CHARTS,
  },
  LcFileUpload: {
    icon: LcFileUpload,
    label: 'File Upload',
    category: IconCategoryId.FILES,
  },
  LcForm: {
    icon: LcForm,
    label: 'Form',
    category: IconCategoryId.LAYOUT,
  },
  LcSectionColumn: {
    icon: LcSectionColumn,
    label: 'Section Column',
    category: IconCategoryId.LAYOUT,
  },
  LcStatus: {
    icon: LcStatus,
    label: 'Status',
    category: IconCategoryId.GENERAL,
  },
  Lightbulb02: {
    icon: Lightbulb02,
    label: 'Lightbulb 2',
    category: IconCategoryId.GENERAL,
  },
  LineChartUp01: {
    icon: LineChartUp01,
    label: 'Line Chart Up',
    category: IconCategoryId.CHARTS,
  },
  LineLineChart: {
    icon: LineLineChart,
    label: 'Line Chart',
    category: IconCategoryId.CHARTS,
  },
  Link01: {
    icon: Link01,
    label: 'Link 1',
    category: IconCategoryId.GENERAL,
  },
  LinkBroken01: {
    icon: LinkBroken01,
    label: 'Broken Link',
    category: IconCategoryId.GENERAL,
  },
  Linkedin: {
    icon: Linkedin,
    label: 'LinkedIn',
    category: IconCategoryId.LOGOS,
  },
  LinkExternal01: {
    icon: LinkExternal01,
    label: 'External Link',
    category: IconCategoryId.GENERAL,
  },
  List: {
    icon: List,
    label: 'List',
    category: IconCategoryId.LAYOUT,
  },
  ListSolid: {
    icon: ListSolid,
    label: 'List Solid',
    category: IconCategoryId.LAYOUT,
  },
  Lock03: {
    icon: Lock03,
    label: 'Lock 3',
    category: IconCategoryId.SECURITY,
  },
  Lock04Filled: {
    icon: Lock04Filled,
    label: 'Lock 4 Filled',
    category: IconCategoryId.SECURITY,
  },
  Logout01: {
    icon: Logout01,
    label: 'Logout',
    category: IconCategoryId.GENERAL,
  },
  Loop: {
    icon: Loop,
    label: 'Loop',
    category: IconCategoryId.DEVELOPMENT,
  },
  Mail01: {
    icon: Mail01,
    label: 'Mail',
    category: IconCategoryId.COMMUNICATION,
  },
  Mark: {
    icon: Mark,
    label: 'Mark',
    category: IconCategoryId.TRAVEL,
  },
  Menu01: {
    icon: Menu01,
    label: 'Menu 1',
    category: IconCategoryId.GENERAL,
  },
  Menu03: {
    icon: Menu03,
    label: 'Menu 3',
    category: IconCategoryId.GENERAL,
  },
  MessageAlertSquare: {
    icon: MessageAlertSquare,
    label: 'Message Alert Square',
    category: IconCategoryId.COMMUNICATION,
  },
  MessagePlusSquare: {
    icon: MessagePlusSquare,
    label: 'Message Plus Square',
    category: IconCategoryId.COMMUNICATION,
  },
  MessageQuestionSquare: {
    icon: MessageQuestionSquare,
    label: 'Message Question Square',
    category: IconCategoryId.GENERAL,
  },
  MessageSmileSquare: {
    icon: MessageSmileSquare,
    label: 'Message Smile Square',
    category: IconCategoryId.COMMUNICATION,
  },
  MessageSmileSquareSolid: {
    icon: MessageSmileSquareSolid,
    label: 'Message Smile Square',
    category: IconCategoryId.COMMUNICATION,
  },
  MessageTextSquare02: {
    icon: MessageTextSquare02,
    label: 'Message Text Square',
    category: IconCategoryId.COMMUNICATION,
  },
  Microphone01: {
    icon: Microphone01,
    label: 'Microphone',
    category: IconCategoryId.MEDIA_AND_DEVICES,
  },
  MicrophoneOff01: {
    icon: MicrophoneOff01,
    label: 'Microphone Off',
    category: IconCategoryId.MEDIA_AND_DEVICES,
  },
  Minimize02: {
    icon: Minimize02,
    label: 'Minimize',
    category: IconCategoryId.LAYOUT,
  },
  Minus: {
    icon: Minus,
    label: 'Minus',
    category: IconCategoryId.GENERAL,
  },
  Mode: {
    icon: Mode,
    label: 'Mode',
    category: IconCategoryId.GENERAL,
  },
  Monitor01: {
    icon: Monitor01,
    label: 'Monitor',
    category: IconCategoryId.MEDIA_AND_DEVICES,
  },
  MonitorOff01: {
    icon: MonitorOff01,
    label: 'Monitor Off',
    category: IconCategoryId.MEDIA_AND_DEVICES,
  },
  Move: {
    icon: Move,
    label: 'Move',
    category: IconCategoryId.GENERAL,
  },
  MultiDevice: {
    icon: MultiDevice,
    label: 'Multi Device',
    category: IconCategoryId.MEDIA_AND_DEVICES,
  },
  NetworkGraph: {
    icon: NetworkGraph,
    label: 'Network Graph',
    category: IconCategoryId.DEVELOPMENT,
  },
  NoCodeAlert: {
    icon: NoCodeAlert,
    label: 'Alert',
    category: IconCategoryId.ALERTS_AND_FEEDBACK,
  },
  NoCodeAudioPlayer: {
    icon: NoCodeAudioPlayer,
    label: 'Audio Player',
    category: IconCategoryId.MEDIA_AND_DEVICES,
  },
  NoCodeAvatar: {
    icon: NoCodeAvatar,
    label: 'Avatar',
    category: IconCategoryId.USERS,
  },
  NoCodeAvatarGroup: {
    icon: NoCodeAvatarGroup,
    label: 'Avatar Group',
    category: IconCategoryId.USERS,
  },
  NoCodeBarCode: {
    icon: NoCodeBarCode,
    label: 'NoCodeBarCode',
    category: IconCategoryId.COMPONENTS,
  },
  NoCodeBottomsheet: {
    icon: NoCodeBottomsheet,
    label: 'Bottom Sheet',
    category: IconCategoryId.LAYOUT,
  },
  NoCodeBusinessHour: {
    icon: NoCodeBusinessHour,
    label: 'Business Hours',
    category: IconCategoryId.TIME,
  },
  NoCodeButton: {
    icon: NoCodeButton,
    label: 'Button',
    category: IconCategoryId.LAYOUT,
  },
  NoCodeButtonGroup: {
    icon: NoCodeButtonGroup,
    label: 'Button Group',
    category: IconCategoryId.LAYOUT,
  },
  NoCodeCalendar: {
    icon: NoCodeCalendar,
    label: 'Calendar',
    category: IconCategoryId.TIME,
  },
  NoCodeCamera: {
    icon: NoCodeCamera,
    label: 'Camera',
    category: IconCategoryId.IMAGES,
  },
  NoCodeCanvasEmptyState: {
    icon: NoCodeCanvasEmptyState,
    label: 'No Code Canvas Empty State',
    category: IconCategoryId.GENERAL,
  },
  NoCodeCard: {
    icon: NoCodeCard,
    label: 'Card',
    category: IconCategoryId.LAYOUT,
  },
  NoCodeCarousel: {
    icon: NoCodeCarousel,
    label: 'Carousel',
    category: IconCategoryId.LAYOUT,
  },
  NoCodeCategoryFilter: {
    icon: NoCodeCategoryFilter,
    label: 'Category Filter',
    category: IconCategoryId.GENERAL,
  },
  NoCodeChart: {
    icon: NoCodeChart,
    label: 'Chart',
    category: IconCategoryId.CHARTS,
  },
  NoCodeCheckBox: {
    icon: NoCodeCheckBox,
    label: 'Checkbox',
    category: IconCategoryId.GENERAL,
  },
  NoCodeCodeEditor: {
    icon: NoCodeCodeEditor,
    label: 'Code Editor',
    category: IconCategoryId.DEVELOPMENT,
  },
  NoCodeCollaboration: {
    icon: NoCodeCollaboration,
    label: 'Collaboration',
    category: IconCategoryId.COMMUNICATION,
  },
  NoCodeColorAlert: {
    icon: NoCodeColorAlert,
    label: 'Alert Color',
    category: IconCategoryId.COMPONENTS,
  },
  NoCodeColorAudioPlayer: {
    icon: NoCodeColorAudioPlayer,
    label: 'Audio Player Color',
    category: IconCategoryId.COMPONENTS,
  },
  NoCodeColorAvatar: {
    icon: NoCodeColorAvatar,
    label: 'Avatar Color',
    category: IconCategoryId.COMPONENTS,
  },
  NoCodeColorAvatarGroup: {
    icon: NoCodeColorAvatarGroup,
    label: 'Avatar Group Color',
    category: IconCategoryId.COMPONENTS,
  },
  NoCodeColorBarCode: {
    icon: NoCodeColorBarCode,
    label: 'Bar Code Color',
    category: IconCategoryId.COMPONENTS,
  },
  NoCodeColorBottomsheet: {
    icon: NoCodeColorBottomsheet,
    label: 'Bottom Sheet Color',
    category: IconCategoryId.COMPONENTS,
  },
  NoCodeColorBusinessHour: {
    icon: NoCodeColorBusinessHour,
    label: 'Business Hours Color',
    category: IconCategoryId.COMPONENTS,
  },
  NoCodeColorButton: {
    icon: NoCodeColorButton,
    label: 'Button Color',
    category: IconCategoryId.COMPONENTS,
  },
  NoCodeColorButtonGroup: {
    icon: NoCodeColorButtonGroup,
    label: 'Button Group Color',
    category: IconCategoryId.COMPONENTS,
  },
  NoCodeColorCalendar: {
    icon: NoCodeColorCalendar,
    label: 'Calendar Color',
    category: IconCategoryId.COMPONENTS,
  },
  NoCodeColorCamera: {
    icon: NoCodeColorCamera,
    label: 'Camera Color',
    category: IconCategoryId.COMPONENTS,
  },
  NoCodeColorCard: {
    icon: NoCodeColorCard,
    label: 'Card Color',
    category: IconCategoryId.COMPONENTS,
  },
  NoCodeColorCarousel: {
    icon: NoCodeColorCarousel,
    label: 'Carousel Color',
    category: IconCategoryId.COMPONENTS,
  },
  NoCodeColorCategoryFilter: {
    icon: NoCodeColorCategoryFilter,
    label: 'Category Filter Color',
    category: IconCategoryId.COMPONENTS,
  },
  NoCodeColorChart: {
    icon: NoCodeColorChart,
    label: 'Chart Color',
    category: IconCategoryId.COMPONENTS,
  },
  NoCodeColorCodeEditor: {
    icon: NoCodeColorCodeEditor,
    label: 'Code Editor Color',
    category: IconCategoryId.COMPONENTS,
  },
  NoCodeColorCollaboration: {
    icon: NoCodeColorCollaboration,
    label: 'Collaboration Color',
    category: IconCategoryId.COMPONENTS,
  },
  NoCodeColorComment: {
    icon: NoCodeColorComment,
    label: 'Comment Color',
    category: IconCategoryId.COMPONENTS,
  },
  NoCodeColorContainer: {
    icon: NoCodeColorContainer,
    label: 'Container Color',
    category: IconCategoryId.COMPONENTS,
  },
  NoCodeColorContextualDialog: {
    icon: NoCodeColorContextualDialog,
    label: 'Contextual Dialog Color',
    category: IconCategoryId.COMPONENTS,
  },
  NoCodeColorCopilot: {
    icon: NoCodeColorCopilot,
    label: 'Copilot Color',
    category: IconCategoryId.COMPONENTS,
  },
  NoCodeColorDatePicker: {
    icon: NoCodeColorDatePicker,
    label: 'Date Picker Color',
    category: IconCategoryId.COMPONENTS,
  },
  NoCodeColorDictation: {
    icon: NoCodeColorDictation,
    label: 'Dictation Color',
    category: IconCategoryId.COMPONENTS,
  },
  NoCodeColorDivider: {
    icon: NoCodeColorDivider,
    label: 'Divider Color',
    category: IconCategoryId.COMPONENTS,
  },
  NoCodeColorDropdown: {
    icon: NoCodeColorDropdown,
    label: 'Dropdown Color',
    category: IconCategoryId.COMPONENTS,
  },
  NoCodeColorEventsCalendar: {
    icon: NoCodeColorEventsCalendar,
    label: 'Events Calendar Color',
    category: IconCategoryId.COMPONENTS,
  },
  NoCodeColorFileUpload: {
    icon: NoCodeColorFileUpload,
    label: 'File Upload Color',
    category: IconCategoryId.COMPONENTS,
  },
  NoCodeColorFilters: {
    icon: NoCodeColorFilters,
    label: 'Filters Color',
    category: IconCategoryId.COMPONENTS,
  },
  NoCodeColorFlippable: {
    icon: NoCodeColorFlippable,
    label: 'Flippable',
    category: IconCategoryId.COMPONENTS,
  },
  NoCodeColorForm: {
    icon: NoCodeColorForm,
    label: 'Form Color',
    category: IconCategoryId.COMPONENTS,
  },
  NoCodeColorGrid: {
    icon: NoCodeColorGrid,
    label: 'Grid Color',
    category: IconCategoryId.COMPONENTS,
  },
  NoCodeColorIcon: {
    icon: NoCodeColorIcon,
    label: 'Icon Color',
    category: IconCategoryId.COMPONENTS,
  },
  NoCodeColorIconButton: {
    icon: NoCodeColorIconButton,
    label: 'Icon Button Color',
    category: IconCategoryId.COMPONENTS,
  },
  NoCodeColorIframe: {
    icon: NoCodeColorIframe,
    label: 'iFrame Color',
    category: IconCategoryId.COMPONENTS,
  },
  NoCodeColorImage: {
    icon: NoCodeColorImage,
    label: 'Image Color',
    category: IconCategoryId.COMPONENTS,
  },
  NoCodeColorInputDate: {
    icon: NoCodeColorInputDate,
    label: 'Date Input Color',
    category: IconCategoryId.COMPONENTS,
  },
  NoCodeColorInputDateTime: {
    icon: NoCodeColorInputDateTime,
    label: 'Date Time Input Color',
    category: IconCategoryId.COMPONENTS,
  },
  NoCodeColorInputTime: {
    icon: NoCodeColorInputTime,
    label: 'Time Input Color',
    category: IconCategoryId.COMPONENTS,
  },
  NoCodeColorKeyValue: {
    icon: NoCodeColorKeyValue,
    label: 'Key Value Color',
    category: IconCategoryId.COMPONENTS,
  },
  NoCodeColorLink: {
    icon: NoCodeColorLink,
    label: 'Link Color',
    category: IconCategoryId.COMPONENTS,
  },
  NoCodeColorLoader: {
    icon: NoCodeColorLoader,
    label: 'Loader Color',
    category: IconCategoryId.COMPONENTS,
  },
  NoCodeColorMedia: {
    icon: NoCodeColorMedia,
    label: 'Media Color',
    category: IconCategoryId.COMPONENTS,
  },
  NoCodeColorMenu: {
    icon: NoCodeColorMenu,
    label: 'Menu Color',
    category: IconCategoryId.COMPONENTS,
  },
  NoCodeColorMessageInput: {
    icon: NoCodeColorMessageInput,
    label: 'Message Input Color',
    category: IconCategoryId.COMPONENTS,
  },
  NoCodeColorModal: {
    icon: NoCodeColorModal,
    label: 'Modal Color',
    category: IconCategoryId.COMPONENTS,
  },
  NoCodeColorMultiStatCard: {
    icon: NoCodeColorMultiStatCard,
    label: 'Multi Stat Card Color',
    category: IconCategoryId.COMPONENTS,
  },
  NoCodeColorNavigation: {
    icon: NoCodeColorNavigation,
    label: 'Navigation Color',
    category: IconCategoryId.COMPONENTS,
  },
  NoCodeColorNavigationContainer: {
    icon: NoCodeColorNavigationContainer,
    label: 'Navigation Container Color',
    category: IconCategoryId.COMPONENTS,
  },
  NoCodeColorNestedTable: {
    icon: NoCodeColorNestedTable,
    label: 'Nested Table Color',
    category: IconCategoryId.COMPONENTS,
  },
  NoCodeColorPassword: {
    icon: NoCodeColorPassword,
    label: 'Password Color',
    category: IconCategoryId.COMPONENTS,
  },
  NoCodeColorPdfViewer: {
    icon: NoCodeColorPdfViewer,
    label: 'PDF Viewer Color',
    category: IconCategoryId.COMPONENTS,
  },
  NoCodeColorPhoneNumber: {
    icon: NoCodeColorPhoneNumber,
    label: 'Phone Number Color',
    category: IconCategoryId.COMPONENTS,
  },
  NoCodeColorPinInput: {
    icon: NoCodeColorPinInput,
    label: 'Pin Input Color',
    category: IconCategoryId.COMPONENTS,
  },
  NoCodeColorPressable: {
    icon: NoCodeColorPressable,
    label: 'Pressable Color',
    category: IconCategoryId.COMPONENTS,
  },
  NoCodeColorProgressBar: {
    icon: NoCodeColorProgressBar,
    label: 'Progress Bar Color',
    category: IconCategoryId.COMPONENTS,
  },
  NoCodeColorQrCode: {
    icon: NoCodeColorQrCode,
    label: 'QR Code Color',
    category: IconCategoryId.COMPONENTS,
  },
  NoCodeColorRadioButton: {
    icon: NoCodeColorRadioButton,
    label: 'Radio Button Color',
    category: IconCategoryId.COMPONENTS,
  },
  NoCodeColorRating: {
    icon: NoCodeColorRating,
    label: 'Rating Color',
    category: IconCategoryId.COMPONENTS,
  },
  NoCodeColorRecords: {
    icon: NoCodeColorRecords,
    label: 'Records Color',
    category: IconCategoryId.COMPONENTS,
  },
  NoCodeColorRepeatable: {
    icon: NoCodeColorRepeatable,
    label: 'Repeatable Color',
    category: IconCategoryId.COMPONENTS,
  },
  NoCodeColorRepeatableList: {
    icon: NoCodeColorRepeatableList,
    label: 'Repeatable List Color',
    category: IconCategoryId.COMPONENTS,
  },
  NoCodeColorRichtext: {
    icon: NoCodeColorRichtext,
    label: 'Rich Text Color',
    category: IconCategoryId.COMPONENTS,
  },
  NoCodeColorScanner: {
    icon: NoCodeColorScanner,
    label: 'Scanner Color',
    category: IconCategoryId.COMPONENTS,
  },
  NoCodeColorSelect: {
    icon: NoCodeColorSelect,
    label: 'Select Color',
    category: IconCategoryId.COMPONENTS,
  },
  NoCodeColorSideDrawer: {
    icon: NoCodeColorSideDrawer,
    label: 'Side Drawer Color',
    category: IconCategoryId.COMPONENTS,
  },
  NoCodeColorSignature: {
    icon: NoCodeColorSignature,
    label: 'Signature Color',
    category: IconCategoryId.COMPONENTS,
  },
  NoCodeColorSlot: {
    icon: NoCodeColorSlot,
    label: 'Slot Color',
    category: IconCategoryId.COMPONENTS,
  },
  NoCodeColorStack: {
    icon: NoCodeColorStack,
    label: 'Stack Color',
    category: IconCategoryId.COMPONENTS,
  },
  NoCodeColorStatCard: {
    icon: NoCodeColorStatCard,
    label: 'Stat Card Color',
    category: IconCategoryId.COMPONENTS,
  },
  NoCodeColorStatus: {
    icon: NoCodeColorStatus,
    label: 'Status Color',
    category: IconCategoryId.COMPONENTS,
  },
  NoCodeColorStepIndicator: {
    icon: NoCodeColorStepIndicator,
    label: 'Step Indicator Color',
    category: IconCategoryId.COMPONENTS,
  },
  NoCodeColorSteppedContainer: {
    icon: NoCodeColorSteppedContainer,
    label: 'Stepped Container Color',
    category: IconCategoryId.COMPONENTS,
  },
  NoCodeColorStepper: {
    icon: NoCodeColorStepper,
    label: 'Stepper Color',
    category: IconCategoryId.COMPONENTS,
  },
  NoCodeColorStepSeparator: {
    icon: NoCodeColorStepSeparator,
    label: 'Step Separator Color',
    category: IconCategoryId.COMPONENTS,
  },
  NoCodeColorStories: {
    icon: NoCodeColorStories,
    label: 'Stories Color',
    category: IconCategoryId.COMPONENTS,
  },
  NoCodeColorSwipeable: {
    icon: NoCodeColorSwipeable,
    label: 'Swipeable Color',
    category: IconCategoryId.COMPONENTS,
  },
  NoCodeColorSwipeableStack: {
    icon: NoCodeColorSwipeableStack,
    label: 'Swipeable Stack',
    category: IconCategoryId.COMPONENTS,
  },
  NoCodeColorTable: {
    icon: NoCodeColorTable,
    label: 'Table Color',
    category: IconCategoryId.COMPONENTS,
  },
  NoCodeColorTabs: {
    icon: NoCodeColorTabs,
    label: 'Tabs Color',
    category: IconCategoryId.COMPONENTS,
  },
  NoCodeColorTag: {
    icon: NoCodeColorTag,
    label: 'Tag Color',
    category: IconCategoryId.COMPONENTS,
  },
  NoCodeColorTemplateComponent: {
    icon: NoCodeColorTemplateComponent,
    label: 'Template Component Color',
    category: IconCategoryId.COMPONENTS,
  },
  NoCodeColorText: {
    icon: NoCodeColorText,
    label: 'Text Color',
    category: IconCategoryId.COMPONENTS,
  },
  NoCodeColorTextArea: {
    icon: NoCodeColorTextArea,
    label: 'Text Area Color',
    category: IconCategoryId.COMPONENTS,
  },
  NoCodeColorTextInput: {
    icon: NoCodeColorTextInput,
    label: 'Text Input Color',
    category: IconCategoryId.COMPONENTS,
  },
  NoCodeColorTimeline: {
    icon: NoCodeColorTimeline,
    label: 'Timeline Color',
    category: IconCategoryId.COMPONENTS,
  },
  NoCodeColorTimer: {
    icon: NoCodeColorTimer,
    label: 'Timer Color',
    category: IconCategoryId.COMPONENTS,
  },
  NoCodeColorVideo: {
    icon: NoCodeColorVideo,
    label: 'Video Color',
    category: IconCategoryId.COMPONENTS,
  },
  NoCodeColumns3: {
    icon: NoCodeColumns3,
    label: 'Three Columns',
    category: IconCategoryId.LAYOUT,
  },
  NoCodeColumns4: {
    icon: NoCodeColumns4,
    label: 'Four Columns',
    category: IconCategoryId.LAYOUT,
  },
  NoCodeColumns5: {
    icon: NoCodeColumns5,
    label: 'Five Columns',
    category: IconCategoryId.LAYOUT,
  },
  NoCodeColumns6: {
    icon: NoCodeColumns6,
    label: 'Six Columns',
    category: IconCategoryId.LAYOUT,
  },
  NoCodeComponentSelection: {
    icon: NoCodeComponentSelection,
    label: 'Component Selection',
    category: IconCategoryId.COMPONENTS,
  },
  NoCodeContainer: {
    icon: NoCodeContainer,
    label: 'Container',
    category: IconCategoryId.LAYOUT,
  },
  NoCodeContainer11: {
    icon: NoCodeContainer11,
    label: 'Container 1:1',
    category: IconCategoryId.LAYOUT,
  },
  NoCodeContainer112: {
    icon: NoCodeContainer112,
    label: 'Container 1:1:2',
    category: IconCategoryId.LAYOUT,
  },
  NoCodeContainer12: {
    icon: NoCodeContainer12,
    label: 'Container 1:2',
    category: IconCategoryId.LAYOUT,
  },
  NoCodeContainer121: {
    icon: NoCodeContainer121,
    label: 'Container 1:2:1',
    category: IconCategoryId.LAYOUT,
  },
  NoCodeContainer13: {
    icon: NoCodeContainer13,
    label: 'Container 1:3',
    category: IconCategoryId.LAYOUT,
  },
  NoCodeContainer21: {
    icon: NoCodeContainer21,
    label: 'Container 2:1',
    category: IconCategoryId.LAYOUT,
  },
  NoCodeContainer211: {
    icon: NoCodeContainer211,
    label: 'Container 2:1:1',
    category: IconCategoryId.LAYOUT,
  },
  NoCodeContainer23: {
    icon: NoCodeContainer23,
    label: 'Container 2:3',
    category: IconCategoryId.LAYOUT,
  },
  NoCodeContainer31: {
    icon: NoCodeContainer31,
    label: 'Container 3:1',
    category: IconCategoryId.LAYOUT,
  },
  NoCodeContainer32: {
    icon: NoCodeContainer32,
    label: 'Container 3:2',
    category: IconCategoryId.LAYOUT,
  },
  NoCodeContextualDialog: {
    icon: NoCodeContextualDialog,
    label: 'Contextual Dialog',
    category: IconCategoryId.LAYOUT,
  },
  NoCodeCopilot: {
    icon: NoCodeCopilot,
    label: 'Copilot',
    category: IconCategoryId.DEVELOPMENT,
  },
  NoCodeDatasource: {
    icon: NoCodeDatasource,
    label: 'Data Source',
    category: IconCategoryId.DEVELOPMENT,
  },
  NoCodeDatePicker: {
    icon: NoCodeDatePicker,
    label: 'Date Picker',
    category: IconCategoryId.TIME,
  },
  NoCodeDictation: {
    icon: NoCodeDictation,
    label: 'Dictation',
    category: IconCategoryId.MEDIA_AND_DEVICES,
  },
  NoCodeDivider: {
    icon: NoCodeDivider,
    label: 'Divider',
    category: IconCategoryId.LAYOUT,
  },
  NoCodeDropdown: {
    icon: NoCodeDropdown,
    label: 'Dropdown',
    category: IconCategoryId.GENERAL,
  },
  NoCodeEventsCalendar: {
    icon: NoCodeEventsCalendar,
    label: 'Events Calendar',
    category: IconCategoryId.TIME,
  },
  NoCodeFileUpload: {
    icon: NoCodeFileUpload,
    label: 'File Upload',
    category: IconCategoryId.FILES,
  },
  NoCodeFilters: {
    icon: NoCodeFilters,
    label: 'Filters',
    category: IconCategoryId.GENERAL,
  },
  NoCodeFlippable: {
    icon: NoCodeFlippable,
    label: 'Flippable',
    category: IconCategoryId.COMPONENTS,
  },
  NoCodeForm: {
    icon: NoCodeForm,
    label: 'Form',
    category: IconCategoryId.LAYOUT,
  },
  NoCodeFunctions: {
    icon: NoCodeFunctions,
    label: 'Functions',
    category: IconCategoryId.DEVELOPMENT,
  },
  NoCodeGrid: {
    icon: NoCodeGrid,
    label: 'Grid',
    category: IconCategoryId.LAYOUT,
  },
  NoCodeHeatMap: {
    icon: NoCodeHeatMap,
    label: 'Heat Map',
    category: IconCategoryId.CHARTS,
  },
  NoCodeIcon: {
    icon: NoCodeIcon,
    label: 'Icon',
    category: IconCategoryId.GENERAL,
  },
  NoCodeIconButton: {
    icon: NoCodeIconButton,
    label: 'Icon Button',
    category: IconCategoryId.LAYOUT,
  },
  NoCodeIframe: {
    icon: NoCodeIframe,
    label: 'iFrame',
    category: IconCategoryId.DEVELOPMENT,
  },
  NoCodeImage: {
    icon: NoCodeImage,
    label: 'Image',
    category: IconCategoryId.IMAGES,
  },
  NoCodeKanban: {
    icon: NoCodeKanban,
    label: 'Kanban Table',
    category: IconCategoryId.COMPONENTS,
  },
  NoCodeKanbanColored: {
    icon: NoCodeKanbanColored,
    label: 'Kanban Table',
    category: IconCategoryId.COMPONENTS,
  },
  NoCodeKeyValue: {
    icon: NoCodeKeyValue,
    label: 'Key Value',
    category: IconCategoryId.GENERAL,
  },
  NoCodeLink: {
    icon: NoCodeLink,
    label: 'Link',
    category: IconCategoryId.GENERAL,
  },
  NoCodeLoader: {
    icon: NoCodeLoader,
    label: 'Loader',
    category: IconCategoryId.GENERAL,
  },
  NoCodeMedia: {
    icon: NoCodeMedia,
    label: 'Media',
    category: IconCategoryId.MEDIA_AND_DEVICES,
  },
  NoCodeMenu: {
    icon: NoCodeMenu,
    label: 'Menu',
    category: IconCategoryId.LAYOUT,
  },
  NoCodeMessageInput: {
    icon: NoCodeMessageInput,
    label: 'Message Input',
    category: IconCategoryId.COMMUNICATION,
  },
  NoCodeModal: {
    icon: NoCodeModal,
    label: 'Modal',
    category: IconCategoryId.LAYOUT,
  },
  NoCodeMultiStatCard: {
    icon: NoCodeMultiStatCard,
    label: 'Multi Stat Card',
    category: IconCategoryId.CHARTS,
  },
  NoCodeNavigation: {
    icon: NoCodeNavigation,
    label: 'Navigation',
    category: IconCategoryId.LAYOUT,
  },
  NoCodeNavigationContainer: {
    icon: NoCodeNavigationContainer,
    label: 'Navigation Container',
    category: IconCategoryId.LAYOUT,
  },
  NoCodeNestedTable: {
    icon: NoCodeNestedTable,
    label: 'Nested Table',
    category: IconCategoryId.LAYOUT,
  },
  NoCodePassword: {
    icon: NoCodePassword,
    label: 'Password',
    category: IconCategoryId.EDITOR,
  },
  NoCodePdfViewer: {
    icon: NoCodePdfViewer,
    label: 'PDF Viewer',
    category: IconCategoryId.FILES,
  },
  NoCodePhoneNumber: {
    icon: NoCodePhoneNumber,
    label: 'Phone Number',
    category: IconCategoryId.COMPONENTS,
  },
  NoCodePinInput: {
    icon: NoCodePinInput,
    label: 'Pin Input',
    category: IconCategoryId.COMPONENTS,
  },
  NoCodePinnedRightPane: {
    icon: NoCodePinnedRightPane,
    label: 'Pinned Right Pane',
    category: IconCategoryId.LAYOUT,
  },
  NoCodePressable: {
    icon: NoCodePressable,
    label: 'Pressable',
    category: IconCategoryId.GENERAL,
  },
  NoCodeProgressBar: {
    icon: NoCodeProgressBar,
    label: 'Progress Bar',
    category: IconCategoryId.GENERAL,
  },
  NoCodeQrCode: {
    icon: NoCodeQrCode,
    label: 'QR Code',
    category: IconCategoryId.DEVELOPMENT,
  },
  NoCodeRadioButton: {
    icon: NoCodeRadioButton,
    label: 'Radio Button',
    category: IconCategoryId.GENERAL,
  },
  NoCodeRating: {
    icon: NoCodeRating,
    label: 'Rating',
    category: IconCategoryId.COMPONENTS,
  },
  NoCodeRecords: {
    icon: NoCodeRecords,
    label: 'Records',
    category: IconCategoryId.TIME,
  },
  NoCodeRepeatable: {
    icon: NoCodeRepeatable,
    label: 'Repeatable',
    category: IconCategoryId.LAYOUT,
  },
  NoCodeRepeatableList: {
    icon: NoCodeRepeatableList,
    label: 'Repeatable List',
    category: IconCategoryId.LAYOUT,
  },
  NoCodeRichtext: {
    icon: NoCodeRichtext,
    label: 'Rich Text',
    category: IconCategoryId.EDITOR,
  },
  NoCodeScanner: {
    icon: NoCodeScanner,
    label: 'Scanner',
    category: IconCategoryId.MEDIA_AND_DEVICES,
  },
  NoCodeSideDrawer: {
    icon: NoCodeSideDrawer,
    label: 'Side Drawer',
    category: IconCategoryId.LAYOUT,
  },
  NoCodeSignature: {
    icon: NoCodeSignature,
    label: 'Signature',
    category: IconCategoryId.EDITOR,
  },
  NoCodeSlot: {
    icon: NoCodeSlot,
    label: 'Slot',
    category: IconCategoryId.COMPONENTS,
  },
  NoCodeStack: {
    icon: NoCodeStack,
    label: 'Stack',
    category: IconCategoryId.LAYOUT,
  },
  NoCodeStatCard: {
    icon: NoCodeStatCard,
    label: 'Stat Card',
    category: IconCategoryId.CHARTS,
  },
  NoCodeStepIndicator: {
    icon: NoCodeStepIndicator,
    label: 'Step Indicator',
    category: IconCategoryId.LAYOUT,
  },
  NoCodeSteppedContainer: {
    icon: NoCodeSteppedContainer,
    label: 'Stepped Container',
    category: IconCategoryId.LAYOUT,
  },
  NoCodeStepper: {
    icon: NoCodeStepper,
    label: 'Stepper',
    category: IconCategoryId.LAYOUT,
  },
  NoCodeStepSeparator: {
    icon: NoCodeStepSeparator,
    label: 'Step Separator',
    category: IconCategoryId.LAYOUT,
  },
  NoCodeStories: {
    icon: NoCodeStories,
    label: 'Stories',
    category: IconCategoryId.MEDIA_AND_DEVICES,
  },
  NoCodeSwipeable: {
    icon: NoCodeSwipeable,
    label: 'Swipeable',
    category: IconCategoryId.GENERAL,
  },
  NoCodeSwipeableStack: {
    icon: NoCodeSwipeableStack,
    label: 'Swipeable Stack',
    category: IconCategoryId.COMPONENTS,
  },
  NoCodeTable: {
    icon: NoCodeTable,
    label: 'Table',
    category: IconCategoryId.LAYOUT,
  },
  NoCodeTabs: {
    icon: NoCodeTabs,
    label: 'Tabs',
    category: IconCategoryId.LAYOUT,
  },
  NoCodeTag: {
    icon: NoCodeTag,
    label: 'Tag',
    category: IconCategoryId.FINANCE,
  },
  NoCodeTemplateComponent: {
    icon: NoCodeTemplateComponent,
    label: 'Template Component',
    category: IconCategoryId.COMPONENTS,
  },
  NoCodeTemplatePlaceholder: {
    icon: NoCodeTemplatePlaceholder,
    label: 'Template Component Placeholder',
    category: IconCategoryId.GENERAL,
  },
  NoCodeText: {
    icon: NoCodeText,
    label: 'Text',
    category: IconCategoryId.EDITOR,
  },
  NoCodeTextArea: {
    icon: NoCodeTextArea,
    label: 'Text Area',
    category: IconCategoryId.EDITOR,
  },
  NoCodeTextInput: {
    icon: NoCodeTextInput,
    label: 'Text Input',
    category: IconCategoryId.EDITOR,
  },
  NoCodeTimeline: {
    icon: NoCodeTimeline,
    label: 'Timeline',
    category: IconCategoryId.TIME,
  },
  NoCodeTimer: {
    icon: NoCodeTimer,
    label: 'Timer',
    category: IconCategoryId.TIME,
  },
  NoCodeToggle: {
    icon: NoCodeToggle,
    label: 'Toggle',
    category: IconCategoryId.GENERAL,
  },
  NoCodeVariables: {
    icon: NoCodeVariables,
    label: 'Variables',
    category: IconCategoryId.DEVELOPMENT,
  },
  NoCodeVideo: {
    icon: NoCodeVideo,
    label: 'Video',
    category: IconCategoryId.MEDIA_AND_DEVICES,
  },
  NoEntry: {
    icon: NoEntry,
    label: 'No Entry',
    category: IconCategoryId.ALERTS_AND_FEEDBACK,
  },
  OpenSourceModel: {
    icon: OpenSourceModel,
    label: 'Open Source Model',
    category: IconCategoryId.DEVELOPMENT,
  },
  PackageCheck: {
    icon: PackageCheck,
    label: 'Package Check',
    category: IconCategoryId.DEVELOPMENT,
  },
  Paginate: {
    icon: Paginate,
    label: 'Paginate',
    category: IconCategoryId.FILES,
  },
  Palette: {
    icon: Palette,
    label: 'Palette',
    category: IconCategoryId.EDITOR,
  },
  Pause: {
    icon: Pause,
    label: 'Pause',
    category: IconCategoryId.MEDIA_AND_DEVICES,
  },
  Pdf2: {
    icon: Pdf2,
    label: 'PDF 2',
    category: IconCategoryId.FILES,
  },
  PermissionControl: {
    icon: PermissionControl,
    label: 'Permission Control',
    category: IconCategoryId.GENERAL,
  },
  Phone02: {
    icon: Phone02,
    label: 'Phone 2',
    category: IconCategoryId.MEDIA_AND_DEVICES,
  },
  PieChart01: {
    icon: PieChart01,
    label: 'Pie Chart',
    category: IconCategoryId.CHARTS,
  },
  Placeholder: {
    icon: Placeholder,
    label: 'Placeholder',
    category: IconCategoryId.GENERAL,
  },
  Play: {
    icon: Play,
    label: 'Play',
    category: IconCategoryId.MEDIA_AND_DEVICES,
  },
  PlayCircle: {
    icon: PlayCircle,
    label: 'Play Circle',
    category: IconCategoryId.MEDIA_AND_DEVICES,
  },
  Plus: {
    icon: Plus,
    label: 'Plus',
    category: IconCategoryId.GENERAL,
  },
  Ppt: {
    icon: Ppt,
    label: 'PPT',
    category: IconCategoryId.FILES,
  },
  Pptx: {
    icon: Pptx,
    label: 'PPTX',
    category: IconCategoryId.FILES,
  },
  PresentationChart01: {
    icon: PresentationChart01,
    label: 'Presentation Chart 1',
    category: IconCategoryId.CHARTS,
  },
  Prohibition: {
    icon: Prohibition,
    label: 'Prohibition',
    category: IconCategoryId.ALERTS_AND_FEEDBACK,
  },
  Prompt: {
    icon: Prompt,
    label: 'Prompt',
    category: IconCategoryId.COMMUNICATION,
  },
  QuoteEnd: {
    icon: QuoteEnd,
    label: 'Quote End',
    category: IconCategoryId.EDITOR,
  },
  RadarSpiderChart: {
    icon: RadarSpiderChart,
    label: 'Radar Spider Chart',
    category: IconCategoryId.CHARTS,
  },
  RadialBarChart: {
    icon: RadialBarChart,
    label: 'Radial Bar Chart',
    category: IconCategoryId.CHARTS,
  },
  RadialColumnChart: {
    icon: RadialColumnChart,
    label: 'Radial Column Chart',
    category: IconCategoryId.CHARTS,
  },
  RadialScatterChart: {
    icon: RadialScatterChart,
    label: 'Radial Scatter Chart',
    category: IconCategoryId.CHARTS,
  },
  RefreshCcw01: {
    icon: RefreshCcw01,
    label: 'Refresh 1',
    category: IconCategoryId.ARROWS,
  },
  RefreshCcw02: {
    icon: RefreshCcw02,
    label: 'Refresh 2',
    category: IconCategoryId.ARROWS,
  },
  RefreshCcw05: {
    icon: RefreshCcw05,
    label: 'Refresh 5',
    category: IconCategoryId.ARROWS,
  },
  RefreshCcw06: {
    icon: RefreshCcw06,
    label: 'Refresh 6',
    category: IconCategoryId.ARROWS,
  },
  RefreshCw01: {
    icon: RefreshCw01,
    label: 'Refresh',
    category: IconCategoryId.ARROWS,
  },
  Reply: {
    icon: Reply,
    label: 'Reply',
    category: IconCategoryId.ARROWS,
  },
  RichText: {
    icon: RichText,
    label: 'Rich Text',
    category: IconCategoryId.DEVELOPMENT,
  },
  Route: {
    icon: Route,
    label: 'Route',
    category: IconCategoryId.TRAVEL,
  },
  SankeyChart01: {
    icon: SankeyChart01,
    label: 'Sankey Chart',
    category: IconCategoryId.CHARTS,
  },
  Scales01: {
    icon: Scales01,
    label: 'Scales',
    category: IconCategoryId.GENERAL,
  },
  Scales02: {
    icon: Scales02,
    label: 'Scales',
    category: IconCategoryId.GENERAL,
  },
  Scan: {
    icon: Scan,
    label: 'Scan',
    category: IconCategoryId.GENERAL,
  },
  ScatterChart: {
    icon: ScatterChart,
    label: 'Scatter Chart',
    category: IconCategoryId.CHARTS,
  },
  SchemaMapping: {
    icon: SchemaMapping,
    label: 'Schema Mapping',
    category: IconCategoryId.DEVELOPMENT,
  },
  Scissors01: {
    icon: Scissors01,
    label: 'Scissors',
    category: IconCategoryId.EDITOR,
  },
  Server04: {
    icon: Server04,
    label: 'Server',
    category: IconCategoryId.DEVELOPMENT,
  },
  SessionStorage: {
    icon: SessionStorage,
    label: 'Session Storage',
    category: IconCategoryId.DEVELOPMENT,
  },
  Settings01: {
    icon: Settings01,
    label: 'Settings 1',
    category: IconCategoryId.GENERAL,
  },
  Settings04: {
    icon: Settings04,
    label: 'Settings 4',
    category: IconCategoryId.GENERAL,
  },
  Settings05: {
    icon: Settings05,
    label: 'Settings 5',
    category: IconCategoryId.GENERAL,
  },
  Share04: {
    icon: Share04,
    label: 'Share',
    category: IconCategoryId.GENERAL,
  },
  ShieldLock: {
    icon: ShieldLock,
    label: 'Shield Lock',
    category: IconCategoryId.SECURITY,
  },
  SlashBox: {
    icon: SlashBox,
    label: 'Box Slash',
    category: IconCategoryId.GENERAL,
  },
  SlashCircle01: {
    icon: SlashCircle01,
    label: 'Circle Slash',
    category: IconCategoryId.GENERAL,
  },
  Sources: {
    icon: Sources,
    label: 'Sources',
    category: IconCategoryId.GENERAL,
  },
  SquareFilled: {
    icon: SquareFilled,
    label: 'Square Filled',
    category: IconCategoryId.GENERAL,
  },
  Star01: {
    icon: Star01,
    label: 'Star 1',
    category: IconCategoryId.GENERAL,
  },
  StarBackground: {
    icon: StarBackground,
    label: 'Star Background',
    category: IconCategoryId.GENERAL,
  },
  Stars01: {
    icon: Stars01,
    label: 'Stars 1',
    category: IconCategoryId.GENERAL,
  },
  Stars02: {
    icon: Stars02,
    label: 'Stars',
    category: IconCategoryId.GENERAL,
  },
  Stars02Colored: {
    icon: Stars02Colored,
    label: 'Stars Colored',
    category: IconCategoryId.GENERAL,
  },
  Stars02Filled: {
    icon: Stars02Filled,
    label: 'Star 2 Filled',
    category: IconCategoryId.GENERAL,
  },
  StatusClosed: {
    icon: StatusClosed,
    label: 'Status Closed',
    category: IconCategoryId.GENERAL,
  },
  StatusClosedPill: {
    icon: StatusClosedPill,
    label: 'Status Closed Pill',
    category: IconCategoryId.GENERAL,
  },
  StatusInProgress: {
    icon: StatusInProgress,
    label: 'Status In Progress',
    category: IconCategoryId.GENERAL,
  },
  StatusOpen: {
    icon: StatusOpen,
    label: 'Status Open',
    category: IconCategoryId.GENERAL,
  },
  StatusOpenPill: {
    icon: StatusOpenPill,
    label: 'Status Open Pill',
    category: IconCategoryId.GENERAL,
  },
  StatusResolved: {
    icon: StatusResolved,
    label: 'Status Resolved',
    category: IconCategoryId.GENERAL,
  },
  StorageTools02: {
    icon: StorageTools02,
    label: 'Storage Tools',
    category: IconCategoryId.GENERAL,
  },
  SuccessCheck: {
    icon: SuccessCheck,
    label: 'Success Check',
    category: IconCategoryId.GENERAL,
  },
  Sun: {
    icon: Sun,
    label: 'Sun',
    category: IconCategoryId.GENERAL,
  },
  Sunrise: {
    icon: Sunrise,
    label: 'Sunrise',
    category: IconCategoryId.GENERAL,
  },
  Sunset: {
    icon: Sunset,
    label: 'Sunset',
    category: IconCategoryId.GENERAL,
  },
  SvgA2AServer: {
    icon: SvgA2AServer,
    label: 'A2A Server',
    category: IconCategoryId.DEVELOPMENT,
  },
  SvgActivity: {
    icon: SvgActivity,
    label: 'Activity',
    category: IconCategoryId.GENERAL,
  },
  SvgAdaptiveTheme: {
    icon: SvgAdaptiveTheme,
    label: 'Adaptive Theme',
    category: IconCategoryId.GENERAL,
  },
  SvgAep: {
    icon: SvgAep,
    label: 'AEP',
    category: IconCategoryId.FILES,
  },
  SvgAgentAvatar: {
    icon: SvgAgentAvatar,
    label: 'Agent Avatar',
    category: IconCategoryId.AI,
  },
  SvgAi: {
    icon: SvgAi,
    label: 'AI File',
    category: IconCategoryId.FILES,
  },
  SvgAiAgent: {
    icon: SvgAiAgent,
    label: 'AI Agent',
    category: IconCategoryId.AI,
  },
  SvgAiAgent02: {
    icon: SvgAiAgent02,
    label: 'AI Agent 02',
    category: IconCategoryId.AI,
  },
  SvgAiChat: {
    icon: SvgAiChat,
    label: 'AI Chat',
    category: IconCategoryId.AI,
  },
  SvgAiEsChat: {
    icon: SvgAiEsChat,
    label: 'AI ES Chat',
    category: IconCategoryId.AI,
  },
  SvgAiMemory: {
    icon: SvgAiMemory,
    label: 'AI Memory',
    category: IconCategoryId.AI,
  },
  SvgAiPromptGuard: {
    icon: SvgAiPromptGuard,
    label: 'SvgAiPromptGuard',
    category: IconCategoryId.AI,
  },
  SvgAiTeam: {
    icon: SvgAiTeam,
    label: 'AI Team',
    category: IconCategoryId.AI,
  },
  SvgAlarmClockCheck: {
    icon: SvgAlarmClockCheck,
    label: 'Alarm Clock Check',
    category: IconCategoryId.TIME,
  },
  SvgAlertCircleSolid: {
    icon: SvgAlertCircleSolid,
    label: 'Alert Circle Solid',
    category: IconCategoryId.GENERAL,
  },
  SvgAlignHorizontalCenter: {
    icon: SvgAlignHorizontalCenter,
    label: 'Align Horizontal Center',
    category: IconCategoryId.LAYOUT,
  },
  SvgAlignHorizontalCentre02: {
    icon: SvgAlignHorizontalCentre02,
    label: 'Align Horizontal Center 2',
    category: IconCategoryId.LAYOUT,
  },
  SvgAlignHorizontalEnd: {
    icon: SvgAlignHorizontalEnd,
    label: 'Align Horizontal End',
    category: IconCategoryId.LAYOUT,
  },
  SvgAlignHorizontalSpaceBetween: {
    icon: SvgAlignHorizontalSpaceBetween,
    label: 'Space Between Horizontal',
    category: IconCategoryId.LAYOUT,
  },
  SvgAlignHorizontalStart: {
    icon: SvgAlignHorizontalStart,
    label: 'Align Horizontal Start',
    category: IconCategoryId.LAYOUT,
  },
  SvgAlignHorizontalStretch: {
    icon: SvgAlignHorizontalStretch,
    label: 'Stretch Horizontal',
    category: IconCategoryId.LAYOUT,
  },
  SvgAlignLeft02: {
    icon: SvgAlignLeft02,
    label: 'Align Left 2',
    category: IconCategoryId.LAYOUT,
  },
  SvgAlignVerticalCenter: {
    icon: SvgAlignVerticalCenter,
    label: 'Align Vertical Center',
    category: IconCategoryId.LAYOUT,
  },
  SvgAlignVerticalEnd: {
    icon: SvgAlignVerticalEnd,
    label: 'Align Vertical End',
    category: IconCategoryId.LAYOUT,
  },
  SvgAlignVerticalSpaceBetween: {
    icon: SvgAlignVerticalSpaceBetween,
    label: 'Space Between Vertical',
    category: IconCategoryId.LAYOUT,
  },
  SvgAlignVerticalStart: {
    icon: SvgAlignVerticalStart,
    label: 'Align Vertical Start',
    category: IconCategoryId.LAYOUT,
  },
  SvgAlignVerticalStretch: {
    icon: SvgAlignVerticalStretch,
    label: 'Stretch Vertical',
    category: IconCategoryId.LAYOUT,
  },
  SvgAnnotationAlert: {
    icon: SvgAnnotationAlert,
    label: 'Annotation Alert',
    category: IconCategoryId.COMMUNICATION,
  },
  SvgApplicationsByUnifyapps: {
    icon: SvgApplicationsByUnifyapps,
    label: 'Applications By Unifyapps',
    category: IconCategoryId.GENERAL,
  },
  SvgAppWindow: {
    icon: SvgAppWindow,
    label: 'App Window',
    category: IconCategoryId.LAYOUT,
  },
  SvgArrowNarrowDownLeft: {
    icon: SvgArrowNarrowDownLeft,
    label: 'Arrow Narrow Down Left',
    category: IconCategoryId.ARROWS,
  },
  SvgArrowNarrowUp: {
    icon: SvgArrowNarrowUp,
    label: 'Arrow Narrow Up',
    category: IconCategoryId.ARROWS,
  },
  SvgArrowNarrowUpRight: {
    icon: SvgArrowNarrowUpRight,
    label: 'Arrow Narrow Up Right',
    category: IconCategoryId.ARROWS,
  },
  SvgArrowUpRight: {
    icon: SvgArrowUpRight,
    label: 'Arrow Up Right',
    category: IconCategoryId.ARROWS,
  },
  SvgAsterisk03: {
    icon: SvgAsterisk03,
    label: 'Asterisk 3',
    category: IconCategoryId.GENERAL,
  },
  SvgAtSign: {
    icon: SvgAtSign,
    label: 'At Sign',
    category: IconCategoryId.GENERAL,
  },
  SvgAttachment01: {
    icon: SvgAttachment01,
    label: 'Attachment',
    category: IconCategoryId.EDITOR,
  },
  SvgAudience: {
    icon: SvgAudience,
    label: 'Audience',
    category: IconCategoryId.USERS,
  },
  SvgAudio: {
    icon: SvgAudio,
    label: 'Audio',
    category: IconCategoryId.FILES,
  },
  SvgAuthByUnifyapps: {
    icon: SvgAuthByUnifyapps,
    label: 'Auth By Unifyapps',
    category: IconCategoryId.SECURITY,
  },
  SvgAutomations: {
    icon: SvgAutomations,
    label: 'Automations',
    category: IconCategoryId.GENERAL,
  },
  SvgAvi: {
    icon: SvgAvi,
    label: 'AVI',
    category: IconCategoryId.FILES,
  },
  SvgAward01: {
    icon: SvgAward01,
    label: 'Award 1',
    category: IconCategoryId.EDUCATION,
  },
  SvgAward05: {
    icon: SvgAward05,
    label: 'Award 5',
    category: IconCategoryId.EDUCATION,
  },
  SvgAzure: {
    icon: SvgAzure,
    label: 'Azure',
    category: IconCategoryId.LOGOS,
  },
  SvgBankNote01: {
    icon: SvgBankNote01,
    label: 'Bank Note 1',
    category: IconCategoryId.FINANCE,
  },
  SvgBankNote02: {
    icon: SvgBankNote02,
    label: 'Bank Note 2',
    category: IconCategoryId.FINANCE,
  },
  SvgBarChart01: {
    icon: SvgBarChart01,
    label: 'BarChart01',
    category: IconCategoryId.GENERAL,
  },
  SvgBarChartSquare: {
    icon: SvgBarChartSquare,
    label: 'Bar Chart Square',
    category: IconCategoryId.CHARTS,
  },
  SvgBarChartSquareSolid: {
    icon: SvgBarChartSquareSolid,
    label: 'Bar Chart Square Solid',
    category: IconCategoryId.CHARTS,
  },
  SvgBarLineChart: {
    icon: SvgBarLineChart,
    label: 'Bar Line Chart',
    category: IconCategoryId.CHARTS,
  },
  SvgBeaker01: {
    icon: SvgBeaker01,
    label: 'Beaker',
    category: IconCategoryId.EDUCATION,
  },
  SvgBell: {
    icon: SvgBell,
    label: 'Bell',
    category: IconCategoryId.GENERAL,
  },
  SvgBike01: {
    icon: SvgBike01,
    label: 'Bike',
    category: IconCategoryId.TRAVEL,
  },
  SvgBolt: {
    icon: SvgBolt,
    label: 'Bolt',
    category: IconCategoryId.GENERAL,
  },
  SvgBookClosed: {
    icon: SvgBookClosed,
    label: 'Book Closed',
    category: IconCategoryId.EDUCATION,
  },
  SvgBookOpen01: {
    icon: SvgBookOpen01,
    label: 'Book Open',
    category: IconCategoryId.EDUCATION,
  },
  SvgBox: {
    icon: SvgBox,
    label: 'Box',
    category: IconCategoryId.FILES,
  },
  SvgBrackets: {
    icon: SvgBrackets,
    label: 'Brackets',
    category: IconCategoryId.GENERAL,
  },
  SvgBracketsPlus: {
    icon: SvgBracketsPlus,
    label: 'Brackets Plus',
    category: IconCategoryId.GENERAL,
  },
  SvgBracketsX: {
    icon: SvgBracketsX,
    label: 'Brackets X',
    category: IconCategoryId.DEVELOPMENT,
  },
  SvgBranching: {
    icon: SvgBranching,
    label: 'Branching',
    category: IconCategoryId.DEVELOPMENT,
  },
  SvgBranchSolid: {
    icon: SvgBranchSolid,
    label: 'Branch Solid',
    category: IconCategoryId.DEVELOPMENT,
  },
  SvgBrowserEmitPage: {
    icon: SvgBrowserEmitPage,
    label: 'Browser Emit Page',
    category: IconCategoryId.DEVELOPMENT,
  },
  SvgButtonBrand: {
    icon: SvgButtonBrand,
    label: 'Button Brand',
    category: IconCategoryId.COMPONENTS,
  },
  SvgCalculator: {
    icon: SvgCalculator,
    label: 'Calculator',
    category: IconCategoryId.EDUCATION,
  },
  SvgCalculator02: {
    icon: SvgCalculator02,
    label: 'Calculator 2',
    category: IconCategoryId.GENERAL,
  },
  SvgCalendar: {
    icon: SvgCalendar,
    label: 'Calendar',
    category: IconCategoryId.TIME,
  },
  SvgCalendarCheck01: {
    icon: SvgCalendarCheck01,
    label: 'Calendar Check',
    category: IconCategoryId.TIME,
  },
  SvgCalendarClock: {
    icon: SvgCalendarClock,
    label: 'Calendar Clock',
    category: IconCategoryId.TIME,
  },
  SvgCalendarFilled: {
    icon: SvgCalendarFilled,
    label: 'Calendar',
    category: IconCategoryId.TIME,
  },
  SvgCalendarMinus01: {
    icon: SvgCalendarMinus01,
    label: 'SvgCalendarMinus01',
    category: IconCategoryId.GENERAL,
  },
  SvgCar02: {
    icon: SvgCar02,
    label: 'Car',
    category: IconCategoryId.TRAVEL,
  },
  SvgCaretRight: {
    icon: SvgCaretRight,
    label: 'Caret Right',
    category: IconCategoryId.GENERAL,
  },
  SvgCatalog: {
    icon: SvgCatalog,
    label: 'Catalog',
    category: IconCategoryId.FILES,
  },
  SvgCeil: {
    icon: SvgCeil,
    label: 'Ceiling',
    category: IconCategoryId.DEVELOPMENT,
  },
  SvgCertificate02: {
    icon: SvgCertificate02,
    label: 'Certificate',
    category: IconCategoryId.EDUCATION,
  },
  SvgChartBreakoutCircle1: {
    icon: SvgChartBreakoutCircle1,
    label: 'Chart Breakout Circle',
    category: IconCategoryId.CHARTS,
  },
  SvgChatSolid: {
    icon: SvgChatSolid,
    label: 'Chat',
    category: IconCategoryId.COMMUNICATION,
  },
  SvgChatView: {
    icon: SvgChatView,
    label: 'Chat View',
    category: IconCategoryId.LAYOUT,
  },
  SvgCheck: {
    icon: SvgCheck,
    label: 'Check',
    category: IconCategoryId.GENERAL,
  },
  SvgCheckboxGroup: {
    icon: SvgCheckboxGroup,
    label: 'Checkbox Group',
    category: IconCategoryId.GENERAL,
  },
  SvgCheckCircle: {
    icon: SvgCheckCircle,
    label: 'Check Circle',
    category: IconCategoryId.GENERAL,
  },
  SvgCheckDone01: {
    icon: SvgCheckDone01,
    label: 'Check Done',
    category: IconCategoryId.GENERAL,
  },
  SvgCheckSlim: {
    icon: SvgCheckSlim,
    label: 'Check Slim',
    category: IconCategoryId.FILES,
  },
  SvgCheckSquare: {
    icon: SvgCheckSquare,
    label: 'Check Square',
    category: IconCategoryId.GENERAL,
  },
  SvgCheckVerified02: {
    icon: SvgCheckVerified02,
    label: 'Verified Check',
    category: IconCategoryId.GENERAL,
  },
  SvgChevronLeftSingle: {
    icon: SvgChevronLeftSingle,
    label: 'Svg Chevron Left Single',
    category: IconCategoryId.GENERAL,
  },
  SvgChevronNarrowRightSm: {
    icon: SvgChevronNarrowRightSm,
    label: 'Chevron Narrow Right Small',
    category: IconCategoryId.GENERAL,
  },
  SvgChevronRightSm: {
    icon: SvgChevronRightSm,
    label: 'Chevron Right Small',
    category: IconCategoryId.GENERAL,
  },
  SvgCircle: {
    icon: SvgCircle,
    label: 'SvgCircle',
    category: IconCategoryId.GENERAL,
  },
  SvgCircleDotted: {
    icon: SvgCircleDotted,
    label: 'Circle Dotted',
    category: IconCategoryId.GENERAL,
  },
  SvgClapperboardFillSolid: {
    icon: SvgClapperboardFillSolid,
    label: 'Clapperboard Fill',
    category: IconCategoryId.MEDIA_AND_DEVICES,
  },
  SvgClipboardCheck: {
    icon: SvgClipboardCheck,
    label: 'Clipboard Check',
    category: IconCategoryId.FILES,
  },
  SvgClipboardSettings: {
    icon: SvgClipboardSettings,
    label: 'Clipboard Settings',
    category: IconCategoryId.FILES,
  },
  SvgClock: {
    icon: SvgClock,
    label: 'Clock',
    category: IconCategoryId.TIME,
  },
  SvgClockCheck: {
    icon: SvgClockCheck,
    label: 'Clock Check',
    category: IconCategoryId.TIME,
  },
  SvgClockFastForward: {
    icon: SvgClockFastForward,
    label: 'Clock Fast Forward',
    category: IconCategoryId.TIME,
  },
  SvgClockFastForwardSolid: {
    icon: SvgClockFastForwardSolid,
    label: 'Clock Fast Forward',
    category: IconCategoryId.TIME,
  },
  SvgClockRewind: {
    icon: SvgClockRewind,
    label: 'Clock Rewind',
    category: IconCategoryId.TIME,
  },
  SvgClockRewindSolid: {
    icon: SvgClockRewindSolid,
    label: 'Clock Rewind',
    category: IconCategoryId.TIME,
  },
  SvgCode: {
    icon: SvgCode,
    label: 'Code',
    category: IconCategoryId.DEVELOPMENT,
  },
  SvgCodeBrowser: {
    icon: SvgCodeBrowser,
    label: 'Code Browser',
    category: IconCategoryId.DEVELOPMENT,
  },
  SvgCodeCircle01: {
    icon: SvgCodeCircle01,
    label: 'Code Circle',
    category: IconCategoryId.DEVELOPMENT,
  },
  SvgCodeSquare02: {
    icon: SvgCodeSquare02,
    label: 'Code Square',
    category: IconCategoryId.DEVELOPMENT,
  },
  SvgColors: {
    icon: SvgColors,
    label: 'Colors',
    category: IconCategoryId.EDITOR,
  },
  SvgColumns03: {
    icon: SvgColumns03,
    label: 'Columns',
    category: IconCategoryId.LAYOUT,
  },
  SvgControlPushNotifications: {
    icon: SvgControlPushNotifications,
    label: 'Control Push Notifications',
    category: IconCategoryId.GENERAL,
  },
  SvgCopy07: {
    icon: SvgCopy07,
    label: 'Copy',
    category: IconCategoryId.GENERAL,
  },
  SvgCornerDownLeft: {
    icon: SvgCornerDownLeft,
    label: 'Corner Down Left',
    category: IconCategoryId.ARROWS,
  },
  SvgCornerDownRight: {
    icon: SvgCornerDownRight,
    label: 'Corner Down Right',
    category: IconCategoryId.ARROWS,
  },
  SvgCpuChip01: {
    icon: SvgCpuChip01,
    label: 'Cpu Chip',
    category: IconCategoryId.GENERAL,
  },
  SvgCreateBranch: {
    icon: SvgCreateBranch,
    label: 'Create Branch',
    category: IconCategoryId.GENERAL,
  },
  SvgCreditCard02: {
    icon: SvgCreditCard02,
    label: 'Credit Card 2',
    category: IconCategoryId.FINANCE,
  },
  SvgCreditCardLock: {
    icon: SvgCreditCardLock,
    label: 'Credit Card Lock',
    category: IconCategoryId.FINANCE,
  },
  SvgCreditCardMinus: {
    icon: SvgCreditCardMinus,
    label: 'Credit Card Minus',
    category: IconCategoryId.FINANCE,
  },
  SvgCreditCardPlus: {
    icon: SvgCreditCardPlus,
    label: 'Credit Card Plus',
    category: IconCategoryId.FINANCE,
  },
  SvgCryptocurrency01: {
    icon: SvgCryptocurrency01,
    label: 'Cryptocurrency',
    category: IconCategoryId.FINANCE,
  },
  SvgCss: {
    icon: SvgCss,
    label: 'CSS',
    category: IconCategoryId.FILES,
  },
  SvgCsv: {
    icon: SvgCsv,
    label: 'CSV',
    category: IconCategoryId.FILES,
  },
  SvgCurrencyDirham: {
    icon: SvgCurrencyDirham,
    label: 'Dirham',
    category: IconCategoryId.FINANCE,
  },
  SvgCurrencyDollar: {
    icon: SvgCurrencyDollar,
    label: 'Dollar',
    category: IconCategoryId.FINANCE,
  },
  SvgCurrencyDollarCircle: {
    icon: SvgCurrencyDollarCircle,
    label: 'Dollar Circle',
    category: IconCategoryId.FINANCE,
  },
  SvgCurrencyEuro: {
    icon: SvgCurrencyEuro,
    label: 'Euro',
    category: IconCategoryId.FINANCE,
  },
  SvgCurrencyPound: {
    icon: SvgCurrencyPound,
    label: 'Pound',
    category: IconCategoryId.FINANCE,
  },
  SvgCurrencyRuble: {
    icon: SvgCurrencyRuble,
    label: 'Ruble',
    category: IconCategoryId.FINANCE,
  },
  SvgCurrencyRupee: {
    icon: SvgCurrencyRupee,
    label: 'Rupee',
    category: IconCategoryId.FINANCE,
  },
  SvgCurrencyYen: {
    icon: SvgCurrencyYen,
    label: 'Yen',
    category: IconCategoryId.FINANCE,
  },
  SvgDarkTheme: {
    icon: SvgDarkTheme,
    label: 'Dark Theme',
    category: IconCategoryId.GENERAL,
  },
  SvgData: {
    icon: SvgData,
    label: 'Data',
    category: IconCategoryId.DEVELOPMENT,
  },
  SvgDatabase02: {
    icon: SvgDatabase02,
    label: 'Database 2',
    category: IconCategoryId.DEVELOPMENT,
  },
  SvgDatabase03: {
    icon: SvgDatabase03,
    label: 'Database 3',
    category: IconCategoryId.DEVELOPMENT,
  },
  SvgDatabase05: {
    icon: SvgDatabase05,
    label: 'Database 5',
    category: IconCategoryId.DEVELOPMENT,
  },
  SvgDatabaseCylinder: {
    icon: SvgDatabaseCylinder,
    label: 'Database Cylinder',
    category: IconCategoryId.GENERAL,
  },
  SvgDataflow01: {
    icon: SvgDataflow01,
    label: 'Data Flow 1',
    category: IconCategoryId.DEVELOPMENT,
  },
  SvgDataNodes: {
    icon: SvgDataNodes,
    label: 'Data Nodes',
    category: IconCategoryId.GENERAL,
  },
  SvgDeployRestart: {
    icon: SvgDeployRestart,
    label: 'Deploy Restart',
    category: IconCategoryId.ARROWS,
  },
  SvgDetokenisation: {
    icon: SvgDetokenisation,
    label: 'Detokenisation',
    category: IconCategoryId.SECURITY,
  },
  SvgDmg: {
    icon: SvgDmg,
    label: 'DMG',
    category: IconCategoryId.FILES,
  },
  SvgDoc: {
    icon: SvgDoc,
    label: 'DOC',
    category: IconCategoryId.FILES,
  },
  SvgDocument: {
    icon: SvgDocument,
    label: 'Document',
    category: IconCategoryId.FILES,
  },
  SvgDocumentOpen: {
    icon: SvgDocumentOpen,
    label: 'Document Open',
    category: IconCategoryId.FILES,
  },
  SvgDocx: {
    icon: SvgDocx,
    label: 'DOCX',
    category: IconCategoryId.FILES,
  },
  SvgDot: {
    icon: SvgDot,
    label: 'Dot',
    category: IconCategoryId.ALERTS_AND_FEEDBACK,
  },
  SvgDottedCircle: {
    icon: SvgDottedCircle,
    label: 'Dotted Circle',
    category: IconCategoryId.GENERAL,
  },
  SvgDownload01: {
    icon: SvgDownload01,
    label: 'Download',
    category: IconCategoryId.GENERAL,
  },
  SvgDownloadCloud02: {
    icon: SvgDownloadCloud02,
    label: 'Download Cloud',
    category: IconCategoryId.GENERAL,
  },
  SvgEdit03: {
    icon: SvgEdit03,
    label: 'Edit 3',
    category: IconCategoryId.GENERAL,
  },
  SvgEmptyBox: {
    icon: SvgEmptyBox,
    label: 'Empty Box SVG',
    category: IconCategoryId.GENERAL,
  },
  SvgEnvironmentVariable: {
    icon: SvgEnvironmentVariable,
    label: 'Environment Variable',
    category: IconCategoryId.DEVELOPMENT,
  },
  SvgEps: {
    icon: SvgEps,
    label: 'EPS',
    category: IconCategoryId.FILES,
  },
  SvgEpubs: {
    icon: SvgEpubs,
    label: 'EPUB',
    category: IconCategoryId.FILES,
  },
  SvgEraser: {
    icon: SvgEraser,
    label: 'Eraser',
    category: IconCategoryId.EDITOR,
  },
  SvgErp: {
    icon: SvgErp,
    label: 'Erp',
    category: IconCategoryId.GENERAL,
  },
  SvgExe: {
    icon: SvgExe,
    label: 'EXE',
    category: IconCategoryId.FILES,
  },
  SvgExpand03: {
    icon: SvgExpand03,
    label: 'Expand',
    category: IconCategoryId.ARROWS,
  },
  SvgExploreAiAgents: {
    icon: SvgExploreAiAgents,
    label: 'ExploreAiAgents',
    category: IconCategoryId.AI,
  },
  SvgEye: {
    icon: SvgEye,
    label: 'Eye',
    category: IconCategoryId.GENERAL,
  },
  SvgEyeClosed: {
    icon: SvgEyeClosed,
    label: 'EyeClosed',
    category: IconCategoryId.GENERAL,
  },
  SvgEyeOff: {
    icon: SvgEyeOff,
    label: 'Eye Off',
    category: IconCategoryId.GENERAL,
  },
  SvgFaceId: {
    icon: SvgFaceId,
    label: 'Face ID',
    category: IconCategoryId.SECURITY,
  },
  SvgFastBackward: {
    icon: SvgFastBackward,
    label: 'FastBackward',
    category: IconCategoryId.MEDIA_AND_DEVICES,
  },
  SvgFastForward: {
    icon: SvgFastForward,
    label: 'FastForward',
    category: IconCategoryId.MEDIA_AND_DEVICES,
  },
  SvgFig: {
    icon: SvgFig,
    label: 'FIG',
    category: IconCategoryId.FILES,
  },
  SvgFigma: {
    icon: SvgFigma,
    label: 'Figma',
    category: IconCategoryId.LOGOS,
  },
  SvgFile02: {
    icon: SvgFile02,
    label: 'File 2',
    category: IconCategoryId.FILES,
  },
  SvgFile08: {
    icon: SvgFile08,
    label: 'File 8',
    category: IconCategoryId.FILES,
  },
  SvgFileCheck02: {
    icon: SvgFileCheck02,
    label: 'File Check 2',
    category: IconCategoryId.FILES,
  },
  SvgFileCheck03: {
    icon: SvgFileCheck03,
    label: 'File Check 3',
    category: IconCategoryId.FILES,
  },
  SvgFileCode01: {
    icon: SvgFileCode01,
    label: 'File Code',
    category: IconCategoryId.DEVELOPMENT,
  },
  SvgFileCode01Solid: {
    icon: SvgFileCode01Solid,
    label: 'File Code Solid',
    category: IconCategoryId.DEVELOPMENT,
  },
  SvgFileEdit: {
    icon: SvgFileEdit,
    label: 'File Edit',
    category: IconCategoryId.FILES,
  },
  SvgFileLock02: {
    icon: SvgFileLock02,
    label: 'File Lock',
    category: IconCategoryId.SECURITY,
  },
  SvgFileSearch02: {
    icon: SvgFileSearch02,
    label: 'File Search',
    category: IconCategoryId.FILES,
  },
  SvgFileXls: {
    icon: SvgFileXls,
    label: 'File Xls',
    category: IconCategoryId.FILES,
  },
  SvgFill: {
    icon: SvgFill,
    label: 'Fill',
    category: IconCategoryId.GENERAL,
  },
  SvgFilterFunnel01: {
    icon: SvgFilterFunnel01,
    label: 'Filter Funnel',
    category: IconCategoryId.GENERAL,
  },
  SvgFilterFunnel02: {
    icon: SvgFilterFunnel02,
    label: 'Filter Funnel 2',
    category: IconCategoryId.GENERAL,
  },
  SvgFingerprint04: {
    icon: SvgFingerprint04,
    label: 'Fingerprint',
    category: IconCategoryId.SECURITY,
  },
  SvgFlag01: {
    icon: SvgFlag01,
    label: 'Flag 01',
    category: IconCategoryId.GENERAL,
  },
  SvgFlagged: {
    icon: SvgFlagged,
    label: 'Flagged',
    category: IconCategoryId.ALERTS_AND_FEEDBACK,
  },
  SvgFloor: {
    icon: SvgFloor,
    label: 'Floor',
    category: IconCategoryId.DEVELOPMENT,
  },
  SvgFlowChart: {
    icon: SvgFlowChart,
    label: 'Flow Chart',
    category: IconCategoryId.GENERAL,
  },
  SvgFolder: {
    icon: SvgFolder,
    label: 'Folder',
    category: IconCategoryId.FILES,
  },
  SvgFolder02: {
    icon: SvgFolder02,
    label: 'Folder 2',
    category: IconCategoryId.FILES,
  },
  SvgFolder02Solid: {
    icon: SvgFolder02Solid,
    label: 'Folder 2',
    category: IconCategoryId.FILES,
  },
  SvgFolderCheck: {
    icon: SvgFolderCheck,
    label: 'Folder Check',
    category: IconCategoryId.FILES,
  },
  SvgFolderClosed: {
    icon: SvgFolderClosed,
    label: 'Folder Closed',
    category: IconCategoryId.FILES,
  },
  SvgFolderMinus: {
    icon: SvgFolderMinus,
    label: 'Folder Minus',
    category: IconCategoryId.FILES,
  },
  SvgFolderOpen: {
    icon: SvgFolderOpen,
    label: 'Folder Open',
    category: IconCategoryId.FILES,
  },
  SvgFolderPlus: {
    icon: SvgFolderPlus,
    label: 'Folder Plus',
    category: IconCategoryId.FILES,
  },
  SvgFolderQuestion: {
    icon: SvgFolderQuestion,
    label: 'Folder Question',
    category: IconCategoryId.FILES,
  },
  SvgFolderSolid: {
    icon: SvgFolderSolid,
    label: 'Folder',
    category: IconCategoryId.FILES,
  },
  SvgFolderX: {
    icon: SvgFolderX,
    label: 'Folder X',
    category: IconCategoryId.FILES,
  },
  SvgForwardArrow: {
    icon: SvgForwardArrow,
    label: 'Forward Arrow',
    category: IconCategoryId.ARROWS,
  },
  SvgFunction: {
    icon: SvgFunction,
    label: 'Function',
    category: IconCategoryId.DEVELOPMENT,
  },
  SvgFunctions: {
    icon: SvgFunctions,
    label: 'Functions',
    category: IconCategoryId.DEVELOPMENT,
  },
  SvgGear: {
    icon: SvgGear,
    label: 'Gear',
    category: IconCategoryId.GENERAL,
  },
  SvgGif: {
    icon: SvgGif,
    label: 'GIF',
    category: IconCategoryId.FILES,
  },
  SvgGoogle: {
    icon: SvgGoogle,
    label: 'Google',
    category: IconCategoryId.LOGOS,
  },
  SvgGoogleChrome: {
    icon: SvgGoogleChrome,
    label: 'Google Chrome',
    category: IconCategoryId.LOGOS,
  },
  SvgGoogleDoc: {
    icon: SvgGoogleDoc,
    label: 'Google Doc',
    category: IconCategoryId.LOGOS,
  },
  SvgGoogleDocs: {
    icon: SvgGoogleDocs,
    label: 'Google Docs',
    category: IconCategoryId.LOGOS,
  },
  SvgGoogleMeet: {
    icon: SvgGoogleMeet,
    label: 'Google Meet',
    category: IconCategoryId.COMMUNICATION,
  },
  SvgGoogleSheets: {
    icon: SvgGoogleSheets,
    label: 'Google Sheets',
    category: IconCategoryId.LOGOS,
  },
  SvgGoogleSlides: {
    icon: SvgGoogleSlides,
    label: 'Google Slides',
    category: IconCategoryId.LOGOS,
  },
  SvgGraduationHat01: {
    icon: SvgGraduationHat01,
    label: 'Graduation Hat',
    category: IconCategoryId.EDUCATION,
  },
  SvgGraduationHat01Solid: {
    icon: SvgGraduationHat01Solid,
    label: 'Graduation Hat',
    category: IconCategoryId.EDUCATION,
  },
  SvgGrid01: {
    icon: SvgGrid01,
    label: 'Grid',
    category: IconCategoryId.LAYOUT,
  },
  SvgGrid01Solid: {
    icon: SvgGrid01Solid,
    label: 'Grid',
    category: IconCategoryId.LAYOUT,
  },
  SvgGrid03: {
    icon: SvgGrid03,
    label: 'Grid',
    category: IconCategoryId.LAYOUT,
  },
  SvgGridAdd: {
    icon: SvgGridAdd,
    label: 'Grid Add',
    category: IconCategoryId.LAYOUT,
  },
  SvgGridCompact: {
    icon: SvgGridCompact,
    label: 'Grid Compact',
    category: IconCategoryId.LAYOUT,
  },
  SvgGridPlus: {
    icon: SvgGridPlus,
    label: 'Grid Plus',
    category: IconCategoryId.LAYOUT,
  },
  SvgGroovyLanguage: {
    icon: SvgGroovyLanguage,
    label: 'Groovy',
    category: IconCategoryId.DEVELOPMENT,
  },
  SvgHanger: {
    icon: SvgHanger,
    label: 'Hanger',
    category: IconCategoryId.GENERAL,
  },
  SvgHierarchySolid: {
    icon: SvgHierarchySolid,
    label: 'Hierarchy',
    category: IconCategoryId.GENERAL,
  },
  SvgHighlighter: {
    icon: SvgHighlighter,
    label: 'Highlighter',
    category: IconCategoryId.EDITOR,
  },
  SvgHtml: {
    icon: SvgHtml,
    label: 'HTML',
    category: IconCategoryId.FILES,
  },
  SvgHubspot: {
    icon: SvgHubspot,
    label: 'HubSpot',
    category: IconCategoryId.LOGOS,
  },
  SvgHumanize: {
    icon: SvgHumanize,
    label: 'Humanize',
    category: IconCategoryId.USERS,
  },
  SvgImage: {
    icon: SvgImage,
    label: 'Image',
    category: IconCategoryId.IMAGES,
  },
  SvgImage01: {
    icon: SvgImage01,
    label: 'Image',
    category: IconCategoryId.IMAGES,
  },
  SvgImg: {
    icon: SvgImg,
    label: 'Image',
    category: IconCategoryId.FILES,
  },
  SvgIndd: {
    icon: SvgIndd,
    label: 'InDesign',
    category: IconCategoryId.FILES,
  },
  SvgInfoSquare: {
    icon: SvgInfoSquare,
    label: 'Info Square',
    category: IconCategoryId.GENERAL,
  },
  SvgInputSolid: {
    icon: SvgInputSolid,
    label: 'Input Solid',
    category: IconCategoryId.COMPONENTS,
  },
  SvgJava: {
    icon: SvgJava,
    label: 'Java',
    category: IconCategoryId.FILES,
  },
  SvgJavaLanguage: {
    icon: SvgJavaLanguage,
    label: 'Java',
    category: IconCategoryId.DEVELOPMENT,
  },
  SvgJpeg: {
    icon: SvgJpeg,
    label: 'JPEG',
    category: IconCategoryId.FILES,
  },
  SvgJpg: {
    icon: SvgJpg,
    label: 'JPG',
    category: IconCategoryId.FILES,
  },
  SvgJs: {
    icon: SvgJs,
    label: 'JavaScript',
    category: IconCategoryId.FILES,
  },
  SvgJsLanguage: {
    icon: SvgJsLanguage,
    label: 'JavaScript',
    category: IconCategoryId.DEVELOPMENT,
  },
  SvgJson: {
    icon: SvgJson,
    label: 'JSON',
    category: IconCategoryId.FILES,
  },
  SvgJsonLanguage: {
    icon: SvgJsonLanguage,
    label: 'JSON',
    category: IconCategoryId.DEVELOPMENT,
  },
  SvgJsonSchemaLanguage: {
    icon: SvgJsonSchemaLanguage,
    label: 'JSON Schema',
    category: IconCategoryId.DEVELOPMENT,
  },
  SvgJwtValidation: {
    icon: SvgJwtValidation,
    label: 'JWT Validation',
    category: IconCategoryId.SECURITY,
  },
  SvgKey01: {
    icon: SvgKey01,
    label: 'Key',
    category: IconCategoryId.SECURITY,
  },
  SvgLayers: {
    icon: SvgLayers,
    label: 'Layers',
    category: IconCategoryId.LAYOUT,
  },
  SvgLayersStack: {
    icon: SvgLayersStack,
    label: 'Layers Stack',
    category: IconCategoryId.GENERAL,
  },
  SvgLayoutAlt01: {
    icon: SvgLayoutAlt01,
    label: 'Layout Alt',
    category: IconCategoryId.LAYOUT,
  },
  SvgLayoutGrid02: {
    icon: SvgLayoutGrid02,
    label: 'Layout Grid',
    category: IconCategoryId.LAYOUT,
  },
  SvgLayoutTop: {
    icon: SvgLayoutTop,
    label: 'Layout Top',
    category: IconCategoryId.LAYOUT,
  },
  SvgLcCard: {
    icon: SvgLcCard,
    label: 'Card',
    category: IconCategoryId.LAYOUT,
  },
  SvgLcContainer: {
    icon: SvgLcContainer,
    label: 'SvgLcContainer',
    category: IconCategoryId.LAYOUT,
  },
  SvgLcContainer02: {
    icon: SvgLcContainer02,
    label: 'Container 02',
    category: IconCategoryId.LAYOUT,
  },
  SvgLcCopilot: {
    icon: SvgLcCopilot,
    label: 'Copilot',
    category: IconCategoryId.AI,
  },
  SvgLcIcon: {
    icon: SvgLcIcon,
    label: 'Icon',
    category: IconCategoryId.GENERAL,
  },
  SvgLcIconButton: {
    icon: SvgLcIconButton,
    label: 'Icon Button',
    category: IconCategoryId.LAYOUT,
  },
  SvgLcLink: {
    icon: SvgLcLink,
    label: 'Link',
    category: IconCategoryId.GENERAL,
  },
  SvgLcProgressBar: {
    icon: SvgLcProgressBar,
    label: 'Progress Bar',
    category: IconCategoryId.GENERAL,
  },
  SvgLcSectionColumn: {
    icon: SvgLcSectionColumn,
    label: 'SvgLcSectionColumn',
    category: IconCategoryId.LAYOUT,
  },
  SvgLcSheets: {
    icon: SvgLcSheets,
    label: 'csv',
    category: IconCategoryId.GENERAL,
  },
  SvgLcTimeline: {
    icon: SvgLcTimeline,
    label: 'Timeline',
    category: IconCategoryId.TIME,
  },
  SvgLdap: {
    icon: SvgLdap,
    label: 'LDAP',
    category: IconCategoryId.SECURITY,
  },
  SvgLibrary: {
    icon: SvgLibrary,
    label: 'Library',
    category: IconCategoryId.GENERAL,
  },
  SvgLightbulb02: {
    icon: SvgLightbulb02,
    label: 'Lightbulb 2',
    category: IconCategoryId.MEDIA_AND_DEVICES,
  },
  SvgLightbulb03: {
    icon: SvgLightbulb03,
    label: 'Lightbulb 3',
    category: IconCategoryId.MEDIA_AND_DEVICES,
  },
  SvgLightbulb05: {
    icon: SvgLightbulb05,
    label: 'Lightbulb 5',
    category: IconCategoryId.MEDIA_AND_DEVICES,
  },
  SvgLineChartDown01: {
    icon: SvgLineChartDown01,
    label: 'Line Chart Down',
    category: IconCategoryId.CHARTS,
  },
  SvgLineChartUp03: {
    icon: SvgLineChartUp03,
    label: 'Line Chart Up',
    category: IconCategoryId.CHARTS,
  },
  SvgLink01: {
    icon: SvgLink01,
    label: 'Link',
    category: IconCategoryId.GENERAL,
  },
  SvgLinkHorizontal: {
    icon: SvgLinkHorizontal,
    label: 'Link Horizontal',
    category: IconCategoryId.GENERAL,
  },
  SvgList: {
    icon: SvgList,
    label: 'List',
    category: IconCategoryId.LAYOUT,
  },
  SvgListCheck: {
    icon: SvgListCheck,
    label: 'List Check',
    category: IconCategoryId.LAYOUT,
  },
  SvgLoading01: {
    icon: SvgLoading01,
    label: 'Loading 01',
    category: IconCategoryId.GENERAL,
  },
  SvgLocalStorage: {
    icon: SvgLocalStorage,
    label: 'Local Storage',
    category: IconCategoryId.DEVELOPMENT,
  },
  SvgLocation: {
    icon: SvgLocation,
    label: 'Location',
    category: IconCategoryId.TRAVEL,
  },
  SvgLock01: {
    icon: SvgLock01,
    label: 'Lock',
    category: IconCategoryId.SECURITY,
  },
  SvgLoop: {
    icon: SvgLoop,
    label: 'Loop',
    category: IconCategoryId.DEVELOPMENT,
  },
  SvgLowercase: {
    icon: SvgLowercase,
    label: 'Lowercase',
    category: IconCategoryId.EDITOR,
  },
  SvgMagicWand: {
    icon: SvgMagicWand,
    label: 'Magic Wand',
    category: IconCategoryId.GENERAL,
  },
  SvgMagicWand01: {
    icon: SvgMagicWand01,
    label: 'Magic Wand',
    category: IconCategoryId.GENERAL,
  },
  SvgMapEdge: {
    icon: SvgMapEdge,
    label: 'Map Edge',
    category: IconCategoryId.GENERAL,
  },
  SvgMapNode: {
    icon: SvgMapNode,
    label: 'Map Node',
    category: IconCategoryId.GENERAL,
  },
  SvgMarginVertical: {
    icon: SvgMarginVertical,
    label: 'Margin Vertical',
    category: IconCategoryId.LAYOUT,
  },
  SvgMarkerPin01: {
    icon: SvgMarkerPin01,
    label: 'Map Pin',
    category: IconCategoryId.TRAVEL,
  },
  SvgMaximize01: {
    icon: SvgMaximize01,
    label: 'Maximize',
    category: IconCategoryId.LAYOUT,
  },
  SvgMedicalCross: {
    icon: SvgMedicalCross,
    label: 'Medical Cross',
    category: IconCategoryId.GENERAL,
  },
  SvgMessageChatSquare: {
    icon: SvgMessageChatSquare,
    label: 'Message Chat Square',
    category: IconCategoryId.COMMUNICATION,
  },
  SvgMessageHeartSquare: {
    icon: SvgMessageHeartSquare,
    label: 'Message Heart Square',
    category: IconCategoryId.COMMUNICATION,
  },
  SvgMessageSquare02: {
    icon: SvgMessageSquare02,
    label: 'Message Square',
    category: IconCategoryId.COMMUNICATION,
  },
  SvgMessageTextSquare01: {
    icon: SvgMessageTextSquare01,
    label: 'Message Text Square',
    category: IconCategoryId.COMMUNICATION,
  },
  SvgMicrosoft: {
    icon: SvgMicrosoft,
    label: 'Microsoft',
    category: IconCategoryId.LOGOS,
  },
  SvgMicrosoftTeams: {
    icon: SvgMicrosoftTeams,
    label: 'Microsoft Teams',
    category: IconCategoryId.COMMUNICATION,
  },
  SvgMinimize01: {
    icon: SvgMinimize01,
    label: 'Minimize',
    category: IconCategoryId.LAYOUT,
  },
  SvgModified: {
    icon: SvgModified,
    label: 'Modified',
    category: IconCategoryId.DEVELOPMENT,
  },
  SvgMonitor01Solid: {
    icon: SvgMonitor01Solid,
    label: 'Monitor',
    category: IconCategoryId.MEDIA_AND_DEVICES,
  },
  SvgMonitoringExperiment: {
    icon: SvgMonitoringExperiment,
    label: 'Monitoring Experiment',
    category: IconCategoryId.DEVELOPMENT,
  },
  SvgMoon01: {
    icon: SvgMoon01,
    label: 'Moon',
    category: IconCategoryId.GENERAL,
  },
  SvgMoon01Solid: {
    icon: SvgMoon01Solid,
    label: 'MoonSolid',
    category: IconCategoryId.GENERAL,
  },
  SvgMove: {
    icon: SvgMove,
    label: 'Move',
    category: IconCategoryId.GENERAL,
  },
  SvgMozillaFirefox: {
    icon: SvgMozillaFirefox,
    label: 'Mozilla Firefox',
    category: IconCategoryId.LOGOS,
  },
  SvgMp3: {
    icon: SvgMp3,
    label: 'MP3',
    category: IconCategoryId.FILES,
  },
  SvgMp4: {
    icon: SvgMp4,
    label: 'MP4',
    category: IconCategoryId.FILES,
  },
  SvgMpeg: {
    icon: SvgMpeg,
    label: 'MPEG',
    category: IconCategoryId.FILES,
  },
  SvgMqtt: {
    icon: SvgMqtt,
    label: 'MQTT',
    category: IconCategoryId.COMMUNICATION,
  },
  SvgMultiSelect: {
    icon: SvgMultiSelect,
    label: 'Multi Select',
    category: IconCategoryId.GENERAL,
  },
  SvgNavigationMenu: {
    icon: SvgNavigationMenu,
    label: 'Navigation Menu',
    category: IconCategoryId.LAYOUT,
  },
  SvgNoCodeBottomsheet: {
    icon: SvgNoCodeBottomsheet,
    label: 'Bottom Sheet',
    category: IconCategoryId.LAYOUT,
  },
  SvgNoCodeCascader: {
    icon: SvgNoCodeCascader,
    label: 'Cascader',
    category: IconCategoryId.GENERAL,
  },
  SvgNoCodeColorCascader: {
    icon: SvgNoCodeColorCascader,
    label: 'Cascader Color',
    category: IconCategoryId.COMPONENTS,
  },
  SvgNoCodeColorCheckbox: {
    icon: SvgNoCodeColorCheckbox,
    label: 'Checkbox Color',
    category: IconCategoryId.COMPONENTS,
  },
  SvgNoCodeColorEventsTimeline: {
    icon: SvgNoCodeColorEventsTimeline,
    label: 'SvgNoCodeColorEventsTimeline',
    category: IconCategoryId.COMPONENTS,
  },
  SvgNoCodeColorFloatingActionbutton: {
    icon: SvgNoCodeColorFloatingActionbutton,
    label: 'Floating Action Button Color',
    category: IconCategoryId.COMPONENTS,
  },
  SvgNoCodeColorImageGrid: {
    icon: SvgNoCodeColorImageGrid,
    label: 'Image Grid Color',
    category: IconCategoryId.COMPONENTS,
  },
  SvgNoCodeColorLottieAnimation: {
    icon: SvgNoCodeColorLottieAnimation,
    label: 'Lottie Animation Color',
    category: IconCategoryId.GENERAL,
  },
  SvgNoCodeColorModule: {
    icon: SvgNoCodeColorModule,
    label: 'Module Color',
    category: IconCategoryId.COMPONENTS,
  },
  SvgNoCodeColorOrgChart: {
    icon: SvgNoCodeColorOrgChart,
    label: 'SvgNoCodeColorOrgChart',
    category: IconCategoryId.COMPONENTS,
  },
  SvgNoCodeColorSheetPreview: {
    icon: SvgNoCodeColorSheetPreview,
    label: 'Sheet Preview Color',
    category: IconCategoryId.COMPONENTS,
  },
  SvgNoCodeColorToggle: {
    icon: SvgNoCodeColorToggle,
    label: 'Toggle Color',
    category: IconCategoryId.COMPONENTS,
  },
  SvgNoCodeCustomIcons: {
    icon: SvgNoCodeCustomIcons,
    label: 'No Code Custom Icons',
    category: IconCategoryId.COMPONENTS,
  },
  SvgNoCodeDesign: {
    icon: SvgNoCodeDesign,
    label: 'Design',
    category: IconCategoryId.COMPONENTS,
  },
  SvgNoCodeEventsTimeline: {
    icon: SvgNoCodeEventsTimeline,
    label: 'SvgNoCodeEventsTimeline',
    category: IconCategoryId.COMPONENTS,
  },
  SvgNoCodeFloatingActionbutton: {
    icon: SvgNoCodeFloatingActionbutton,
    label: 'Floating Action Button',
    category: IconCategoryId.LAYOUT,
  },
  SvgNoCodeFolderClose: {
    icon: SvgNoCodeFolderClose,
    label: 'Folder Closed',
    category: IconCategoryId.FILES,
  },
  SvgNoCodeFolderOpen: {
    icon: SvgNoCodeFolderOpen,
    label: 'Folder Open',
    category: IconCategoryId.FILES,
  },
  SvgNoCodeFolderPlus: {
    icon: SvgNoCodeFolderPlus,
    label: 'Folder Plus',
    category: IconCategoryId.FILES,
  },
  SvgNoCodeForm: {
    icon: SvgNoCodeForm,
    label: 'Form',
    category: IconCategoryId.LAYOUT,
  },
  SvgNoCodeImageGrid: {
    icon: SvgNoCodeImageGrid,
    label: 'Image Grid',
    category: IconCategoryId.IMAGES,
  },
  SvgNoCodeLottieAnimation: {
    icon: SvgNoCodeLottieAnimation,
    label: 'Lottie Animation',
    category: IconCategoryId.GENERAL,
  },
  SvgNoCodeModulePlus: {
    icon: SvgNoCodeModulePlus,
    label: 'Module Plus',
    category: IconCategoryId.FILES,
  },
  SvgNoCodeNavigatorActive: {
    icon: SvgNoCodeNavigatorActive,
    label: 'Navigator Active',
    category: IconCategoryId.LAYOUT,
  },
  SvgNoCodeOrgChart: {
    icon: SvgNoCodeOrgChart,
    label: 'Org Chart',
    category: IconCategoryId.CHARTS,
  },
  SvgNoCodePage: {
    icon: SvgNoCodePage,
    label: 'Page',
    category: IconCategoryId.FILES,
  },
  SvgNoCodePagePlus: {
    icon: SvgNoCodePagePlus,
    label: 'Page Plus',
    category: IconCategoryId.FILES,
  },
  SvgNoCodeSheetPreview: {
    icon: SvgNoCodeSheetPreview,
    label: 'Sheet Preview',
    category: IconCategoryId.LAYOUT,
  },
  SvgNoCodeSideDrawer: {
    icon: SvgNoCodeSideDrawer,
    label: 'Side Drawer',
    category: IconCategoryId.LAYOUT,
  },
  SvgNoCodeSlot: {
    icon: SvgNoCodeSlot,
    label: 'No Code Slot',
    category: IconCategoryId.GENERAL,
  },
  SvgNoCodeTemplateComponent: {
    icon: SvgNoCodeTemplateComponent,
    label: 'No Code Template Component',
    category: IconCategoryId.GENERAL,
  },
  SvgNoCodeUnifyAppsChat: {
    icon: SvgNoCodeUnifyAppsChat,
    label: 'Unify Apps Chat',
    category: IconCategoryId.COMPONENTS,
  },
  SvgNotification: {
    icon: SvgNotification,
    label: 'Notification',
    category: IconCategoryId.GENERAL,
  },
  SvgNotificationMuted: {
    icon: SvgNotificationMuted,
    label: 'Muted Notification',
    category: IconCategoryId.GENERAL,
  },
  SvgNotificationText: {
    icon: SvgNotificationText,
    label: 'Notification Text',
    category: IconCategoryId.ALERTS_AND_FEEDBACK,
  },
  SvgOkta: {
    icon: SvgOkta,
    label: 'Okta',
    category: IconCategoryId.LOGOS,
  },
  SvgOkta02: {
    icon: SvgOkta02,
    label: 'Okta 2',
    category: IconCategoryId.SECURITY,
  },
  SvgOpenFolder: {
    icon: SvgOpenFolder,
    label: 'Open Folder',
    category: IconCategoryId.FILES,
  },
  SvgOpenId: {
    icon: SvgOpenId,
    label: 'OpenID',
    category: IconCategoryId.LOGOS,
  },
  SvgOtel: {
    icon: SvgOtel,
    label: 'Open Telemetry',
    category: IconCategoryId.DEVELOPMENT,
  },
  SvgOutlineFolder: {
    icon: SvgOutlineFolder,
    label: 'Folder Outline',
    category: IconCategoryId.FILES,
  },
  SvgPackage: {
    icon: SvgPackage,
    label: 'Package',
    category: IconCategoryId.DEVELOPMENT,
  },
  SvgPage: {
    icon: SvgPage,
    label: 'Page',
    category: IconCategoryId.FILES,
  },
  SvgPageVariables: {
    icon: SvgPageVariables,
    label: 'Page Variables',
    category: IconCategoryId.DEVELOPMENT,
  },
  SvgPaginate: {
    icon: SvgPaginate,
    label: 'Paginate',
    category: IconCategoryId.EDITOR,
  },
  SvgPaginateSolid: {
    icon: SvgPaginateSolid,
    label: 'Paginate',
    category: IconCategoryId.EDITOR,
  },
  SvgPaintPour: {
    icon: SvgPaintPour,
    label: 'Paint Pour',
    category: IconCategoryId.EDITOR,
  },
  SvgPaperAirplane: {
    icon: SvgPaperAirplane,
    label: 'Paper Airplane',
    category: IconCategoryId.COMMUNICATION,
  },
  SvgPasscode: {
    icon: SvgPasscode,
    label: 'Passcode',
    category: IconCategoryId.SECURITY,
  },
  SvgPasscodeLock: {
    icon: SvgPasscodeLock,
    label: 'Passcode Lock',
    category: IconCategoryId.SECURITY,
  },
  SvgPaste: {
    icon: SvgPaste,
    label: 'Paste',
    category: IconCategoryId.FILES,
  },
  SvgPaste02: {
    icon: SvgPaste02,
    label: 'Paste 2',
    category: IconCategoryId.FILES,
  },
  SvgPdf: {
    icon: SvgPdf,
    label: 'PDF',
    category: IconCategoryId.FILES,
  },
  SvgPdf01: {
    icon: SvgPdf01,
    label: 'PDF',
    category: IconCategoryId.FILES,
  },
  SvgPencil01: {
    icon: SvgPencil01,
    label: 'Pencil',
    category: IconCategoryId.EDITOR,
  },
  SvgPencilRuler: {
    icon: SvgPencilRuler,
    label: 'Pencil Ruler',
    category: IconCategoryId.EDITOR,
  },
  SvgPenTool: {
    icon: SvgPenTool,
    label: 'Pen Tool',
    category: IconCategoryId.EDITOR,
  },
  SvgPeople: {
    icon: SvgPeople,
    label: 'People',
    category: IconCategoryId.USERS,
  },
  SvgPercent02: {
    icon: SvgPercent02,
    label: 'Percent',
    category: IconCategoryId.GENERAL,
  },
  SvgPhone: {
    icon: SvgPhone,
    label: 'Phone',
    category: IconCategoryId.COMMUNICATION,
  },
  SvgPhone01: {
    icon: SvgPhone01,
    label: 'Phone 1',
    category: IconCategoryId.MEDIA_AND_DEVICES,
  },
  SvgPhone02: {
    icon: SvgPhone02,
    label: 'Phone 2',
    category: IconCategoryId.MEDIA_AND_DEVICES,
  },
  SvgPhone02Solid: {
    icon: SvgPhone02Solid,
    label: 'Phone 2',
    category: IconCategoryId.MEDIA_AND_DEVICES,
  },
  SvgPin02: {
    icon: SvgPin02,
    label: 'Pin',
    category: IconCategoryId.GENERAL,
  },
  SvgPin02Solid: {
    icon: SvgPin02Solid,
    label: 'Pin Filled',
    category: IconCategoryId.GENERAL,
  },
  SvgPinInput: {
    icon: SvgPinInput,
    label: 'Pin Input',
    category: IconCategoryId.SECURITY,
  },
  SvgPipeline01: {
    icon: SvgPipeline01,
    label: 'Pipeline',
    category: IconCategoryId.DEVELOPMENT,
  },
  SvgPlatformSettings: {
    icon: SvgPlatformSettings,
    label: 'Platform Settings',
    category: IconCategoryId.GENERAL,
  },
  SvgPlayCircle: {
    icon: SvgPlayCircle,
    label: 'Play Circle',
    category: IconCategoryId.MEDIA_AND_DEVICES,
  },
  SvgPlaylist: {
    icon: SvgPlaylist,
    label: 'Playlist',
    category: IconCategoryId.MEDIA_AND_DEVICES,
  },
  SvgPlugIn: {
    icon: SvgPlugIn,
    label: 'Plug In',
    category: IconCategoryId.DEVELOPMENT,
  },
  SvgPlusSolid: {
    icon: SvgPlusSolid,
    label: 'Plus',
    category: IconCategoryId.GENERAL,
  },
  SvgPng: {
    icon: SvgPng,
    label: 'PNG',
    category: IconCategoryId.FILES,
  },
  SvgPpt: {
    icon: SvgPpt,
    label: 'PPT',
    category: IconCategoryId.FILES,
  },
  SvgPptx: {
    icon: SvgPptx,
    label: 'PPTX',
    category: IconCategoryId.FILES,
  },
  SvgPreprocessingRequest: {
    icon: SvgPreprocessingRequest,
    label: 'Preprocessing Request',
    category: IconCategoryId.GENERAL,
  },
  SvgPresentationDeck: {
    icon: SvgPresentationDeck,
    label: 'Presentation Deck',
    category: IconCategoryId.CHARTS,
  },
  SvgPsd: {
    icon: SvgPsd,
    label: 'PSD',
    category: IconCategoryId.FILES,
  },
  SvgPublish: {
    icon: SvgPublish,
    label: 'Publish',
    category: IconCategoryId.GENERAL,
  },
  SvgPusher: {
    icon: SvgPusher,
    label: 'Pusher',
    category: IconCategoryId.LOGOS,
  },
  SvgPuzzlePiece02: {
    icon: SvgPuzzlePiece02,
    label: 'Puzzle Piece',
    category: IconCategoryId.DEVELOPMENT,
  },
  SvgPythonLanguage: {
    icon: SvgPythonLanguage,
    label: 'Python',
    category: IconCategoryId.DEVELOPMENT,
  },
  SvgQuestionMark: {
    icon: SvgQuestionMark,
    label: 'Question Mark',
    category: IconCategoryId.GENERAL,
  },
  SvgQuotes: {
    icon: SvgQuotes,
    label: 'Quote Start',
    category: IconCategoryId.EDITOR,
  },
  SvgRadioSelect: {
    icon: SvgRadioSelect,
    label: 'Radio Select',
    category: IconCategoryId.GENERAL,
  },
  SvgRar: {
    icon: SvgRar,
    label: 'RAR',
    category: IconCategoryId.FILES,
  },
  SvgReflect01: {
    icon: SvgReflect01,
    label: 'Reflect',
    category: IconCategoryId.EDITOR,
  },
  SvgRefreshCcw01Solid: {
    icon: SvgRefreshCcw01Solid,
    label: 'SvgRefreshCcw01Solid',
    category: IconCategoryId.GENERAL,
  },
  SvgRefreshCcw05Solid: {
    icon: SvgRefreshCcw05Solid,
    label: 'Refresh 5',
    category: IconCategoryId.ARROWS,
  },
  SvgRepeat04: {
    icon: SvgRepeat04,
    label: 'Repeat',
    category: IconCategoryId.GENERAL,
  },
  SvgRequestTransformer: {
    icon: SvgRequestTransformer,
    label: 'Request Transformer',
    category: IconCategoryId.DEVELOPMENT,
  },
  SvgResetPassword: {
    icon: SvgResetPassword,
    label: 'Reset Password',
    category: IconCategoryId.SECURITY,
  },
  SvgReverseLeft: {
    icon: SvgReverseLeft,
    label: 'Reverse Left',
    category: IconCategoryId.ARROWS,
  },
  SvgReview: {
    icon: SvgReview,
    label: 'Review',
    category: IconCategoryId.ALERTS_AND_FEEDBACK,
  },
  SvgRocket02: {
    icon: SvgRocket02,
    label: 'Rocket',
    category: IconCategoryId.TRAVEL,
  },
  SvgRotateLeft: {
    icon: SvgRotateLeft,
    label: 'Rotate Left',
    category: IconCategoryId.ARROWS,
  },
  SvgRotateRight: {
    icon: SvgRotateRight,
    label: 'Rotate Right',
    category: IconCategoryId.ARROWS,
  },
  SvgRound: {
    icon: SvgRound,
    label: 'Round',
    category: IconCategoryId.DEVELOPMENT,
  },
  SvgRows01: {
    icon: SvgRows01,
    label: 'Rows 1',
    category: IconCategoryId.LAYOUT,
  },
  SvgRows03: {
    icon: SvgRows03,
    label: 'Rows 3',
    category: IconCategoryId.LAYOUT,
  },
  SvgRss: {
    icon: SvgRss,
    label: 'RSS',
    category: IconCategoryId.FILES,
  },
  SvgSafari: {
    icon: SvgSafari,
    label: 'Safari',
    category: IconCategoryId.LOGOS,
  },
  SvgSalesforce: {
    icon: SvgSalesforce,
    label: 'Salesforce',
    category: IconCategoryId.LOGOS,
  },
  SvgScan: {
    icon: SvgScan,
    label: 'SvgScan',
    category: IconCategoryId.GENERAL,
  },
  SvgScissorsCut02: {
    icon: SvgScissorsCut02,
    label: 'Cut',
    category: IconCategoryId.EDITOR,
  },
  SvgScript: {
    icon: SvgScript,
    label: 'Script',
    category: IconCategoryId.DEVELOPMENT,
  },
  SvgScript02: {
    icon: SvgScript02,
    label: 'Script',
    category: IconCategoryId.DEVELOPMENT,
  },
  SvgSearchBook: {
    icon: SvgSearchBook,
    label: 'Search Book',
    category: IconCategoryId.EDUCATION,
  },
  SvgSearchMd: {
    icon: SvgSearchMd,
    label: 'Search',
    category: IconCategoryId.GENERAL,
  },
  SvgSearchMdFilled: {
    icon: SvgSearchMdFilled,
    label: 'Search Filled',
    category: IconCategoryId.GENERAL,
  },
  SvgSearchMdSolid: {
    icon: SvgSearchMdSolid,
    label: 'Search',
    category: IconCategoryId.GENERAL,
  },
  SvgSearchRefraction: {
    icon: SvgSearchRefraction,
    label: 'Search Refraction',
    category: IconCategoryId.GENERAL,
  },
  SvgSearchStar02: {
    icon: SvgSearchStar02,
    label: 'SvgSearchStar02',
    category: IconCategoryId.GENERAL,
  },
  SvgSend01: {
    icon: SvgSend01,
    label: 'Send',
    category: IconCategoryId.COMMUNICATION,
  },
  SvgSeoOptimise: {
    icon: SvgSeoOptimise,
    label: 'SvgSeoOptimise',
    category: IconCategoryId.GENERAL,
  },
  SvgSettings: {
    icon: SvgSettings,
    label: 'Settings',
    category: IconCategoryId.GENERAL,
  },
  SvgSettings01: {
    icon: SvgSettings01,
    label: 'Settings 1',
    category: IconCategoryId.GENERAL,
  },
  SvgSettingsSolid: {
    icon: SvgSettingsSolid,
    label: 'Settings',
    category: IconCategoryId.GENERAL,
  },
  SvgShare07: {
    icon: SvgShare07,
    label: 'Share',
    category: IconCategoryId.GENERAL,
  },
  SvgShield01: {
    icon: SvgShield01,
    label: 'Shield 01',
    category: IconCategoryId.GENERAL,
  },
  SvgShield02: {
    icon: SvgShield02,
    label: 'Shield 2',
    category: IconCategoryId.SECURITY,
  },
  SvgShield03: {
    icon: SvgShield03,
    label: 'Shield 3',
    category: IconCategoryId.SECURITY,
  },
  SvgShieldAgent02: {
    icon: SvgShieldAgent02,
    label: 'Shield Agent 2',
    category: IconCategoryId.SECURITY,
  },
  SvgShieldOff: {
    icon: SvgShieldOff,
    label: 'Shield Off',
    category: IconCategoryId.SECURITY,
  },
  SvgShieldStar: {
    icon: SvgShieldStar,
    label: 'Shield Star',
    category: IconCategoryId.GENERAL,
  },
  SvgShieldStarOutline: {
    icon: SvgShieldStarOutline,
    label: 'Shield Star',
    category: IconCategoryId.GENERAL,
  },
  SvgShieldTick: {
    icon: SvgShieldTick,
    label: 'Shield Tick',
    category: IconCategoryId.SECURITY,
  },
  SvgShoppingBag02: {
    icon: SvgShoppingBag02,
    label: 'Shopping Bag',
    category: IconCategoryId.FINANCE,
  },
  SvgShoppingCart01: {
    icon: SvgShoppingCart01,
    label: 'Shopping Cart',
    category: IconCategoryId.GENERAL,
  },
  SvgShuffle01: {
    icon: SvgShuffle01,
    label: 'Shuffle',
    category: IconCategoryId.MEDIA_AND_DEVICES,
  },
  SvgSignal01: {
    icon: SvgSignal01,
    label: 'Signal 1',
    category: IconCategoryId.MEDIA_AND_DEVICES,
  },
  SvgSignal02: {
    icon: SvgSignal02,
    label: 'Signal 2',
    category: IconCategoryId.MEDIA_AND_DEVICES,
  },
  SvgSignal03: {
    icon: SvgSignal03,
    label: 'Signal 3',
    category: IconCategoryId.MEDIA_AND_DEVICES,
  },
  SvgSimcard: {
    icon: SvgSimcard,
    label: 'SIM Card',
    category: IconCategoryId.MEDIA_AND_DEVICES,
  },
  SvgSingleSelect: {
    icon: SvgSingleSelect,
    label: 'Single Select',
    category: IconCategoryId.GENERAL,
  },
  SvgSlack: {
    icon: SvgSlack,
    label: 'Slack',
    category: IconCategoryId.LOGOS,
  },
  SvgSlashDivider: {
    icon: SvgSlashDivider,
    label: 'Divider',
    category: IconCategoryId.GENERAL,
  },
  SvgSliders01: {
    icon: SvgSliders01,
    label: 'Sliders 1',
    category: IconCategoryId.MEDIA_AND_DEVICES,
  },
  SvgSliders01Outline: {
    icon: SvgSliders01Outline,
    label: 'Outline Sliders 1',
    category: IconCategoryId.MEDIA_AND_DEVICES,
  },
  SvgSliders04: {
    icon: SvgSliders04,
    label: 'Sliders',
    category: IconCategoryId.MEDIA_AND_DEVICES,
  },
  SvgSolidLock: {
    icon: SvgSolidLock,
    label: 'Lock (solid)',
    category: IconCategoryId.SECURITY,
  },
  SvgSpacingHeight01: {
    icon: SvgSpacingHeight01,
    label: 'Spacing Height',
    category: IconCategoryId.LAYOUT,
  },
  SvgSpacingWidth02: {
    icon: SvgSpacingWidth02,
    label: 'Spacing Width',
    category: IconCategoryId.LAYOUT,
  },
  SvgSpeedMeterSolid: {
    icon: SvgSpeedMeterSolid,
    label: 'Speed Meter',
    category: IconCategoryId.GENERAL,
  },
  SvgSpeedometer01: {
    icon: SvgSpeedometer01,
    label: 'Speedometer 1',
    category: IconCategoryId.GENERAL,
  },
  SvgSpeedometer03: {
    icon: SvgSpeedometer03,
    label: 'Speedometer 3',
    category: IconCategoryId.GENERAL,
  },
  SvgSpreadsheet: {
    icon: SvgSpreadsheet,
    label: 'Spreadsheet',
    category: IconCategoryId.FILES,
  },
  SvgSprinklr: {
    icon: SvgSprinklr,
    label: 'Sprinklr',
    category: IconCategoryId.LOGOS,
  },
  SvgSql: {
    icon: SvgSql,
    label: 'SQL',
    category: IconCategoryId.FILES,
  },
  SvgSquared: {
    icon: SvgSquared,
    label: 'Squared',
    category: IconCategoryId.DEVELOPMENT,
  },
  SvgStar02: {
    icon: SvgStar02,
    label: 'Star 2',
    category: IconCategoryId.GENERAL,
  },
  SvgStar04: {
    icon: SvgStar04,
    label: 'Star 4',
    category: IconCategoryId.GENERAL,
  },
  SvgStar04Solid: {
    icon: SvgStar04Solid,
    label: 'Star 4 Solid',
    category: IconCategoryId.GENERAL,
  },
  SvgStar07: {
    icon: SvgStar07,
    label: 'Star 7',
    category: IconCategoryId.GENERAL,
  },
  SvgStarOff: {
    icon: SvgStarOff,
    label: 'Star Off',
    category: IconCategoryId.GENERAL,
  },
  SvgStars01: {
    icon: SvgStars01,
    label: 'Stars01',
    category: IconCategoryId.GENERAL,
  },
  SvgStatusArchived: {
    icon: SvgStatusArchived,
    label: 'Status Archived',
    category: IconCategoryId.ALERTS_AND_FEEDBACK,
  },
  SvgStatusDraft: {
    icon: SvgStatusDraft,
    label: 'Status Draft',
    category: IconCategoryId.ALERTS_AND_FEEDBACK,
  },
  SvgStatusError: {
    icon: SvgStatusError,
    label: 'Status Error',
    category: IconCategoryId.ALERTS_AND_FEEDBACK,
  },
  SvgStatusLive: {
    icon: SvgStatusLive,
    label: 'Status Live',
    category: IconCategoryId.ALERTS_AND_FEEDBACK,
  },
  SvgStatusPaused: {
    icon: SvgStatusPaused,
    label: 'Status Paused',
    category: IconCategoryId.ALERTS_AND_FEEDBACK,
  },
  SvgStatusPaused02: {
    icon: SvgStatusPaused02,
    label: 'Status Paused 02',
    category: IconCategoryId.ALERTS_AND_FEEDBACK,
  },
  SvgStepComplete: {
    icon: SvgStepComplete,
    label: 'Step Complete',
    category: IconCategoryId.DEVELOPMENT,
  },
  SvgStepCurrent: {
    icon: SvgStepCurrent,
    label: 'Step Current',
    category: IconCategoryId.DEVELOPMENT,
  },
  SvgStepError: {
    icon: SvgStepError,
    label: 'Step Error',
    category: IconCategoryId.DEVELOPMENT,
  },
  SvgStepIncomplete: {
    icon: SvgStepIncomplete,
    label: 'Step Incomplete',
    category: IconCategoryId.DEVELOPMENT,
  },
  SvgStore: {
    icon: SvgStore,
    label: 'Store',
    category: IconCategoryId.GENERAL,
  },
  SvgStructure: {
    icon: SvgStructure,
    label: 'Structure',
    category: IconCategoryId.LAYOUT,
  },
  SvgSupport: {
    icon: SvgSupport,
    label: 'Support',
    category: IconCategoryId.SECURITY,
  },
  SvgSvg: {
    icon: SvgSvg,
    label: 'SVG',
    category: IconCategoryId.FILES,
  },
  SvgSvgBreaker02: {
    icon: SvgSvgBreaker02,
    label: 'Breaker',
    category: IconCategoryId.GENERAL,
  },
  SvgSwitchHorizontal01: {
    icon: SvgSwitchHorizontal01,
    label: 'Switch Horizontal',
    category: IconCategoryId.GENERAL,
  },
  SvgSwitchOff: {
    icon: SvgSwitchOff,
    label: 'Switch Off',
    category: IconCategoryId.GENERAL,
  },
  SvgSwitchOn: {
    icon: SvgSwitchOn,
    label: 'Switch On',
    category: IconCategoryId.GENERAL,
  },
  SvgSwitchVertical02: {
    icon: SvgSwitchVertical02,
    label: 'Switch Vertical 2',
    category: IconCategoryId.ARROWS,
  },
  SvgSyncing: {
    icon: SvgSyncing,
    label: 'Syncing',
    category: IconCategoryId.GENERAL,
  },
  SvgTablet01: {
    icon: SvgTablet01,
    label: 'Tablet',
    category: IconCategoryId.MEDIA_AND_DEVICES,
  },
  SvgTabletHorizontal: {
    icon: SvgTabletHorizontal,
    label: 'Tablet Horizontal',
    category: IconCategoryId.MEDIA_AND_DEVICES,
  },
  SvgTag01: {
    icon: SvgTag01,
    label: 'Tag',
    category: IconCategoryId.FINANCE,
  },
  SvgTag02: {
    icon: SvgTag02,
    label: 'Tag 2',
    category: IconCategoryId.FINANCE,
  },
  SvgTarget: {
    icon: SvgTarget,
    label: 'Target',
    category: IconCategoryId.GENERAL,
  },
  SvgTarget04: {
    icon: SvgTarget04,
    label: 'Target',
    category: IconCategoryId.GENERAL,
  },
  SvgTelescope: {
    icon: SvgTelescope,
    label: 'Telescope',
    category: IconCategoryId.EDUCATION,
  },
  SvgTerminalBrowser: {
    icon: SvgTerminalBrowser,
    label: 'Terminal Browser',
    category: IconCategoryId.DEVELOPMENT,
  },
  SvgTerminalSquareSolid: {
    icon: SvgTerminalSquareSolid,
    label: 'Terminal Square Solid',
    category: IconCategoryId.DEVELOPMENT,
  },
  SvgTextColor: {
    icon: SvgTextColor,
    label: 'Svg Text Color',
    category: IconCategoryId.GENERAL,
  },
  SvgTextInput: {
    icon: SvgTextInput,
    label: 'Text Input',
    category: IconCategoryId.EDITOR,
  },
  SvgTiff: {
    icon: SvgTiff,
    label: 'TIFF',
    category: IconCategoryId.FILES,
  },
  SvgTimeStamp: {
    icon: SvgTimeStamp,
    label: 'Time Stamp',
    category: IconCategoryId.TIME,
  },
  SvgToastBrand: {
    icon: SvgToastBrand,
    label: 'Toast Brand',
    category: IconCategoryId.COMPONENTS,
  },
  SvgTool01: {
    icon: SvgTool01,
    label: 'Tool 1',
    category: IconCategoryId.GENERAL,
  },
  SvgTool02: {
    icon: SvgTool02,
    label: 'Tool 2',
    category: IconCategoryId.GENERAL,
  },
  SvgTrain: {
    icon: SvgTrain,
    label: 'Train',
    category: IconCategoryId.TRAVEL,
  },
  SvgTranscript: {
    icon: SvgTranscript,
    label: 'Transcript',
    category: IconCategoryId.MEDIA_AND_DEVICES,
  },
  SvgTranscriptOff: {
    icon: SvgTranscriptOff,
    label: 'Transcript Off',
    category: IconCategoryId.MEDIA_AND_DEVICES,
  },
  SvgTranslate02: {
    icon: SvgTranslate02,
    label: 'Translate',
    category: IconCategoryId.GENERAL,
  },
  SvgTrash01: {
    icon: SvgTrash01,
    label: 'Trash 1',
    category: IconCategoryId.GENERAL,
  },
  SvgTrash02: {
    icon: SvgTrash02,
    label: 'Trash 2',
    category: IconCategoryId.GENERAL,
  },
  SvgTriangleDownSolid: {
    icon: SvgTriangleDownSolid,
    label: 'Triangle Down Solid',
    category: IconCategoryId.GENERAL,
  },
  SvgTriangleSolid: {
    icon: SvgTriangleSolid,
    label: 'Triangle Solid',
    category: IconCategoryId.GENERAL,
  },
  SvgTruck02: {
    icon: SvgTruck02,
    label: 'Truck 2',
    category: IconCategoryId.GENERAL,
  },
  SvgTv02: {
    icon: SvgTv02,
    label: 'TV',
    category: IconCategoryId.MEDIA_AND_DEVICES,
  },
  SvgTv02Solid: {
    icon: SvgTv02Solid,
    label: 'TV',
    category: IconCategoryId.MEDIA_AND_DEVICES,
  },
  SvgTxt: {
    icon: SvgTxt,
    label: 'TXT',
    category: IconCategoryId.FILES,
  },
  SvgTypeColorMd: {
    icon: SvgTypeColorMd,
    label: 'Type Color MD',
    category: IconCategoryId.EDITOR,
  },
  SvgTypeMd: {
    icon: SvgTypeMd,
    label: 'Type Md',
    category: IconCategoryId.EDITOR,
  },
  SvgUnifyAi: {
    icon: SvgUnifyAi,
    label: 'Unify AI',
    category: IconCategoryId.AI,
  },
  SvgUnifyAiSolid: {
    icon: SvgUnifyAiSolid,
    label: 'Unify AI Solid',
    category: IconCategoryId.AI,
  },
  SvgUnifyApi: {
    icon: SvgUnifyApi,
    label: 'Unify API',
    category: IconCategoryId.DEVELOPMENT,
  },
  SvgUnStar01: {
    icon: SvgUnStar01,
    label: 'Unstar',
    category: IconCategoryId.GENERAL,
  },
  SvgUpload01: {
    icon: SvgUpload01,
    label: 'Upload',
    category: IconCategoryId.GENERAL,
  },
  SvgUploadCloud02: {
    icon: SvgUploadCloud02,
    label: 'Upload Cloud',
    category: IconCategoryId.GENERAL,
  },
  SvgUppercase: {
    icon: SvgUppercase,
    label: 'Uppercase',
    category: IconCategoryId.EDITOR,
  },
  SvgUserCheck01: {
    icon: SvgUserCheck01,
    label: 'User Check',
    category: IconCategoryId.USERS,
  },
  SvgUserManager: {
    icon: SvgUserManager,
    label: 'User Manager',
    category: IconCategoryId.USERS,
  },
  SvgUserPlus01: {
    icon: SvgUserPlus01,
    label: 'User Plus',
    category: IconCategoryId.USERS,
  },
  SvgUserRight01: {
    icon: SvgUserRight01,
    label: 'User Right',
    category: IconCategoryId.USERS,
  },
  SvgUsers01: {
    icon: SvgUsers01,
    label: 'Users',
    category: IconCategoryId.USERS,
  },
  SvgUsersCheck: {
    icon: SvgUsersCheck,
    label: 'Users Check',
    category: IconCategoryId.USERS,
  },
  SvgUserSquare: {
    icon: SvgUserSquare,
    label: 'User Square',
    category: IconCategoryId.USERS,
  },
  SvgUsersRight: {
    icon: SvgUsersRight,
    label: 'Users Right',
    category: IconCategoryId.USERS,
  },
  SvgUsersX: {
    icon: SvgUsersX,
    label: 'Remove Users',
    category: IconCategoryId.USERS,
  },
  SvgUserThree: {
    icon: SvgUserThree,
    label: 'User Three',
    category: IconCategoryId.USERS,
  },
  SvgVariable: {
    icon: SvgVariable,
    label: 'Variable',
    category: IconCategoryId.DEVELOPMENT,
  },
  SvgVideo: {
    icon: SvgVideo,
    label: 'Video',
    category: IconCategoryId.FILES,
  },
  SvgVideo01: {
    icon: SvgVideo01,
    label: 'Video',
    category: IconCategoryId.FILES,
  },
  SvgVolumeMax: {
    icon: SvgVolumeMax,
    label: 'Volume Max',
    category: IconCategoryId.MEDIA_AND_DEVICES,
  },
  SvgVolumeMin: {
    icon: SvgVolumeMin,
    label: 'Volume Min',
    category: IconCategoryId.MEDIA_AND_DEVICES,
  },
  SvgVolumeMinus: {
    icon: SvgVolumeMinus,
    label: 'Volume Minus',
    category: IconCategoryId.MEDIA_AND_DEVICES,
  },
  SvgVolumePlus: {
    icon: SvgVolumePlus,
    label: 'Volume Plus',
    category: IconCategoryId.MEDIA_AND_DEVICES,
  },
  SvgVolumeX: {
    icon: SvgVolumeX,
    label: 'Volume X',
    category: IconCategoryId.MEDIA_AND_DEVICES,
  },
  SvgWav: {
    icon: SvgWav,
    label: 'WAV',
    category: IconCategoryId.FILES,
  },
  SvgWebcam01: {
    icon: SvgWebcam01,
    label: 'Webcam',
    category: IconCategoryId.IMAGES,
  },
  SvgWebhookSolid: {
    icon: SvgWebhookSolid,
    label: 'Webhook',
    category: IconCategoryId.DEVELOPMENT,
  },
  SvgWebp: {
    icon: SvgWebp,
    label: 'WebP',
    category: IconCategoryId.FILES,
  },
  SvgWhatsapp: {
    icon: SvgWhatsapp,
    label: 'WhatsApp',
    category: IconCategoryId.LOGOS,
  },
  SvgWidgetAdd: {
    icon: SvgWidgetAdd,
    label: 'Widget Add',
    category: IconCategoryId.LAYOUT,
  },
  SvgWorkspace: {
    icon: SvgWorkspace,
    label: 'Workspace',
    category: IconCategoryId.GENERAL,
  },
  SvgXCircleSolid: {
    icon: SvgXCircleSolid,
    label: 'X Circle Solid',
    category: IconCategoryId.GENERAL,
  },
  SvgXClose: {
    icon: SvgXClose,
    label: 'Close',
    category: IconCategoryId.GENERAL,
  },
  SvgXLogo: {
    icon: SvgXLogo,
    label: 'X Logo',
    category: IconCategoryId.LOGOS,
  },
  SvgXls: {
    icon: SvgXls,
    label: 'XLS',
    category: IconCategoryId.FILES,
  },
  SvgXml: {
    icon: SvgXml,
    label: 'XML',
    category: IconCategoryId.FILES,
  },
  SvgXmlLanguage: {
    icon: SvgXmlLanguage,
    label: 'XML',
    category: IconCategoryId.DEVELOPMENT,
  },
  SvgZapOff: {
    icon: SvgZapOff,
    label: 'Lightning Off',
    category: IconCategoryId.GENERAL,
  },
  SvgZip: {
    icon: SvgZip,
    label: 'ZIP',
    category: IconCategoryId.FILES,
  },
  SvgZoom: {
    icon: SvgZoom,
    label: 'Zoom',
    category: IconCategoryId.LOGOS,
  },
  SvgZoomInfo: {
    icon: SvgZoomInfo,
    label: 'ZoomInfo',
    category: IconCategoryId.LOGOS,
  },
  TerminalSquare: {
    icon: TerminalSquare,
    label: 'Terminal Square',
    category: IconCategoryId.DEVELOPMENT,
  },
  TextAlignCenter: {
    icon: TextAlignCenter,
    label: 'Align Center',
    category: IconCategoryId.EDITOR,
  },
  TextAlignJustify: {
    icon: TextAlignJustify,
    label: 'Align Justify',
    category: IconCategoryId.EDITOR,
  },
  TextAlignLeft: {
    icon: TextAlignLeft,
    label: 'Align Left',
    category: IconCategoryId.EDITOR,
  },
  TextAlignRight: {
    icon: TextAlignRight,
    label: 'Align Right',
    category: IconCategoryId.EDITOR,
  },
  ThumbsDown: {
    icon: ThumbsDown,
    label: 'Thumbs Down',
    category: IconCategoryId.ALERTS_AND_FEEDBACK,
  },
  ThumbsUp: {
    icon: ThumbsUp,
    label: 'Thumbs Up',
    category: IconCategoryId.ALERTS_AND_FEEDBACK,
  },
  Ticket01: {
    icon: Ticket01,
    label: 'Ticket',
    category: IconCategoryId.TRAVEL,
  },
  Toggle01Right: {
    icon: Toggle01Right,
    label: 'Toggle Right',
    category: IconCategoryId.GENERAL,
  },
  Tool02: {
    icon: Tool02,
    label: 'Tool 2',
    category: IconCategoryId.GENERAL,
  },
  Transform: {
    icon: Transform,
    label: 'Transform',
    category: IconCategoryId.EDITOR,
  },
  Trash01: {
    icon: Trash01,
    label: 'Trash',
    category: IconCategoryId.GENERAL,
  },
  Type01: {
    icon: Type01,
    label: 'Type 1',
    category: IconCategoryId.EDITOR,
  },
  Type03: {
    icon: Type03,
    label: 'Type 3',
    category: IconCategoryId.EDITOR,
  },
  TypeFeature: {
    icon: TypeFeature,
    label: 'Type Feature',
    category: IconCategoryId.GENERAL,
  },
  TypeIssue: {
    icon: TypeIssue,
    label: 'Type Issue',
    category: IconCategoryId.GENERAL,
  },
  TypeQuestion: {
    icon: TypeQuestion,
    label: 'Type Question',
    category: IconCategoryId.GENERAL,
  },
  Unfold: {
    icon: Unfold,
    label: 'Unfold',
    category: IconCategoryId.GENERAL,
  },
  UnifyAi3: {
    icon: UnifyAi3,
    label: 'Unify AI 3',
    category: IconCategoryId.AI,
  },
  UploadCloud01: {
    icon: UploadCloud01,
    label: 'Upload Cloud 1',
    category: IconCategoryId.FILES,
  },
  User01: {
    icon: User01,
    label: 'User',
    category: IconCategoryId.USERS,
  },
  UsersPlus: {
    icon: UsersPlus,
    label: 'Users Plus',
    category: IconCategoryId.USERS,
  },
  Verif: {
    icon: Verif,
    label: 'Verified',
    category: IconCategoryId.LOGOS,
  },
  VideoRecorder: {
    icon: VideoRecorder,
    label: 'Video Recorder',
    category: IconCategoryId.MEDIA_AND_DEVICES,
  },
  VideoRecorderOff: {
    icon: VideoRecorderOff,
    label: 'Video Recorder Off',
    category: IconCategoryId.MEDIA_AND_DEVICES,
  },
  Warning: {
    icon: Warning,
    label: 'Warning',
    category: IconCategoryId.ALERTS_AND_FEEDBACK,
  },
  WaterfallChart: {
    icon: WaterfallChart,
    label: 'Waterfall Chart',
    category: IconCategoryId.CHARTS,
  },
  Webhook: {
    icon: Webhook,
    label: 'Webhook',
    category: IconCategoryId.DEVELOPMENT,
  },
  Wifi: {
    icon: Wifi,
    label: 'WiFi',
    category: IconCategoryId.MEDIA_AND_DEVICES,
  },
  WifiOff: {
    icon: WifiOff,
    label: 'WiFi Off',
    category: IconCategoryId.MEDIA_AND_DEVICES,
  },
  WordCloudChart: {
    icon: WordCloudChart,
    label: 'Word Cloud Chart',
    category: IconCategoryId.CHARTS,
  },
  XCircle: {
    icon: XCircle,
    label: 'X Circle',
    category: IconCategoryId.GENERAL,
  },
  Xls: {
    icon: Xls,
    label: 'XLS',
    category: IconCategoryId.FILES,
  },
  Xlsx: {
    icon: Xlsx,
    label: 'XLSX',
    category: IconCategoryId.FILES,
  },
  Zap: {
    icon: Zap,
    label: 'Lightning',
    category: IconCategoryId.GENERAL,
  },
  Zap01: {
    icon: Zap01,
    label: 'Lightning01',
    category: IconCategoryId.GENERAL,
  },
  ZapFast: {
    icon: ZapFast,
    label: 'Lightning Fast',
    category: IconCategoryId.GENERAL,
  },
  ZapSolid: {
    icon: ZapSolid,
    label: 'Lightning',
    category: IconCategoryId.GENERAL,
  },
};
